webpackJsonp([0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	__webpack_require__(178);
	
	__webpack_require__(179);
	
	__webpack_require__(180);
	
	__webpack_require__(181);
	
	__webpack_require__(182);
	
	__webpack_require__(183);
	
	__webpack_require__(184);
	
	__webpack_require__(185);
	
	__webpack_require__(186);
	
	__webpack_require__(187);
	
	__webpack_require__(222);
	
	__webpack_require__(223);
	
	__webpack_require__(224);
	
	__webpack_require__(225);
	
	__webpack_require__(226);
	
	__webpack_require__(227);
	
	__webpack_require__(228);
	
	__webpack_require__(229);
	
	__webpack_require__(237);
	
	__webpack_require__(238);
	
	__webpack_require__(243);
	
	__webpack_require__(245);
	
	__webpack_require__(263);
	
	__webpack_require__(264);
	
	__webpack_require__(265);
	
	__webpack_require__(266);
	
	__webpack_require__(267);
	
	__webpack_require__(268);
	
	__webpack_require__(269);
	
	__webpack_require__(270);
	
	__webpack_require__(271);
	
	__webpack_require__(272);
	
	__webpack_require__(273);
	
	__webpack_require__(274);
	
	__webpack_require__(275);
	
	__webpack_require__(276);
	
	__webpack_require__(277);
	
	__webpack_require__(278);
	
	__webpack_require__(279);
	
	__webpack_require__(280);
	
	__webpack_require__(281);
	
	__webpack_require__(282);
	
	__webpack_require__(283);
	
	__webpack_require__(284);
	
	__webpack_require__(285);
	
	__webpack_require__(286);
	
	__webpack_require__(287);
	
	__webpack_require__(288);
	
	__webpack_require__(291);
	
	__webpack_require__(292);
	
	__webpack_require__(296);
	
	__webpack_require__(297);

/***/ },

/***/ 1:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Authentication = function () {
	  /* @ngInject */
	  Authentication.$inject = ["$route", "$location", "$cookies", "$sessionStorage", "Resource", "LoginType", "GA"];
	  function Authentication($route, $location, $cookies, $sessionStorage, Resource, LoginType, GA) {
	    (0, _classCallCheck3.default)(this, Authentication);
	
	    (0, _extends3.default)(this, {
	      $route: $route,
	      $location: $location,
	      $cookies: $cookies,
	      $sessionStorage: $sessionStorage,
	      Resource: Resource,
	      LoginType: LoginType,
	      GA: GA
	    });
	
	    Authentication.$inject = ['$route', '$location', '$cookies', '$sessionStorage', 'Resource', 'LoginType', 'GA'];
	  }
	
	  (0, _createClass3.default)(Authentication, [{
	    key: 'execute',
	    value: function execute() {
	      var _this = this;
	
	      var loginPath = '/' + this.LoginType.getShorthand() + '/login';
	      if (this.$cookies.get('session_exists')) {
	        var user = this.$sessionStorage.user;
	        if (user) {
	          // $sessionStorage.userの内容は信用できないが、不正な時はリダイレクトが走るためその時まではサインイン済みだと信じる
	          // サインイン済みなら、GAのユーザー関連のカスタムディメンションを設定する
	          this.GA.setUserCustomDimensions(user);
	        } else {
	          // $sessionStorage.userが設定されていない場合は設定してリロード
	          // 失敗した場合はrestangularの方でリダイレクトされる設定になっている
	          var request = this.Resource.new().user();
	          request.get().then(function (user) {
	            _this.$sessionStorage.user = user;
	            _this.$route.reload();
	          });
	        }
	      } else {
	        // session_idがcookieにない場合、初期ユーザーとみなす
	        if (!this.$location.path().match(/\/login$/)) {
	          this.$location.path(loginPath);
	        }
	      }
	    }
	  }]);
	  return Authentication;
	}();
	
	_angular2.default.module('myApp').service('Authentication', Authentication);

/***/ },

/***/ 45:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(48);
	
	__webpack_require__(49);
	
	__webpack_require__(50);
	
	__webpack_require__(51);
	
	__webpack_require__(52);
	
	__webpack_require__(55);
	
	__webpack_require__(56);
	
	__webpack_require__(57);
	
	__webpack_require__(58);
	
	__webpack_require__(59);
	
	__webpack_require__(111);
	
	__webpack_require__(169);
	
	__webpack_require__(170);
	
	__webpack_require__(171);
	
	__webpack_require__(172);
	
	__webpack_require__(173);
	
	__webpack_require__(174);
	
	__webpack_require__(175);
	
	__webpack_require__(176);
	
	__webpack_require__(177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('myApp', ['ngRoute', 'mobile-angular-ui', 'ngAnimate', 'restangular', 'angularDc', 'angularCSS', 'ngResize', 'ui.bootstrap.datetimepicker', 'angular-carousel', 'ngCookies', 'ngStorage', 'ngTouch', 'ngResource', 'angulartics', 'angulartics.google.analytics', 'ngFileUpload']).constant('apiEndpoint', '').config(['$routeProvider', '$locationProvider', '$analyticsProvider', 'Const', function ($routeProvider, $locationProvider, $analyticsProvider, Const) {
	  /* @ngInject */
	  var requireUserInfo = {
	    userInfo: ["$q", "$location", "$sessionStorage", function userInfo($q, $location, $sessionStorage) {
	      var conditions = void 0;
	      var sessionRole = $sessionStorage[Const.LSAPP_ROLE];
	      var role = localStorage.getItem(Const.LSAPP_ROLE);
	      $sessionStorage[Const.SSAPP_FULL_SCREEN_IOS] = false;
	
	      // Cognito Credentials
	      var userId = localStorage.getItem(Const.LSKEY_USER_ID);
	      var jwtToken = localStorage.getItem(Const.LSKEY_USER_ID_TOKEN);
	      var accessKeyId = localStorage.getItem(Const.LSKEY_USER_ACCESS_KEY_ID);
	      var secretAccessKey = localStorage.getItem(Const.LSKEY_USER_SECRET_ACCESS_KEY);
	      var sessionToken = localStorage.getItem(Const.LSKEY_USER_SESSION_TOKEN);
	      var refreshToken = localStorage.getItem(Const.LSKEY_USER_REFRESH_TOKEN);
	      var accessToken = localStorage.getItem(Const.LSKEY_USER_ACCESS_TOKEN);
	      var isCredential = false;
	      if (userId && jwtToken && accessKeyId && secretAccessKey && sessionToken && refreshToken && accessToken) {
	        isCredential = true;
	      }
	      var result = void 0;
	
	      if (!sessionRole && role && isCredential) {
	        // 別タブで開かれている場合で、sessionStorageは空だが、localStorageは残っている
	        // 強制的にそれぞれのloginへ飛ばす
	        $location.path('/simple-login');
	        return $q.reject;
	      }
	
	      var isStaff = role === Const.LSAPP_ROLE_STAFF;
	      var isReception = role === Const.LSAPP_ROLE_RECEPTION;
	      var isSchoolAdmin = role === Const.LSAPP_ROLE_S_ADMIN;
	      var isCompanyAdmin = role === Const.LSAPP_ROLE_C_ADMIN;
	      var isMember = role === Const.LSAPP_ROLE_MEMBER;
	      if (!role) {
	        conditions = Const.CONDITIONS_TYPE.lackRole;
	      } else if ((isStaff || isReception) && $sessionStorage[Const.SSAPP_COACH_NAME] == null) {
	        conditions = Const.CONDITIONS_TYPE.lackStaffName;
	      } else if (isSchoolAdmin && $sessionStorage[Const.SSAPP_SCHOOL_ID] == null) {
	        conditions = Const.CONDITIONS_TYPE.lackSAdminSchoolId;
	      } else if (isCompanyAdmin && $sessionStorage[Const.SSAPP_COMPANY_ID] == null) {
	        conditions = Const.CONDITIONS_TYPE.lackCAdminCompanyId;
	      } else if (isMember && (!$sessionStorage[Const.SSAPP_USER_NAME] || $sessionStorage[Const.SSAPP_GENDER] == null)) {
	        conditions = Const.CONDITIONS_TYPE.lackMemberDetail;
	      }
	      switch (conditions) {
	        case Const.CONDITIONS_TYPE.lackRole:
	          $location.path('/member/login');
	          result = $q.reject;
	          break;
	        case Const.CONDITIONS_TYPE.lackStaffName:
	        case Const.CONDITIONS_TYPE.lackSAdminSchoolId:
	        case Const.CONDITIONS_TYPE.lackCAdminCompanyId:
	          $location.path('/staff/login');
	          result = $q.reject;
	          break;
	        case Const.CONDITIONS_TYPE.lackMemberDetail:
	          $location.path('/member/login');
	          result = $q.reject;
	          break;
	        default:
	          result = $q.resolve;
	      }
	      return result;
	    }]
	  };
	  /* @ngInject */
	  var requireTemplatePassword = {
	    userInfo: ["$q", "$location", "$sessionStorage", function userInfo($q, $location, $sessionStorage) {
	      var sessionRole = $sessionStorage[Const.LSAPP_ROLE];
	      var role = localStorage.getItem(Const.LSAPP_ROLE);
	      $sessionStorage[Const.SSAPP_FULL_SCREEN_IOS] = false;
	
	      // Cognito Credentials
	      var userId = localStorage.getItem(Const.LSKEY_USER_ID);
	      var jwtToken = localStorage.getItem(Const.LSKEY_USER_ID_TOKEN);
	      var accessKeyId = localStorage.getItem(Const.LSKEY_USER_ACCESS_KEY_ID);
	      var secretAccessKey = localStorage.getItem(Const.LSKEY_USER_SECRET_ACCESS_KEY);
	      var sessionToken = localStorage.getItem(Const.LSKEY_USER_SESSION_TOKEN);
	      var refreshToken = localStorage.getItem(Const.LSKEY_USER_REFRESH_TOKEN);
	      var accessToken = localStorage.getItem(Const.LSKEY_USER_ACCESS_TOKEN);
	      var isCredential = false;
	      if (userId && jwtToken && accessKeyId && secretAccessKey && sessionToken && refreshToken && accessToken) {
	        isCredential = true;
	      }
	      var result = void 0;
	
	      if (!sessionRole && role && isCredential) {
	        // 別タブで開かれている場合で、sessionStorageは空だが、localStorageは残っている
	        // 強制的にそれぞれのloginへ飛ばす
	        $location.path('/simple-login');
	        return $q.reject;
	      }
	      return result;
	    }]
	  };
	  $locationProvider.html5Mode(false);
	  $routeProvider.when('/simple-login', {
	    // 生徒サインイン
	    templateUrl: 'app/components/simplicity-sign-in/simplicity-sign-in.html'
	  }).when('/member/login', {
	    // 生徒サインイン
	    templateUrl: 'app/components/member-sign-in/member-sign-in.html'
	  }).when('/member', {
	    // 生徒トップ
	    templateUrl: 'app/components/member-top/member-top.html',
	    resolve: requireUserInfo
	  }).when('/member/lesson', {
	    // レッスン詳細
	    templateUrl: 'app/components/lesson-detail/lesson-detail.html',
	    resolve: requireUserInfo
	  }).when('/member/video', {
	    // レッスン動画再生
	    templateUrl: 'app/components/video/play/video-play-screen.html',
	    resolve: requireUserInfo
	  }).when('/staff/login', {
	    // スタッフサインイン
	    templateUrl: 'app/components/coach-sign-in/coach-sign-in.html'
	  }).when('/staff', {
	    // スタッフトップ
	    templateUrl: 'app/components/coach-top/coach-top.html',
	    resolve: requireUserInfo
	  }).when('/staff/school_list', {
	    // スクールリスト
	    templateUrl: 'app/components/school-list/school-list.html',
	    resolve: requireUserInfo
	  }).when('/staff/guest_video', {
	    // ゲスト動画一覧
	    templateUrl: 'app/components/guest-video/guest-video.html',
	    resolve: requireUserInfo
	  }).when('/staff/video_backlog', {
	    templateUrl: 'app/components/video-backlog/video-backlog.html',
	    resolve: requireUserInfo
	  }).when('/staff/course', {
	    // クラス詳細
	    templateUrl: 'app/components/course-detail/course-detail.html',
	    resolve: requireUserInfo
	  }).when('/staff/member_detail', {
	    // 生徒詳細
	    templateUrl: 'app/components/member-detail/member-detail.html',
	    resolve: requireUserInfo
	  }).when('/admin/school', {
	    // スクール一覧
	    templateUrl: 'app/components/admin-school-list/admin-school-list.html',
	    resolve: requireUserInfo
	  }).when('/admin', {
	    // Adminトップ
	    templateUrl: 'app/components/admin-top/admin-top.html',
	    resolve: requireUserInfo
	  }).when('/admin/coach', {
	    // Admin スタッフ一覧
	    templateUrl: 'app/components/admin-coach-list/admin-coach-list.html',
	    resolve: requireUserInfo
	  }).when('/admin/member', {
	    // Admin 生徒一覧
	    templateUrl: 'app/components/admin-member-list/admin-member-list.html',
	    resolve: requireUserInfo
	  }).when('/admin/course', {
	    // Admin コース一覧
	    templateUrl: 'app/components/admin-course-list/admin-course-list.html',
	    resolve: requireUserInfo
	  }).when('/eula', {
	    // menu: EULA/PP
	    templateUrl: 'app/components/eula/eula.html',
	    resolve: requireUserInfo
	  }).when('/password_forget', {
	    // menu: パスワード忘れ
	    templateUrl: 'app/components/password-forget/password-forget.html'
	  }).when('/password_change', {
	    // menu: パスワード変更
	    templateUrl: 'app/components/password-change/password-change.html',
	    resolve: requireTemplatePassword
	  }).when('/notification_configration', {
	    // menu: 通知設定
	    templateUrl: 'app/components/notification-configration/notification-configration.html',
	    resolve: requireUserInfo
	  }).otherwise({
	    // 生徒サインイン
	    redirectTo: '/member/login'
	  });
	  // Records pages that don't use $state or $route
	  $analyticsProvider.firstPageview(true);
	  // Records full path
	  $analyticsProvider.withAutoBase(true);
	}]).constant('Const', {
	  REGION: 'us-west-2',
	  PROD_HOST_NAME: 'smarttennislesson.jp',
	  // Dev環境用Cognito定義(member)
	  DEV_USER_COGNITO_ID_POOL_ID: 'us-west-2:3fbe2586-b368-46cf-af19-dc76b0035bd1',
	  DEV_USER_COGNITO_USER_POOL_ID: 'us-west-2_KS1Zl9yd5',
	  DEV_USER_CLIENT_ID: '7lee1qp9pkat9967t4msfdmqcp',
	  // Dev環境用Cognito定義(staff)
	  DEV_STAFF_COGNITO_ID_POOL_ID: 'us-west-2:1e66fa53-bb50-488b-a350-140a1917f623',
	  DEV_STAFF_COGNITO_USER_POOL_ID: 'us-west-2_Q52BKCSNd',
	  DEV_STAFF_CLIENT_ID: '35pi0p0km7dckqck9ds3gbu10l',
	  // Prod環境用Cognito定義(member)
	  PROD_USER_COGNITO_ID_POOL_ID: 'us-west-2:3c0249b1-0ad7-4f8a-b69c-c9060c3a09f7',
	  PROD_USER_COGNITO_USER_POOL_ID: 'us-west-2_z0AmoXg27',
	  PROD_USER_CLIENT_ID: '7iid5qllaq6bm7gre8bh047i25',
	  // Prod環境用Cognito定義(staff)
	  PROD_STAFF_COGNITO_ID_POOL_ID: 'us-west-2:0959a472-f0cc-48cf-a70f-683658587bb2',
	  PROD_STAFF_COGNITO_USER_POOL_ID: 'us-west-2_IsOeyRAEv',
	  PROD_STAFF_CLIENT_ID: 'qcaoova3gvq2lgoets7loi7ap',
	  LSKEY_USER_ID: 'userId',
	  LSKEY_USER_ID_TOKEN: 'jwtToken',
	  LSKEY_USER_ACCESS_KEY_ID: 'accessKeyId',
	  LSKEY_USER_SECRET_ACCESS_KEY: 'secretAccessKey',
	  LSKEY_USER_SESSION_TOKEN: 'sessionToken',
	  LSKEY_USER_REFRESH_TOKEN: 'refreshToken',
	  LSKEY_USER_ACCESS_TOKEN: 'accessToken',
	  LSAPP_SCHOOL_NAME: 'schoolName',
	  LSAPP_SCHOOL_ID: 'schoolId',
	  LSAPP_MEMBER_NAME: 'memberName',
	  LSAPP_MEMBER_ID: 'memberId',
	  LSAPP_DISP_MEMBER_ID: 'displayMemberId',
	  SSAPP_HAS_NETWORK_ERROR: 'hasNetworkError',
	  SSAPP_HAS_REFRESH_OK: 'RefreshOk',
	  SSAPP_HAS_REFRESH_ERROR: 'hasRefreshError',
	  SSAPP_HAS_UNEXPECTED_ERROR: 'hasUnExpectedError',
	  SSAPP_HAS_MAINTENANCE_ERROR: 'hasMaintenanceError',
	  SSAPP_USER_NAME: 'userName',
	  SSAPP_GENDER: 'gender',
	  SSAPP_IS_TMP_PASSWORD: 'isTmpPassword',
	  SSAPP_HAS_HEADER: 'hasHeader',
	  SSAPP_HAS_GRAY: 'hasGray',
	  SSAPP_COACH_NAME: 'coachName',
	  SSAPP_COACH_GENDER: 'coachGender',
	  SSAPP_COMPANY_ID: 'companyId',
	  SSAPP_SCHOOL_ID: 'schoolId',
	  SSAPP_SCHOOL_NAME: 'schoolName',
	  SSAPP_COURSE_ID: 'courseId',
	  SSAPP_MEMBER_ID: 'memberId',
	  SSAPP_LESSON_BEGIN_DATE: 'lessonBeginDate',
	  SSAPP_LESSON_END_DATE: 'lessonEndDate',
	  SSAPP_LESSON_NAME: 'lessonName',
	  SSAPP_LESSON_DATE: 'lessonDate',
	  SSAPP_LESSON_DAY: 'lessonDay',
	  SSAPP_LESSON_BEGIN_TIME: 'lessonBeginTime',
	  SSAPP_LESSON_END_TIME: 'lessonEndTime',
	  SSAPP_LESSON_COACH_NAME: 'lessonCoachName',
	  SSAPP_LESSON_SUB_COACH_NAME: 'lessonSubCoachName',
	  SSAPP_DISP_LESSON_INDEX: 'dispLessonIdx',
	  SSAPP_DISP_LESSON_LIST: 'dispLessonList',
	  SSAPP_TARGET_LESSON_INDEX: 'targetLessonIdx',
	  SSAPP_TARGET_LESSON_LIST: 'targetLessonList',
	  SSAPP_COURSE_INDEX: 'courseIdx',
	  SSAPP_COURSE_LIST: 'courseList',
	  SSAPP_SELECTED_YEAR_MONTH: 'selectedYearMonth',
	  SSAPP_EULA_AGREE: 'eulaAgree',
	  SSAPP_SENSOR_RENTAL: 'sensorRental',
	  SSAPP_SMALL_HEIGHT: 'smallHeight',
	  SSAPP_PRESIGNED_URLS: 'presignedUrls',
	  SSAPP_MIN_HEIGHT: 'minHeight',
	  SSAPP_PRIVATE_VIDEO_COMPLETE: 'privateVideoComplete',
	  SSAPP_PUBLIC_VIDEO_COMPLETE: 'publicVideoComplete',
	  SSAPP_PREVIEW_VIDEO_ON_COMPLETE: 'previewVideoOnComplete',
	  SSAPP_PREVIEW_VIDEO_OFF_COMPLETE: 'previewVideoOffComplete',
	  SSAPP_MOVE_VIDEO_TO_MEMBER_COMPLETE: 'moveVideoToMemberComplete',
	  SSAPP_MOVE_VIDEO_TO_GUEST_COMPLETE: 'moveVideoToGuestComplete',
	  SSAPP_ADMIN_COURSE_LIST_LOCATION: 'adminCourseListLocation',
	  LSAPP_ROLE: 'role',
	  LSAPP_ROLE_STAFF: 'staff',
	  LSAPP_ROLE_RECEPTION: 'reception',
	  LSAPP_ROLE_MEMBER: 'member',
	  LSAPP_ROLE_C_ADMIN: 'companyAdmin',
	  LSAPP_ROLE_S_ADMIN: 'schoolAdmin',
	  SSAPP_IS_LOADING: 'isLoading',
	  SSAPP_HEATMAP_FLG: 'heatmapFlg',
	  SSAPP_SHOT_KIND: 'shotKind',
	  SSAPP_RENDER_FIN: 'renderFin',
	  SSAPP_FULL_SCREEN_IOS: 'fullScreenIOS',
	  SSAPP_BROWSER_BACK_FORWARD: 'browserBackForward',
	  SSAPP_OLD_LOCATION: 'oldLocation',
	  SSAPP_BREAD_CRUMB_PATTERN: 'breadCrumbPattern',
	  SSAPP_VIDEO_ID: 'videoId',
	  SSAPP_VIDEO_ID_MOVE_TO_MEMBER: 'videoIdMoveToMember',
	  SSAPP_MEMBER_ID_MOVE_TO_MEMBER: 'memberIdMoveToMember',
	  SSAPP_SELECTED_DATE: 'selectedDate',
	  ROLE_COACH: 'coach',
	  CONDITIONS_TYPE: {
	    lackRole: 1,
	    lackStaffName: 2,
	    lackSAdminSchoolId: 3,
	    lackCAdminCompanyId: 4,
	    lackMemberDetail: 5
	  },
	  ERROR_TYPE: {
	    loginFailed: 0,
	    samePassword: 1,
	    prohibitionChars: 2,
	    mismatchPassword: 3,
	    pleaseInput: 4,
	    passwordPolicy: 5,
	    limit: 6,
	    clear: 7
	  },
	  SHOT_TYPE: {
	    all: 'すべてのショット',
	    foreF: 'フォアハンド スピン/フラット',
	    foreS: 'フォアハンド スライス',
	    foreV: 'フォアハンド ボレー',
	    backF: 'バックハンド スピン/フラット',
	    backS: 'バックハンド スライス',
	    backV: 'バックハンド ボレー',
	    smash: 'スマッシュ',
	    serve: 'サーブ'
	  },
	  SHOT_COLOR: {
	    all: '#000000',
	    foreF: '#ff6d1f',
	    foreS: '#cb2020',
	    foreV: '#517fb7',
	    backF: '#800000',
	    backS: '#793766',
	    backV: '#12A1cb',
	    smash: '#288666',
	    serve: '#90aa40',
	    deselected: '#b6b6b6'
	  },
	  GENDER_TYPE: {
	    male: 1,
	    female: 2
	  },
	  ADMIN_SCREEN_TYPE: {
	    schoolList: 0,
	    coachList: 1,
	    memberList: 2,
	    unknown: 99
	  },
	  EULA_AGREE_TYPE: {
	    notAgree: 0,
	    agreed: 1
	  },
	  SENSOR_RENTAL: {
	    unRegistered: 0,
	    registered: 1
	  },
	  COACH_TYPE: {
	    sub: 0,
	    main: 1
	  },
	  VIDEO_BACKLOG: {
	    preview: 'preview',
	    public: 'public'
	  },
	  VIDEO_BACKLOG_LABEL: {
	    preview: 'プレビュー待ち',
	    public: '公開待ち'
	  },
	  TITLE: {
	    staffList: 'コーチ一覧 - Admim | スマートテニスレッスン',
	    courseList: 'コース一覧 - Admim | スマートテニスレッスン',
	    courseListForStaff: 'コース一覧 - Staff | スマートテニスレッスン',
	    eula: '利用規約 | スマートテニスレッスン',
	    signInForStaff: 'サインイン - Staff | スマートテニスレッスン',
	    signIn: 'サインイン | スマートテニスレッスン',
	    schoolList: 'クラブ選択 - Staff | スマートテニスレッスン',
	    guestVideo: 'ゲスト動画一覧 - Staff | スマートテニスレッスン',
	    videoBacklog: '動画公開状況 - Staff | スマートテニスレッスン',
	    topForCompanyAdmin: 'トップ - Company Admin | スマートテニスレッスン',
	    topForSchoolAdmin: 'トップ - School Admin | スマートテニスレッスン',
	    topForStaff: 'トップ - Staff | スマートテニスレッスン',
	    top: 'トップ | スマートテニスレッスン',
	    lesson: 'レッスン詳細 | スマートテニスレッスン',
	    memberListForAdmin: '生徒一覧 - Admim | スマートテニスレッスン',
	    memberList: '生徒一覧 | スマートテニスレッスン',
	    memberDetail: '生徒詳細 | スマートテニスレッスン',
	    passForget: 'パスワードをお忘れの方 | スマートテニスレッスン',
	    passChange: 'パスワード変更 | スマートテニスレッスン',
	    notificationConfigration: '通知設定 | スマートテニスレッスン'
	  },
	  VIDEO_STATE_FLAG: {
	    uploaded: 1,
	    converted: 2,
	    publiced: 4,
	    previewed: 8
	  },
	  EXTERNAL_URL: {
	    coachingVideos: 'https://www.s-re.jp/school/tennis/coach-movie/',
	    howto: 'https://ict.sonynetwork.co.jp/sports/tennis/mykarte/stl_mykarte_howto.html'
	  },
	  ADMIN_COURSE_LIST_LOCATION: {
	    adminTop: '/admin',
	    coachTop: '/staff',
	    guestVideo: '/staff/guest_video'
	  },
	  READ_MORE_LABEL: {
	    open: '続きを読む',
	    close: '閉じる'
	  }
	});

/***/ },

/***/ 60:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 61,
		"./af.js": 61,
		"./ar": 62,
		"./ar-dz": 63,
		"./ar-dz.js": 63,
		"./ar-ly": 64,
		"./ar-ly.js": 64,
		"./ar-ma": 65,
		"./ar-ma.js": 65,
		"./ar-sa": 66,
		"./ar-sa.js": 66,
		"./ar-tn": 67,
		"./ar-tn.js": 67,
		"./ar.js": 62,
		"./az": 68,
		"./az.js": 68,
		"./be": 69,
		"./be.js": 69,
		"./bg": 70,
		"./bg.js": 70,
		"./bn": 71,
		"./bn.js": 71,
		"./bo": 72,
		"./bo.js": 72,
		"./br": 73,
		"./br.js": 73,
		"./bs": 74,
		"./bs.js": 74,
		"./ca": 75,
		"./ca.js": 75,
		"./cs": 76,
		"./cs.js": 76,
		"./cv": 77,
		"./cv.js": 77,
		"./cy": 78,
		"./cy.js": 78,
		"./da": 79,
		"./da.js": 79,
		"./de": 80,
		"./de-at": 81,
		"./de-at.js": 81,
		"./de.js": 80,
		"./dv": 82,
		"./dv.js": 82,
		"./el": 83,
		"./el.js": 83,
		"./en-au": 84,
		"./en-au.js": 84,
		"./en-ca": 85,
		"./en-ca.js": 85,
		"./en-gb": 86,
		"./en-gb.js": 86,
		"./en-ie": 87,
		"./en-ie.js": 87,
		"./en-nz": 88,
		"./en-nz.js": 88,
		"./eo": 89,
		"./eo.js": 89,
		"./es": 90,
		"./es-do": 91,
		"./es-do.js": 91,
		"./es.js": 90,
		"./et": 92,
		"./et.js": 92,
		"./eu": 93,
		"./eu.js": 93,
		"./fa": 94,
		"./fa.js": 94,
		"./fi": 95,
		"./fi.js": 95,
		"./fo": 96,
		"./fo.js": 96,
		"./fr": 97,
		"./fr-ca": 98,
		"./fr-ca.js": 98,
		"./fr-ch": 99,
		"./fr-ch.js": 99,
		"./fr.js": 97,
		"./fy": 100,
		"./fy.js": 100,
		"./gd": 101,
		"./gd.js": 101,
		"./gl": 102,
		"./gl.js": 102,
		"./he": 103,
		"./he.js": 103,
		"./hi": 104,
		"./hi.js": 104,
		"./hr": 105,
		"./hr.js": 105,
		"./hu": 106,
		"./hu.js": 106,
		"./hy-am": 107,
		"./hy-am.js": 107,
		"./id": 108,
		"./id.js": 108,
		"./is": 109,
		"./is.js": 109,
		"./it": 110,
		"./it.js": 110,
		"./ja": 111,
		"./ja.js": 111,
		"./jv": 112,
		"./jv.js": 112,
		"./ka": 113,
		"./ka.js": 113,
		"./kk": 114,
		"./kk.js": 114,
		"./km": 115,
		"./km.js": 115,
		"./ko": 116,
		"./ko.js": 116,
		"./ky": 117,
		"./ky.js": 117,
		"./lb": 118,
		"./lb.js": 118,
		"./lo": 119,
		"./lo.js": 119,
		"./lt": 120,
		"./lt.js": 120,
		"./lv": 121,
		"./lv.js": 121,
		"./me": 122,
		"./me.js": 122,
		"./mi": 123,
		"./mi.js": 123,
		"./mk": 124,
		"./mk.js": 124,
		"./ml": 125,
		"./ml.js": 125,
		"./mr": 126,
		"./mr.js": 126,
		"./ms": 127,
		"./ms-my": 128,
		"./ms-my.js": 128,
		"./ms.js": 127,
		"./my": 129,
		"./my.js": 129,
		"./nb": 130,
		"./nb.js": 130,
		"./ne": 131,
		"./ne.js": 131,
		"./nl": 132,
		"./nl-be": 133,
		"./nl-be.js": 133,
		"./nl.js": 132,
		"./nn": 134,
		"./nn.js": 134,
		"./pa-in": 135,
		"./pa-in.js": 135,
		"./pl": 136,
		"./pl.js": 136,
		"./pt": 137,
		"./pt-br": 138,
		"./pt-br.js": 138,
		"./pt.js": 137,
		"./ro": 139,
		"./ro.js": 139,
		"./ru": 140,
		"./ru.js": 140,
		"./se": 141,
		"./se.js": 141,
		"./si": 142,
		"./si.js": 142,
		"./sk": 143,
		"./sk.js": 143,
		"./sl": 144,
		"./sl.js": 144,
		"./sq": 145,
		"./sq.js": 145,
		"./sr": 146,
		"./sr-cyrl": 147,
		"./sr-cyrl.js": 147,
		"./sr.js": 146,
		"./ss": 148,
		"./ss.js": 148,
		"./sv": 149,
		"./sv.js": 149,
		"./sw": 150,
		"./sw.js": 150,
		"./ta": 151,
		"./ta.js": 151,
		"./te": 152,
		"./te.js": 152,
		"./tet": 153,
		"./tet.js": 153,
		"./th": 154,
		"./th.js": 154,
		"./tl-ph": 155,
		"./tl-ph.js": 155,
		"./tlh": 156,
		"./tlh.js": 156,
		"./tr": 157,
		"./tr.js": 157,
		"./tzl": 158,
		"./tzl.js": 158,
		"./tzm": 159,
		"./tzm-latn": 160,
		"./tzm-latn.js": 160,
		"./tzm.js": 159,
		"./uk": 161,
		"./uk.js": 161,
		"./uz": 162,
		"./uz.js": 162,
		"./vi": 163,
		"./vi.js": 163,
		"./x-pseudo": 164,
		"./x-pseudo.js": 164,
		"./yo": 165,
		"./yo.js": 165,
		"./zh-cn": 166,
		"./zh-cn.js": 166,
		"./zh-hk": 167,
		"./zh-hk.js": 167,
		"./zh-tw": 168,
		"./zh-tw.js": 168
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 60;


/***/ },

/***/ 174:
/***/ function(module, exports) {

	'use strict';
	
	/*globals angular */
	
	/**
	 * アイコンにGlyphiconではなくFont Awesomeを利用したかった為、
	 * 下記を参考にオーバーライドした。
	 *
	 * https://github.com/dalelotts/angular-bootstrap-datetimepicker#upgrading-from-040-or-earlier
	 */
	
	/**
	 * @license angular-bootstrap-datetimepicker  version: 0.4.0
	 * Copyright 2016 Knight Rider Consulting, Inc. http://www.knightrider.com
	 * License: MIT
	 *
	 * @author        Dale "Ducky" Lotts
	 * @since        2016-Jan-31
	 */
	
	(function () {
	  'use strict';
	
	  angular.module('ui.bootstrap.datetimepicker').run(['$templateCache', function ($templateCache) {
	    $templateCache.put('templates/datetimepicker.html', '<div class="datetimepicker table-responsive">\n    <table class="table table-condensed {{ data.currentView }}-view">\n        <thead>\n        <tr>\n            <th class="left" data-ng-click="changeView(data.currentView, data.leftDate, $event)" data-ng-show="data.leftDate.selectable"><i class="fa fa-arrow-left"><span class="sr-only">{{ screenReader.previous }}</span></i>\n            </th>\n            <th class="switch" colspan="5" data-ng-show="data.previousViewDate.selectable" data-ng-click="changeView(data.previousView, data.previousViewDate, $event)">{{ data.previousViewDate.display }}</th>\n            <th class="right" data-ng-click="changeView(data.currentView, data.rightDate, $event)" data-ng-show="data.rightDate.selectable"><i class="fa fa-arrow-right"><span class="sr-only">{{ screenReader.next }}</span></i>\n            </th>\n        </tr>\n        <tr>\n            <th class="dow" data-ng-repeat="day in data.dayNames">{{ day }}</th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr data-ng-if="data.currentView !== \'day\'">\n            <td colspan="7">\n                          <span class="{{ data.currentView }}" data-ng-repeat="dateObject in data.dates" data-ng-class="{active: dateObject.active, past: dateObject.past, future: dateObject.future, disabled: !dateObject.selectable}" data-ng-click="changeView(data.nextView, dateObject, $event)">{{ dateObject.display }}</span></td>\n        </tr>\n        <tr data-ng-if="data.currentView === \'day\'" data-ng-repeat="week in data.weeks">\n            <td data-ng-repeat="dateObject in week.dates" data-ng-click="changeView(data.nextView, dateObject, $event)" class="day" data-ng-class="{active: dateObject.active, past: dateObject.past, future: dateObject.future, disabled: !dateObject.selectable}">{{ dateObject.display }}</td>\n        </tr>\n        </tbody>\n    </table>\n</div>');
	  }]);
	})();

/***/ },

/***/ 178:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BeforeAction = function () {
	  /* @ngInject */
	  BeforeAction.$inject = ["$rootScope"];
	  function BeforeAction($rootScope) {
	    (0, _classCallCheck3.default)(this, BeforeAction);
	
	    this.$rootScope = $rootScope;
	
	    BeforeAction.$inject = ['$rootScope'];
	  }
	
	  (0, _createClass3.default)(BeforeAction, [{
	    key: 'register',
	    value: function register(action) {
	      this.$rootScope.$on('$routeChangeStart', function (event, next, current) {
	        action.execute(event, next, current);
	      });
	    }
	  }]);
	  return BeforeAction;
	}();
	
	_angular2.default.module('myApp').service('BeforeAction', BeforeAction);

/***/ },

/***/ 179:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('myApp').factory('ConfiguredRestangular', ['Restangular', '$location', '$window', '$sessionStorage', '$timeout', 'LoginType', function (Restangular, $location, $window, $sessionStorage, $timeout, LoginType) {
	  /* @ngInject */
	  return Restangular.withConfig(function (RestangularConfigurer) {
	    // リクエストが成功した場合の共通処理
	    RestangularConfigurer.addResponseInterceptor(function (data, operation, what, url, response, deferred) {
	      // 各種Flashメッセージのフラグをリセット
	      resetErrorMessageFlag('hasSessionError');
	      resetErrorMessageFlag('hasTokenError');
	      resetErrorMessageFlag('hasPermissionError', 3000);
	      return data;
	    });
	
	    // リクエストがエラーになった場合の共通処理
	    RestangularConfigurer.setErrorInterceptor(function (resp, deferred, handler) {
	      // サーバから401(Unauthorized)が返ってきた場合
	      if (resp.status === 401) {
	        // サインインの試行失敗だった場合は何もしない
	        if (resp.config.url === '/api/v1/sign-in') {
	          return;
	        }
	        // エラーメッセージは認証が必要なページでのみ出す（本当はもっとうまいやり方でやりたい）
	        var path = $location.path();
	        if (!path.match(/\/login$/) && path.match(/^\/[pc]\//)) {
	          // エラーメッセージを5秒間表示
	          flashErrorMessageFlag('hasSessionError', 5000);
	        }
	        // $sessionStorage内のユーザ情報をクリア。
	        $sessionStorage.user = null;
	        // ユーザタイプ毎のサインインページへリダイレクト
	        $location.path('/' + LoginType.getShorthand() + '/login');
	
	        // サーバから403(Permission Denied)が返ってきた場合
	      } else if (resp.status === 403) {
	        // エラーメッセージを5秒間表示
	        flashErrorMessageFlag('hasPermissionError', 5000);
	        // 前のページに戻る
	        // TODO: もしこの実装により問題があった場合は
	        //        サインインページへのリダイレクト等で代替する。
	        $window.history.back();
	
	        // サーバから422(InvalidAuthenticityToken)が返ってきた場合
	      } else if (resp.status === 422) {
	        // Tokenを取り直す
	        var request = Restangular.one('token');
	        request.get().then(function () {
	          // エラーメッセージを3秒間表示
	          flashErrorMessageFlag('hasTokenError', 3000);
	        });
	      }
	    });
	  });
	
	  // 指定されたフラッシュメッセージ用のフラグをfalseに設定する。
	  function resetErrorMessageFlag(flagName, msec) {
	    msec = msec || 0;
	    $timeout(function () {
	      $sessionStorage[flagName] = false;
	    }, msec);
	  }
	
	  // 指定されたフラッシュメッセージ用のフラグを指定ミリ秒の間だけtrueにする。
	  function flashErrorMessageFlag(flagName, msec) {
	    $sessionStorage[flagName] = true;
	    $timeout(function () {
	      $sessionStorage[flagName] = false;
	    }, msec);
	  }
	}]);

/***/ },

/***/ 180:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmAction = function () {
	  /* @ngInject */
	  ConfirmAction.$inject = ["Resource", "$sessionStorage", "$window"];
	  function ConfirmAction(Resource, $sessionStorage, $window) {
	    (0, _classCallCheck3.default)(this, ConfirmAction);
	
	    this.Resource = Resource;
	    this.$sessionStorage = $sessionStorage;
	    this.$window = $window;
	    this.errorMsg = '保存されていない項目があります。\n 移動してもよろしいですか？';
	
	    ConfirmAction.$inject = ['Resource', '$sessionStorage', '$window'];
	  }
	
	  // Confirmを出力：キャンセル => False , OK => True
	  // Confirmを出力しない：True
	
	
	  (0, _createClass3.default)(ConfirmAction, [{
	    key: 'confirm',
	    value: function confirm(e) {
	      e = e || null;
	      // 編集中フラグ = OFF または Confirm = OK
	      if (!this.$sessionStorage.editStatus || this.$window.confirm(this.errorMsg)) {
	        this.$sessionStorage.editStatus = false;
	        return true;
	      }
	      if (e) {
	        e.preventDefault();
	      }
	      return false;
	    }
	  }]);
	  return ConfirmAction;
	}();
	
	_angular2.default.module('myApp').service('ConfirmAction', ConfirmAction);

/***/ },

/***/ 181:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _moment = __webpack_require__(59);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import ga from './services/ga.es6';
	/*global
	ga
	*/
	
	var GA = function () {
	  /* @ngInject */
	  GA.$inject = ["$analytics"];
	  function GA($analytics) {
	    (0, _classCallCheck3.default)(this, GA);
	
	    this.$analytics = $analytics;
	
	    GA.$inject = ['$analytics'];
	  }
	
	  (0, _createClass3.default)(GA, [{
	    key: 'pageTrack',
	    value: function pageTrack(path) {
	      this.$analytics.pageTrack(path);
	    }
	  }, {
	    key: 'eventTrack',
	    value: function eventTrack(eventAction) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var eventOptions = {};
	
	      // カスタムディメンションを設定
	      eventOptions.dimension4 = (0, _moment2.default)().format('YYYY-MM-DD');
	      if (options.user) {
	        var user = options.user;
	
	        (0, _extends3.default)(eventOptions, { dimension1: user.id, dimension6: user.type });
	      }
	      if (options.lessonId) {
	        eventOptions.dimension3 = options.lessonId;
	      }
	      if (options.video) {
	        var video = options.video;
	
	        (0, _extends3.default)(eventOptions, { dimension2: video.id, dimension5: video.tag });
	      }
	
	      this.$analytics.eventTrack(eventAction, eventOptions);
	    }
	  }, {
	    key: 'setUserCustomDimensions',
	    value: function setUserCustomDimensions(user) {
	      ga('set', 'dimension1', user.id);
	      ga('set', 'dimension6', user.type);
	    }
	  }]);
	  return GA;
	}();
	
	_angular2.default.module('myApp').service('GA', GA);

/***/ },

/***/ 182:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function create() {
	  var array = [[1, 5], [1, 4], [1, 3], [1, 2], [2, 6], [2, 5], [2, 4], [2, 3], [2, 2], [2, 1], [3, 6], [3, 5], [3, 4], [3, 3], [3, 2], [3, 1], [4, 6], [4, 5], [4, 4], [4, 3], [4, 2], [4, 1], [5, 5], [5, 4], [5, 3], [5, 2]];
	
	  return array;
	}
	
	_angular2.default.module('myApp').factory('ImpactPointConstants', create);

/***/ },

/***/ 183:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginType = function () {
	  /* @ngInject */
	  LoginType.$inject = ["$location"];
	  function LoginType($location) {
	    (0, _classCallCheck3.default)(this, LoginType);
	
	    this.$location = $location;
	
	    LoginType.$inject = ['$location'];
	  }
	
	  (0, _createClass3.default)(LoginType, [{
	    key: 'get',
	    value: function get() {
	      return this.$location.path().match('/c/') ? 'coach' : 'player';
	    }
	  }, {
	    key: 'getShorthand',
	    value: function getShorthand() {
	      return this.get().charAt(0);
	    }
	  }]);
	  return LoginType;
	}();
	
	_angular2.default.module('myApp').service('LoginType', LoginType);

/***/ },

/***/ 184:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResourceBuilder = function () {
	  function ResourceBuilder(ConfiguredRestangular) {
	    (0, _classCallCheck3.default)(this, ResourceBuilder);
	
	    this.Restangular = ConfiguredRestangular;
	    this.current = this.Restangular;
	
	    ResourceBuilder.$inject = ['ConfiguredRestangular'];
	  }
	
	  (0, _createClass3.default)(ResourceBuilder, [{
	    key: 'players',
	    value: function players() {
	      this.current = this.current.all('players');
	      return this;
	    }
	  }, {
	    key: 'player',
	    value: function player(playerId) {
	      this.current = this.current.one('players', playerId);
	      return this;
	    }
	  }, {
	    key: 'postPlayer',
	    value: function postPlayer(params) {
	      this.current = this.current.all('players').post(params);
	      return this;
	    }
	  }, {
	    key: 'coaches',
	    value: function coaches() {
	      this.current = this.current.all('coaches');
	      return this;
	    }
	  }, {
	    key: 'coach',
	    value: function coach(coachId) {
	      this.current = this.current.one('coaches', coachId);
	      return this;
	    }
	  }, {
	    key: 'profile',
	    value: function profile() {
	      this.current = this.current.one('profile');
	      return this;
	    }
	  }, {
	    key: 'schools',
	    value: function schools() {
	      this.current = this.current.all('schools');
	      return this;
	    }
	  }, {
	    key: 'school',
	    value: function school(schoolId) {
	      this.current = this.current.one('schools', schoolId);
	      return this;
	    }
	  }, {
	    key: 'groups',
	    value: function groups() {
	      this.current = this.current.all('groups');
	      return this;
	    }
	  }, {
	    key: 'group',
	    value: function group(groupId) {
	      this.current = this.current.one('groups', groupId);
	      return this;
	    }
	  }, {
	    key: 'signupLinks',
	    value: function signupLinks() {
	      this.current = this.current.all('signup-links');
	      return this;
	    }
	  }, {
	    key: 'shots',
	    value: function shots() {
	      this.current = this.current.all('shots');
	      return this;
	    }
	  }, {
	    key: 'summary',
	    value: function summary() {
	      this.current = this.current.all('summary');
	      return this;
	    }
	  }, {
	    key: 'companies',
	    value: function companies() {
	      this.current = this.current.all('companies');
	      return this;
	    }
	  }, {
	    key: 'company',
	    value: function company(companyId) {
	      this.current = this.current.one('companies', companyId);
	      return this;
	    }
	  }, {
	    key: 'videos',
	    value: function videos() {
	      this.current = this.current.all('videos');
	      return this;
	    }
	  }, {
	    key: 'video',
	    value: function video(videoId) {
	      this.current = this.current.one('videos', videoId);
	      return this;
	    }
	  }, {
	    key: 'postingUrl',
	    value: function postingUrl(tag) {
	      this.current = this.current.one('posting-url', tag);
	      return this;
	    }
	  }, {
	    key: 'order',
	    value: function order() {
	      this.current = this.current.one('order');
	      return this;
	    }
	  }, {
	    key: 'comments',
	    value: function comments(type) {
	      if (type !== 'player' && type !== 'coach') {
	        throw new TypeError('Unexpected user type.');
	      }
	      this.current = this.current.one('comments', type);
	      return this;
	    }
	  }, {
	    key: 'comment',
	    value: function comment(commentId) {
	      this.current = this.current.one('comments', commentId);
	      return this;
	    }
	  }, {
	    key: 'postComment',
	    value: function postComment(params) {
	      this.current = this.current.all('comments').post(params);
	      return this;
	    }
	  }, {
	    key: 'user',
	    value: function user() {
	      this.current = this.current.one('user');
	      return this;
	    }
	  }, {
	    key: 'signOut',
	    value: function signOut() {
	      this.current = this.current.one('sign-out');
	      return this;
	    }
	  }, {
	    key: 'videoDelete',
	    value: function videoDelete() {
	      this.current = this.current.one('delete-video');
	      return this;
	    }
	  }, {
	    key: 'token',
	    value: function token() {
	      this.current = this.current.one('token');
	      return this;
	    }
	  }, {
	    key: 'videoMoveToGuest',
	    value: function videoMoveToGuest() {
	      this.current = this.current.one('move-video-to-guest');
	      return this;
	    }
	  }, {
	    key: 'generatePassword',
	    value: function generatePassword() {
	      this.current = this.current.one('generate-password');
	      return this;
	    }
	  }, {
	    key: 'sessions',
	    value: function sessions() {
	      this.current = this.current.all('sessions');
	      return this;
	    }
	  }, {
	    key: 'signIn',
	    value: function signIn() {
	      this.current = this.current.all('sign-in');
	      return this;
	    }
	  }, {
	    key: 'get',
	    value: function get(arg) {
	      var result = this.current.get(arg);
	      this.current = this.Restangular;
	      return result;
	    }
	  }, {
	    key: 'getList',
	    value: function getList(arg) {
	      var result = this.current.getList(arg);
	      this.current = this.Restangular;
	      return result;
	    }
	  }, {
	    key: 'getObject',
	    value: function getObject(arg) {
	      return this.get(arg).$object;
	    }
	  }, {
	    key: 'getListObject',
	    value: function getListObject(arg) {
	      return this.getList(arg).$object;
	    }
	  }, {
	    key: 'post',
	    value: function post(arg) {
	      return this.current.post(arg);
	    }
	  }, {
	    key: 'put',
	    value: function put(arg) {
	      return this.current.put(arg);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(arg) {
	      return this.current.remove(arg);
	    }
	  }, {
	    key: 'restangular',
	    get: function get() {
	      return this.Restangular;
	    }
	  }, {
	    key: 'currentRestangular',
	    get: function get() {
	      return this.current;
	    }
	  }]);
	  return ResourceBuilder;
	}();
	
	var Resource = function () {
	  /* @ngInject */
	  Resource.$inject = ["ConfiguredRestangular"];
	  function Resource(ConfiguredRestangular) {
	    (0, _classCallCheck3.default)(this, Resource);
	
	    this.Restangular = ConfiguredRestangular;
	  }
	
	  (0, _createClass3.default)(Resource, [{
	    key: 'new',
	    value: function _new() {
	      return new ResourceBuilder(this.Restangular);
	    }
	  }]);
	  return Resource;
	}();
	
	_angular2.default.module('myApp').service('Resource', Resource);

/***/ },

/***/ 185:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SharedState = function () {
	  /* @ngInject */
	  function SharedState() {
	    (0, _classCallCheck3.default)(this, SharedState);
	
	    this._title = 'Coaching system';
	    // TODO: Companyにロゴの情報を入れるようにしておき、
	    // それをセットするようにしたい。
	    this._logo = 'renaissance-logo.png';
	  }
	
	  (0, _createClass3.default)(SharedState, [{
	    key: 'title',
	    get: function get() {
	      return this._title;
	    },
	    set: function set(_title) {
	      this._title = _title;
	    }
	  }, {
	    key: 'logo',
	    get: function get() {
	      return this._logo;
	    },
	    set: function set(_title) {
	      this._logo = this._logo;
	    }
	  }, {
	    key: 'graphPromise',
	    get: function get() {
	      return this._graphPromise;
	    },
	    set: function set(p) {
	      this._graphPromise = p;
	    }
	  }]);
	  return SharedState;
	}();
	
	_angular2.default.module('myApp').service('sssSharedState', SharedState);

/***/ },

/***/ 186:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createSwingTypeConstants() {
	  var t = [{
	    id: 0,
	    orderId: 0,
	    label: 'フォアハンド スピン/フラット',
	    color: '#ff6d1f'
	  }, {
	    id: 1,
	    orderId: 1,
	    label: 'フォアハンド スライス',
	    color: '#cb2020'
	  }, {
	    id: 2,
	    orderId: 4,
	    label: 'フォアハンド ボレー',
	    color: '#517fb7'
	  }, {
	    id: 3,
	    orderId: 2,
	    label: 'バックハンド スピン/フラット',
	    color: '#800000'
	    /* }, {
	      // id:4 は id:3 のBackhand spin/flatと同じものを指す模様なので、
	      // SwingTypeとしてはid:4は欠番、Arrayの添字は繰り上げる
	      // Backhand Spin/FlatDのDはDouble Handを表す
	      id: 4,
	      label: 'Backhand Spin/FlatD',
	      color: '#793766'
	    */
	  }, {
	    id: 5,
	    orderId: 3,
	    label: 'バックハンド スライス',
	    color: '#793766'
	  }, {
	    id: 6,
	    orderId: 6,
	    label: 'バックハンド ボレー',
	    color: '#12a1cb'
	  }, {
	    id: 7,
	    orderId: 7,
	    label: 'スマッシュ',
	    color: '#288666'
	  }, {
	    id: 8,
	    orderId: 8,
	    label: 'サーブ',
	    color: '#90aa40'
	  }];
	
	  t._swingTypeRevMap = {};
	  t.forEach(function (st) {
	    t._swingTypeRevMap[st.label] = st;
	  });
	
	  t.get = function (id) {
	    var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    return t[id] || def;
	  };
	  t.getLabel = function (id) {
	    var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : id;
	
	    // workaround for duplicated type id:3
	    if (id > 3) id--;
	    var o = t[id];
	    if (!o) {
	      return def;
	    }
	    return o.label;
	  };
	  t.getByLabel = function (label) {
	    var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    return t._swingTypeRevMap[label] || def;
	  };
	  t.getOrderIdByLabel = function (label) {
	    var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : label;
	
	    var o = t.getByLabel(label);
	    if (!o) {
	      return def;
	    }
	    return o.orderId;
	  };
	  t.getColorByLabel = function (label) {
	    var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    var o = t.getByLabel(label);
	    if (!o) {
	      return def;
	    }
	    return o.color;
	  };
	
	  return t;
	}
	
	_angular2.default.module('myApp').factory('SwingTypeConstants', createSwingTypeConstants);

/***/ },

/***/ 187:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(188);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*global MP4Box*/
	var VideoParser = function () {
	  /* @ngInject */
	  function VideoParser() {
	    (0, _classCallCheck3.default)(this, VideoParser);
	
	    this.mp4box = '';
	    this.videoInfo = '';
	  }
	
	  (0, _createClass3.default)(VideoParser, [{
	    key: 'initMP4Box',
	    value: function initMP4Box() {
	      console.log('init mp4');
	      var mp4box = new MP4Box();
	      mp4box.onReady = function (info) {
	        console.log('###mp4box onReady###');
	      };
	      mp4box.onError = function (e) {
	        console.log('###mp4box failed to parse data.###');
	      };
	      mp4box.onMoovStart = function (info) {
	        console.log('###mp4box onMoovStart###');
	      };
	      return mp4box;
	    }
	  }, {
	    key: 'setDataToMP4Box',
	    value: function setDataToMP4Box(file) {
	      var _this = this;
	
	      this.mp4box = this.initMP4Box();
	      return new _promise2.default(function (resolve, reject) {
	        var fileReader = new FileReader();
	        // TODO: クラスのメソッドにしてしまうとthisが変わる
	        var onBlockRead = function onBlockRead(event) {
	          var buffer = event.target.result;
	          buffer.fileStart = 0;
	          _this.mp4box.appendBuffer(buffer);
	          _this.mp4box.flush();
	          _this.videoInfo = _this.mp4box.getInfo();
	          resolve();
	        };
	        fileReader.onload = onBlockRead;
	        fileReader.readAsArrayBuffer(file);
	      });
	    }
	  }, {
	    key: 'getVideoInfo',
	    value: function getVideoInfo() {
	      return this.videoInfo;
	    }
	  }, {
	    key: 'getEndUnixTime',
	    value: function getEndUnixTime() {
	      var duration = this.videoInfo.duration / this.videoInfo.timescale * 1000;
	      var startTime = this.getStartUnixTime() + duration;
	      return startTime;
	    }
	  }, {
	    key: 'getStartUnixTime',
	    value: function getStartUnixTime() {
	      var ct = this.mp4box.inputIsoFile.moov.boxes[0].creation_time;
	      var dt = Date.UTC(1904, 0, 1, 0, 0, 0);
	      var creationTime = ct * 1000 + dt;
	      return creationTime;
	    }
	  }, {
	    key: 'getResolution',
	    value: function getResolution() {
	      return this.videoInfo.videoTracks[0].track_height + 'p';
	    }
	  }]);
	  return VideoParser;
	}();
	
	_angular2.default.module('myApp').service('videoParser', VideoParser);

/***/ },

/***/ 222:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMPONENT_NAME = 'breadCrumb';
	var REPLACE_MEMBER_NAME = '__REPLACE_MEMBER_NAME__';
	var REPLACE_SCHOOL_NAME = '__REPLACE_SCHOOL_NAME__';
	var BREADCRUMB_CONFIG_FILE = './config/breadcrumbs-config.json';
	
	var BreadCrumb = function () {
	  /* @ngInject */
	  BreadCrumb.$inject = ["$sessionStorage", "$element", "$http", "Const"];
	  function BreadCrumb($sessionStorage, $element, $http, Const) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, BreadCrumb);
	
	    this.Const = Const;
	    this.$sessionStorage = $sessionStorage;
	    var controller = $element[0].attributes.controller.value;
	    var jsonFilePath = BREADCRUMB_CONFIG_FILE;
	    $http.get(jsonFilePath).success(function (datas) {
	      _this.breadcrumbs = [];
	      datas.forEach(function (data) {
	        if (controller === data.controllerName) {
	          data.breadcrumbs.forEach(function (breadcrumb) {
	            _this.setBreadcrumb(breadcrumb);
	          });
	        }
	      });
	    });
	
	    BreadCrumb.$inject = ['$sessionStorage', '$element', '$http', 'Const'];
	  }
	
	  (0, _createClass3.default)(BreadCrumb, [{
	    key: 'setBreadcrumb',
	    value: function setBreadcrumb(breadcrumb) {
	      if (this.isContainsName(breadcrumb)) {
	        breadcrumb = this.replaceParam(breadcrumb);
	      }
	      this.breadcrumbs.push(breadcrumb);
	    }
	  }, {
	    key: 'replaceParam',
	    value: function replaceParam(breadcrumb) {
	      breadcrumb.viewName = breadcrumb.viewName.replace(REPLACE_MEMBER_NAME, this.$sessionStorage[this.Const.SSAPP_USER_NAME]);
	      breadcrumb.viewName = breadcrumb.viewName.replace(REPLACE_SCHOOL_NAME, this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME]);
	      return breadcrumb;
	    }
	  }, {
	    key: 'isContainsName',
	    value: function isContainsName(breadcrumb) {
	      return breadcrumb.viewName.match(REPLACE_MEMBER_NAME) || breadcrumb.viewName.match(REPLACE_SCHOOL_NAME);
	    }
	  }]);
	  return BreadCrumb;
	}();
	
	_angular2.default.module('myApp').component(COMPONENT_NAME, {
	  bindings: {
	    name: '@' + COMPONENT_NAME
	  },
	  controller: BreadCrumb,
	  // TODO : webpack対応でhtmlをimportするよう修正する
	  templateUrl: 'app/components/templates/bread-crumb.template.html'
	});

/***/ },

/***/ 223:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _moment = __webpack_require__(59);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMPONENT_NAME = 'sssDatePicker'; /*global sessionStorage*/
	
	var DatePicker = function () {
	
	  /* @ngInject */
	  DatePicker.$inject = ["$scope", "$element", "$attrs", "$filter", "SharedState", "$location"];
	  function DatePicker($scope, $element, $attrs, $filter, SharedState, $location) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, DatePicker);
	
	    this.$scope = $scope;
	    this.$elm = $element;
	    this.$attrs = $attrs;
	    this.dateFormatter = $filter('date');
	    this.sharedState = SharedState;
	    this.playReportController = $scope.$parent.report;
	    $scope.renderOnBeforeRender = renderOnBeforeRender;
	    this.modes = [{ value: 'day', label: '日' }, { value: 'week', label: '週' }, { value: 'month', label: '月' }];
	    this.modes.forEach(function (m) {
	      _this.modes[m.value] = m;
	    });
	    _moment2.default.locale('ja');
	
	    // directive自身にclassを追加する
	    $element.addClass('btn-group');
	
	    var msec = parseInt(sessionStorage.getItem('date'), 10) || null;
	    var defDate = msec ? new Date(msec) : new Date();
	
	    if ($location.path().match('/report') && $location.path().match('/report').length > 0) {
	      var range = $location.path().split('/report/');
	      var modeRange = sessionStorage.getItem('dateMode') || 'day';
	      switch (range[1]) {
	        case 'day':
	          modeRange = 'day';break;
	        case 'week':
	          modeRange = 'week';break;
	        case 'month':
	          modeRange = 'month';break;
	        case 'year':
	          modeRange = 'month';break;
	      }
	      this.sharedState.initialize(this.$scope, 'dateMode', {
	        defaultValue: modeRange
	      });
	      this.playReportController.getLatestGroupStartDate().then(function (date) {
	        _this.sharedState.initialize(_this.$scope, 'date', {
	          defaultValue: new Date((0, _moment2.default)(date).valueOf())
	        });
	      });
	
	      if (modeRange === 'month') {
	        this.$scope.config = {
	          configureOnConfig: {
	            startView: 'month',
	            minView: 'month',
	            configureOn: 'config-changed'
	          }
	        };
	      } else {
	        this.$scope.config = {
	          configureOnConfig: {
	            startView: 'day',
	            minView: 'day',
	            configureOn: 'config-changed'
	          }
	        };
	      }
	      sessionStorage.setItem('dateMode', modeRange);
	    } else {
	      this.sharedState.initialize(this.$scope, 'dateMode', {
	        defaultValue: sessionStorage.getItem('dateMode') || 'day'
	      });
	      this.sharedState.initialize(this.$scope, 'date', {
	        defaultValue: defDate
	      });
	
	      if (sessionStorage.getItem('dateMode') && sessionStorage.getItem('dateMode') === 'month') {
	        this.$scope.config = {
	          configureOnConfig: {
	            startView: 'month',
	            minView: 'month',
	            configureOn: 'config-changed'
	          }
	        };
	      } else {
	        this.$scope.config = {
	          configureOnConfig: {
	            startView: 'day',
	            minView: 'day',
	            configureOn: 'config-changed'
	          }
	        };
	      }
	    }
	
	    $scope.$on('mobile-angular-ui.state.changed.dateMode', function (e, newVal, oldVal) {
	      sessionStorage.setItem('dateMode', newVal);
	      if (newVal === 'month') {
	        _this.$scope.config.configureOnConfig.startView = 'month';
	        _this.$scope.config.configureOnConfig.minView = 'month';
	        _this.$scope.$broadcast('config-changed');
	      } else {
	        _this.$scope.config.configureOnConfig.startView = 'day';
	        _this.$scope.config.configureOnConfig.minView = 'day';
	        _this.$scope.$broadcast('config-changed');
	      }
	    });
	
	    $scope.$on('mobile-angular-ui.state.changed.date', function (e, newVal, oldVal) {
	      if (newVal) {
	        sessionStorage.setItem('date', newVal.getTime());
	      }
	    });
	
	    DatePicker.$inject = ['$scope', '$element', '$attrs', '$filter', 'SharedState', '$location'];
	  }
	
	  (0, _createClass3.default)(DatePicker, [{
	    key: 'next',
	    value: function next() {
	      this.move(+1);
	    }
	  }, {
	    key: 'prev',
	    value: function prev() {
	      this.move(-1);
	    }
	  }, {
	    key: 'move',
	    value: function move(val) {
	      var key = this.sharedState.get('dateMode');
	      this.date = (0, _moment2.default)(this.date).add(val, key + 's').toDate();
	    }
	  }, {
	    key: 'dateString',
	    value: function dateString() {
	      switch (this.sharedState.get('dateMode')) {
	        case 'day':
	          return this.dateFormatter(this.date, 'yyyy/MM/dd');
	        case 'month':
	          return this.dateFormatter(this.date, 'yyyy/MM');
	        case 'week':
	          {
	            var start = (0, _moment2.default)(this.date).day(0).toDate();
	            var end = (0, _moment2.default)(this.date).day(6).toDate();
	            return this.dateFormatter(start, 'yyyy/MM/dd') + ' - ' + this.dateFormatter(end, 'MM/dd');
	          }
	      }
	      return this.date;
	    }
	  }, {
	    key: 'modeString',
	    value: function modeString() {
	      var mode = this.sharedState.get('dateMode');
	      return this.modes[mode].label;
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      // do something
	    }
	  }, {
	    key: 'date',
	    get: function get() {
	      return this.sharedState.get('date');
	    },
	    set: function set(val) {
	      if (val) this.sharedState.set('date', val);
	    }
	  }]);
	  return DatePicker;
	}();
	
	function renderOnBeforeRender($dates) {
	  if (sessionStorage.getItem('dateMode') && sessionStorage.getItem('dateMode') === 'week') {
	    var msec = parseInt(sessionStorage.getItem('date'), 10) || null;
	    var defDate = msec ? new Date(msec) : new Date();
	    _angular2.default.forEach($dates, function (dateObject) {
	      var w = [];
	      for (var x = 0; x <= 6; x++) {
	        var d = (0, _moment2.default)(defDate).day(x).toDate();
	        w[x] = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
	        if (w[x] === dateObject.utcDateValue) {
	          dateObject.active = true;
	        }
	      }
	    });
	  }
	}
	
	_angular2.default.module('myApp').component(COMPONENT_NAME, {
	  bindings: {},
	  controller: DatePicker,
	  // TODO : webpack対応でhtmlをimportするよう修正する
	  templateUrl: 'views/date-picker.html'
	});

/***/ },

/***/ 224:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DirectiveName = 'sssResize';
	
	var ResizeController = function () {
	  /* @ngInject */
	  ResizeController.$inject = ["$scope", "$element", "SharedState", "resize"];
	  function ResizeController($scope, $element, SharedState, resize) {
	    (0, _classCallCheck3.default)(this, ResizeController);
	
	    this.$scope = $scope;
	    this.$elm = $element;
	    this.sharedState = SharedState;
	
	    ResizeController.$inject = ['$scope', '$element', 'SharedState', 'resize'];
	  }
	
	  (0, _createClass3.default)(ResizeController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.sharedState.initialize(this.$scope, this.$scope.name, { defaultValue: 0 });
	      this.$scope.$watch(function () {
	        var style = window.getComputedStyle(_this.$elm[0]);
	        var ret = {
	          w: _this.$elm[0].clientWidth - parseInt(style.paddingLeft, 10) - parseInt(style.paddingRight, 10),
	          h: _this.$elm[0].clientHeight - parseInt(style.paddingTop, 10) - parseInt(style.paddingBottom, 10)
	        };
	        return ret;
	      }, function (newVal, oldVal) {
	        _this.setGraphWidth(newVal.w);
	      }, true);
	
	      this.$elm.bind('resize', function () {
	        _this.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'setGraphWidth',
	    value: function setGraphWidth(width) {
	      this.sharedState.set(this.$scope.name, width || 0);
	    }
	  }]);
	  return ResizeController;
	}();
	
	function link($scope, $element, $attrs, controller) {
	  controller.init();
	}
	
	function ddo() {
	  return {
	    restrict: 'A',
	    controller: ResizeController,
	    controllerAs: 'resizeController',
	    require: DirectiveName,
	    scope: {
	      name: '@' + DirectiveName
	    },
	    link: link
	  };
	}
	
	_angular2.default.module('myApp').directive(DirectiveName, ddo);

/***/ },

/***/ 225:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DirectiveName = 'resize';
	
	var ResizeController =
	/* @ngInject */
	["$scope", "$element", "SharedState", function ResizeController($scope, $element, SharedState) {
	  (0, _classCallCheck3.default)(this, ResizeController);
	
	  this.$scope = $scope;
	  this.$elm = $element;
	  this.sharedState = SharedState;
	
	  ResizeController.$inject = ['$scope', '$element', 'SharedState'];
	}];
	
	function ddo() {
	  return {
	    restrict: 'A',
	    controller: ResizeController,
	    controllerAs: 'resizeController',
	    require: DirectiveName,
	    scope: {
	      name: '@' + DirectiveName
	    },
	    link: function link(scope, elem, attrs, controller) {
	      if (elem[0].nodeName === 'TEXTAREA') {
	        // textareaの初期設定
	        elem.css({ 'lineHeight': '20px', 'height': '60px', 'min-height': '60px' });
	
	        // 初期入力情報によってtextareaを変動
	        scope.$watch(attrs.ngModel, function () {
	          var textHeight = elem[0].scrollHeight;
	          elem.css('height', textHeight + 'px');
	        });
	
	        // 文字入力時のtextarea設定値変動
	        var resize = function resize(e) {
	          var argObj = e.target;
	          argObj.style.height = '10px';
	          var wSclollHeight = parseInt(argObj.scrollHeight);
	          var wLineH = parseInt(argObj.style.lineHeight.replace(/px/, ''));
	          if (wSclollHeight < wLineH * 2) {
	            wSclollHeight = wLineH * 2;
	          }
	          elem.css('height', wSclollHeight + 'px');
	        };
	        elem.on('input', resize);
	      }
	    }
	  };
	}
	
	_angular2.default.module('myApp').directive(DirectiveName, ddo);

/***/ },

/***/ 226:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RootController = function () {
	  /* @ngInject */
	  RootController.$inject = ["$rootScope", "$location", "$scope", "$route", "$cookies", "$window", "Resource", "GA", "sssSharedState", "SharedState", "apiEndpoint", "$sessionStorage", "LoginType", "Page", "commonFactory", "Const"];
	  function RootController($rootScope, $location, $scope, $route, $cookies, $window, Resource, GA, sssSharedState, SharedState, apiEndpoint, $sessionStorage, LoginType, Page, commonFactory, Const) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, RootController);
	
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$route = $route;
	    this.$location = $location;
	    this.$window = $window;
	    this.Resource = Resource;
	    this.sharedState = sssSharedState;
	    this.uiSharedState = SharedState;
	    this.uiSharedState.initialize($scope, 'showLoadingCount', { defaultValue: 0 });
	    // TODO $rootScope とどちらに設定すべきか今後検討
	    this.apiEndpoint = apiEndpoint;
	    this.$sessionStorage = $sessionStorage;
	    this.Page = Page;
	    this.commonFactory = commonFactory;
	    this.Const = Const;
	
	    this.$rootScope.$on('$locationChangeSuccess', function () {
	      _this.$rootScope.actualLocation = $location.path();
	    });
	    this.$rootScope.$watch(function () {
	      return $location.path();
	    }, function (newLocation, oldLocation) {
	      _this.$sessionStorage[_this.Const.SSAPP_BROWSER_BACK_FORWARD] = false;
	      _this.$sessionStorage[_this.Const.SSAPP_OLD_LOCATION] = oldLocation;
	      if (_this.$rootScope.actualLocation === newLocation) {
	        _this.$sessionStorage[_this.Const.SSAPP_BROWSER_BACK_FORWARD] = true;
	      }
	    });
	
	    RootController.$inject = ['$rootScope', '$location', '$scope', '$route', '$cookies', '$window', 'Resource', 'GA', 'sssSharedState', 'SharedState', 'apiEndpoint', '$sessionStorage', 'LoginType', 'Page', 'commonFactory', 'Const'];
	  }
	
	  (0, _createClass3.default)(RootController, [{
	    key: 'isLoading',
	    value: function isLoading() {
	      return this.uiSharedState.get('showLoadingCount') > 0;
	    }
	  }, {
	    key: 'go',
	    value: function go($event, url) {
	      $event.preventDefault();
	      $event.stopPropagation();
	      this.$location.path(url);
	
	      // giveup
	      this.showLoadingCount = 0;
	    }
	  }, {
	    key: 'toEula',
	    value: function toEula() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$location.path('/eula');
	    }
	  }, {
	    key: 'toPasswordChange',
	    value: function toPasswordChange() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$location.path('/password_change');
	    }
	  }, {
	    key: 'toNotificationConfigration',
	    value: function toNotificationConfigration() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$location.path('/notification_configration');
	    }
	  }, {
	    key: 'toHowto',
	    value: function toHowto() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$window.open(this.Const.EXTERNAL_URL.howto, '_blank');
	    }
	  }, {
	    key: 'toCoachingVideos',
	    value: function toCoachingVideos() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$window.open(this.Const.EXTERNAL_URL.coachingVideos, '_blank');
	    }
	  }]);
	  return RootController;
	}();
	
	_angular2.default.module('myApp').controller('RootController', RootController);

/***/ },

/***/ 227:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeController = function () {
	  /* @ngInject */
	  HomeController.$inject = ["$scope", "$location", "$sessionStorage", "LoginType"];
	  function HomeController($scope, $location, $sessionStorage, LoginType) {
	    (0, _classCallCheck3.default)(this, HomeController);
	
	    this.location = $location;
	    // TODO : 削除予定
	    $scope.vm = $scope.vm || {};
	    var user = $sessionStorage.user;
	    var type = user.type;
	    this.redirectByType(type);
	
	    HomeController.$inject = ['$scope', '$location', '$sessionStorage', 'LoginType'];
	  }
	
	  (0, _createClass3.default)(HomeController, [{
	    key: 'redirectByType',
	    value: function redirectByType(userType) {
	      switch (userType) {
	        case 'companyAdmin':
	          // TODO: companyAdmin
	          // this.location.path('');
	          break;
	        case 'schoolAdmin':
	          // TODO: schoolAdminの遷移先を指定
	          // this.location.path('');
	          break;
	      }
	    }
	  }]);
	  return HomeController;
	}();
	
	_angular2.default.module('myApp').controller('HomeController', HomeController);

/***/ },

/***/ 228:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MemberSignInController = function () {
	  /* @ngInject */
	  MemberSignInController.$inject = ["$scope", "$sessionStorage", "$location", "commonAuthFactory", "commonApiFactory", "commonFactory", "Const", "Page"];
	  function MemberSignInController($scope, $sessionStorage, $location, commonAuthFactory, commonApiFactory, commonFactory, Const, Page) {
	    (0, _classCallCheck3.default)(this, MemberSignInController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$location = $location;
	    this.commonAuthFactory = commonAuthFactory;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = false;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
	    this.$sessionStorage[this.Const.SSAPP_SMALL_HEIGHT] = '';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.$sessionStorage[this.Const.SSAPP_FULL_SCREEN_IOS] = false;
	    this.isFailed = false;
	    this.isLimit = false;
	    Page.setTitle(this.Const.TITLE.signIn);
	    this.commonFactory.overlayHidden();
	    this.commonFactory.deleteErrorFlg();
	
	    var sessionRole = this.$sessionStorage[Const.LSAPP_ROLE];
	    var role = localStorage.getItem(Const.LSAPP_ROLE);
	    // Cognito Credentials
	    var userId = localStorage.getItem(Const.LSKEY_USER_ID);
	    var jwtToken = localStorage.getItem(Const.LSKEY_USER_ID_TOKEN);
	    var accessKeyId = localStorage.getItem(Const.LSKEY_USER_ACCESS_KEY_ID);
	    var secretAccessKey = localStorage.getItem(Const.LSKEY_USER_SECRET_ACCESS_KEY);
	    var sessionToken = localStorage.getItem(Const.LSKEY_USER_SESSION_TOKEN);
	    var refreshToken = localStorage.getItem(Const.LSKEY_USER_REFRESH_TOKEN);
	    var accessToken = localStorage.getItem(Const.LSKEY_USER_ACCESS_TOKEN);
	    var isCredential = false;
	    if (userId && jwtToken && accessKeyId && secretAccessKey && sessionToken && refreshToken && accessToken) {
	      isCredential = true;
	    }
	    if (!sessionRole && role && isCredential && role === this.Const.LSAPP_ROLE_MEMBER) {
	      this.simplicitySignIn();
	    }
	
	    MemberSignInController.$inject = ['$scope', '$sessionStorage', '$location', 'commonAuthFactory', 'commonApiFactory', 'commonFactory', 'Const', 'Page'];
	  }
	
	  (0, _createClass3.default)(MemberSignInController, [{
	    key: 'signIn',
	    value: function signIn() {
	      var _this = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	      this.isFailed = false;
	      this.isLimit = false;
	
	      var id = this.userId;
	      var password = this.userPass;
	      var userAuth = this.commonAuthFactory.userLogin(id, password, null);
	      this.commonFactory.setStorage(this.Const.LSAPP_ROLE, this.Const.LSAPP_ROLE_MEMBER);
	      userAuth.then(function (userCredentials) {
	        return _this.commonAuthFactory.getCredentialsForAPI(userCredentials, localStorage.getItem(_this.Const.LSAPP_ROLE));
	      }).then(function () {
	        return _this.commonApiFactory.getMembersMe();
	      }).then(function (member) {
	        // 生徒情報を追加時に他修正が必要な箇所
	        // ・password-change-controller.es6
	        // ・simplicity-sign-in-controller.es6
	        _this.$sessionStorage[_this.Const.SSAPP_MEMBER_ID] = member.id;
	        _this.$sessionStorage[_this.Const.SSAPP_USER_NAME] = member.name;
	        _this.$sessionStorage[_this.Const.SSAPP_GENDER] = member.gender;
	        _this.$sessionStorage[_this.Const.SSAPP_EULA_AGREE] = member.data.eulaAgree;
	        _this.$sessionStorage[_this.Const.SSAPP_SENSOR_RENTAL] = member.data.sensorRental;
	        if (member.data.eulaAgree !== null && member.data.eulaAgree === _this.Const.EULA_AGREE_TYPE.agreed) {
	          _this.$location.path('/member');
	        } else {
	          _this.$location.path('/eula');
	        }
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      }).catch(function (error) {
	        console.log('error : ', error);
	        if (error) {
	          if (error.statusCode === 400 && ~error.message.indexOf('attempts exceeded')) {
	            _this.isFailed = false;
	            _this.isLimit = true;
	          } else {
	            _this.isFailed = true;
	            _this.isLimit = false;
	          }
	        } else {
	          _this.isFailed = true;
	          _this.isLimit = false;
	        }
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'simplicitySignIn',
	    value: function simplicitySignIn() {
	      var _this2 = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	      this.isFailed = false;
	      this.isLimit = false;
	
	      this.commonApiFactory.getMembersMe().then(function (member) {
	        _this2.commonFactory.setStorage(_this2.Const.LSAPP_ROLE, _this2.Const.LSAPP_ROLE_MEMBER);
	        // 生徒情報を追加時に他修正が必要な箇所
	        // ・password-change-controller.es6
	        // ・simplicity-sign-in-controller.es6
	        _this2.$sessionStorage[_this2.Const.SSAPP_MEMBER_ID] = member.id;
	        _this2.$sessionStorage[_this2.Const.SSAPP_USER_NAME] = member.name;
	        _this2.$sessionStorage[_this2.Const.SSAPP_GENDER] = member.gender;
	        _this2.$sessionStorage[_this2.Const.SSAPP_EULA_AGREE] = member.data.eulaAgree;
	        _this2.$sessionStorage[_this2.Const.SSAPP_SENSOR_RENTAL] = member.data.sensorRental;
	        _this2.$location.path('/member');
	        _this2.commonFactory.overlayHidden();
	        _this2.$scope.$apply();
	      }).catch(function (error) {
	        console.log('error : ', error);
	        if (error) {
	          if (error.statusCode === 400 && ~error.message.indexOf('attempts exceeded')) {
	            _this2.isFailed = false;
	            _this2.isLimit = true;
	          } else {
	            _this2.isFailed = true;
	            _this2.isLimit = false;
	          }
	        } else {
	          _this2.isFailed = true;
	          _this2.isLimit = false;
	        }
	        _this2.commonFactory.overlayHidden();
	        _this2.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'toPasswordForget',
	    value: function toPasswordForget() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$location.path('/password_forget');
	    }
	  }]);
	  return MemberSignInController;
	}();
	
	_angular2.default.module('myApp').controller('MemberSignInController', MemberSignInController);

/***/ },

/***/ 229:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getIterator2 = __webpack_require__(230);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _slicedToArray2 = __webpack_require__(233);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(188);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _moment = __webpack_require__(59);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FILE_TYPE = 'video/mp4'; /*
	                               global
	                               videojs
	                             */
	
	var VIDEO_DATE_FORMAT = 'YYYY年MM月DD日';
	
	var MemberTopController = function () {
	  /* @ngInject */
	  MemberTopController.$inject = ["$scope", "$rootScope", "$sessionStorage", "$location", "$sce", "$timeout", "commonApiFactory", "commonFactory", "SharedState", "Const", "Page"];
	  function MemberTopController($scope, $rootScope, $sessionStorage, $location, $sce, $timeout, commonApiFactory, commonFactory, SharedState, Const, Page) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, MemberTopController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$sessionStorage = $sessionStorage;
	    this.$location = $location;
	    this.$sce = $sce;
	    this.$timeout = $timeout;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
	    this.commonFactory.overlayHidden();
	    this.commonFactory.deleteErrorFlg();
	
	    this.timestamp = new Date().getTime();
	
	    // レッスン詳細でHeatmapを表示後、生徒トップでフラグを落とす
	    this.$rootScope.heatmapFlg = false;
	    // APIから取得したコースが存在している場合：true
	    // APIから取得したコースが存在していない場合：false
	    this.existenceFlg = true;
	    // APIから取得したFBSが存在している場合：true
	    // APIから取得したFBSが存在していない場合：false
	    this.fbsExistenceFlg = false;
	    // APIからのデータ取得が完了したか判定する
	    this.getDataFin = false;
	
	    this.UiSharedState = SharedState;
	
	    var today = new Date();
	    this.currentDate = today;
	    var monthRange = this.commonFactory.getMonthRange(today);
	    this.selectedYearMonth = (0, _moment2.default)().format('YYYY年M月');
	    this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;
	
	    this.feedbackSheets = [];
	    this.selectedFbs = {};
	    this.fbsIndex = 0;
	    this.isFirstFbs = true;
	    this.isLastFbs = true;
	
	    this.videos = null;
	    this.isVideosExist = false;
	    this.videoRecDate = '';
	    this.videoIndex = 0;
	    this.isFirstVideo = true;
	    this.isLastVideo = true;
	
	    this.$timeout(function () {
	      // ブラウザバックまたはブラウザフォワードでの遷移かつ、前のページが/member/lessonの場合、
	      // レッスン詳細で表示していた月のレッスンリストを表示する
	      if (_this.$sessionStorage[_this.Const.SSAPP_BROWSER_BACK_FORWARD] && _this.$sessionStorage[_this.Const.SSAPP_OLD_LOCATION] === '/member/lesson') {
	        today = new Date(_this.$sessionStorage[_this.Const.SSAPP_LESSON_BEGIN_DATE]);
	        _this.currentDate = today;
	        monthRange = _this.commonFactory.getMonthRange(today);
	        _this.selectedYearMonth = (0, _moment2.default)(_this.$sessionStorage[_this.Const.SSAPP_LESSON_BEGIN_DATE]).format('YYYY年M月');
	        _this.$sessionStorage[_this.Const.SSAPP_SELECTED_YEAR_MONTH] = _this.selectedYearMonth;
	      }
	      if (localStorage.getItem(_this.Const.LSAPP_ROLE) !== _this.Const.LSAPP_ROLE_MEMBER) {
	        _this.staffLogic(monthRange);
	      } else {
	        _this.memberLogic(monthRange);
	      }
	      _this.loadFeedbackSheet();
	      Page.setTitle(_this.Const.TITLE.top);
	    }, 0);
	
	    MemberTopController.$inject = ['$scope', '$rootScope', '$sessionStorage', '$location', '$sce', '$timeout', 'commonApiFactory', 'commonFactory', 'SharedState', 'Const', 'Page'];
	  }
	
	  (0, _createClass3.default)(MemberTopController, [{
	    key: 'staffLogic',
	    value: function staffLogic(monthRange) {
	      var _this2 = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	
	      if (!this.$sessionStorage[this.Const.SSAPP_MEMBER_ID]) {
	        this.$location.path('/staff/course');
	      }
	      var currentMemberId = this.$sessionStorage[this.Const.SSAPP_MEMBER_ID];
	
	      var promises = [];
	
	      // GET /members/{memberId}/lessons用
	      var getMemberIdLessonsParams = {
	        memberId: currentMemberId,
	        endDateTime: monthRange.endDateParam,
	        beginDateTime: monthRange.beginDateParam
	      };
	
	      var getMemberIdVideosParams = {
	        memberId: currentMemberId,
	        limit: '',
	        beginDateTime: '',
	        order: '',
	        url: ''
	      };
	
	      promises.push(this.commonApiFactory.getMembersMemberIdLessons(getMemberIdLessonsParams));
	      if (!this.videos) {
	        promises.push(this.commonApiFactory.getMembersMemberIdVideos(getMemberIdVideosParams));
	      }
	
	      _promise2.default.all(promises).then(function (result) {
	        var _result = (0, _slicedToArray3.default)(result, 2),
	            apiLessons = _result[0],
	            apiVideos = _result[1];
	
	        _this2.lessonList = [];
	        apiLessons.forEach(function (lesson) {
	          var main = [];
	          var sub = [];
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(lesson.course.staffs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var staff = _step.value;
	
	              staff.type === _this2.Const.COACH_TYPE.main ? main.push(staff.name) : sub.push(staff.name);
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          var lessonObj = {
	            startedDate: (0, _moment2.default)(lesson.startedDate).format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
	            endedDate: (0, _moment2.default)(lesson.endedDate).format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
	            date: (0, _moment2.default)(lesson.startedDate).format('M/D'),
	            day: (0, _moment2.default)(lesson.startedDate).format('(ddd)'),
	            beginTime: (0, _moment2.default)(lesson.startedDate).format('HH:mm'),
	            endTime: (0, _moment2.default)(lesson.endedDate).format('HH:mm'),
	            courseName: lesson.course.name,
	            coachName: main.length === 0 ? '' : 'コーチ:' + main.join(','),
	            subCoachName: sub.length === 0 ? '' : 'サブコーチ:' + sub.join(',')
	          };
	          _this2.lessonList.push(lessonObj);
	        });
	        if (_this2.lessonList.length) {
	          _this2.existenceFlg = true;
	          _this2.getDataFin = true;
	          _this2.$sessionStorage[_this2.Const.SSAPP_DISP_LESSON_LIST] = _this2.lessonList;
	        } else {
	          _this2.existenceFlg = false;
	          _this2.getDataFin = true;
	        }
	
	        if (apiVideos) {
	          var publicedVideos = [];
	          apiVideos.forEach(function (video) {
	            if (video.state & _this2.Const.VIDEO_STATE_FLAG.publiced) {
	              publicedVideos.push(video);
	            }
	          });
	          _this2.setFirstVideo(publicedVideos);
	        }
	        _this2.$timeout(function () {
	          _this2.commonFactory.overlayHidden();
	        }, 2200);
	        _this2.$scope.$apply();
	      }).catch(function () {
	        _this2.commonFactory.overlayHidden();
	        _this2.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'memberLogic',
	    value: function memberLogic(monthRange) {
	      var _this3 = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	
	      var promises = [];
	
	      // GET /MembeerMeLessons 用 パラメータ
	      var lessonParams = {
	        beginDateTime: monthRange.beginDateParam,
	        endDateTime: monthRange.endDateParam
	      };
	
	      var videoParams = {
	        limit: '',
	        beginDateTime: '',
	        order: '',
	        url: ''
	      };
	
	      promises.push(this.commonApiFactory.getMembersMeLessons(lessonParams));
	      if (!this.videos) {
	        promises.push(this.commonApiFactory.getMembersMeVideos(videoParams));
	      }
	
	      _promise2.default.all(promises).then(function (result) {
	        var _result2 = (0, _slicedToArray3.default)(result, 2),
	            apiLessons = _result2[0],
	            apiVideos = _result2[1];
	
	        _this3.lessonList = [];
	        apiLessons.forEach(function (lesson) {
	          var main = [];
	          var sub = [];
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = (0, _getIterator3.default)(lesson.course.staffs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var staff = _step2.value;
	
	              staff.type === _this3.Const.COACH_TYPE.main ? main.push(staff.name) : sub.push(staff.name);
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	
	          var lessonObj = {
	            startedDate: (0, _moment2.default)(lesson.startedDate).format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
	            endedDate: (0, _moment2.default)(lesson.endedDate).format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
	            date: (0, _moment2.default)(lesson.startedDate).format('M/D'),
	            day: (0, _moment2.default)(lesson.startedDate).format('(ddd)'),
	            beginTime: (0, _moment2.default)(lesson.startedDate).format('HH:mm'),
	            endTime: (0, _moment2.default)(lesson.endedDate).format('HH:mm'),
	            courseName: lesson.course.name,
	            coachName: main.length === 0 ? '' : 'コーチ:' + main.join(','),
	            subCoachName: sub.length === 0 ? '' : 'サブコーチ:' + sub.join(',')
	          };
	          _this3.lessonList.push(lessonObj);
	        });
	        if (_this3.lessonList.length) {
	          _this3.existenceFlg = true;
	          _this3.getDataFin = true;
	          _this3.$sessionStorage[_this3.Const.SSAPP_DISP_LESSON_LIST] = _this3.lessonList;
	        } else {
	          _this3.existenceFlg = false;
	          _this3.getDataFin = true;
	        }
	
	        if (apiVideos) {
	          _this3.setFirstVideo(apiVideos);
	        }
	        _this3.$timeout(function () {
	          _this3.commonFactory.overlayHidden();
	        }, 2000);
	        _this3.$scope.$apply();
	      }).catch(function () {
	        _this3.commonFactory.overlayHidden();
	        _this3.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'loadFeedbackSheet',
	    value: function loadFeedbackSheet() {
	      var _this4 = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	      var currentMemberId = this.$sessionStorage[this.Const.SSAPP_MEMBER_ID];
	
	      // GET /members/{memberId}/feedbackSheet用
	      var getMemberIdFeedbackSheetParams = {
	        memberId: currentMemberId
	      };
	
	      this.commonApiFactory.getMembersMemberIdFeedbackSheet(getMemberIdFeedbackSheetParams).then(function (apiFeedbackSheet) {
	        _this4.fbsList = [];
	        apiFeedbackSheet.fbs.forEach(function (fbs) {
	          var fbsObj = {
	            periodName: fbs.periodName,
	            pdfUrl: fbs.pdfUrl,
	            fileName: fbs.fileName,
	            periodStartDate: (0, _moment2.default)(fbs.periodStartDate).format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
	            isNew: fbs.isNew
	          };
	          _this4.fbsList.push(fbsObj);
	        });
	
	        if (_this4.fbsList.length) {
	          _this4.fbsExistenceFlg = true;
	          _this4.feedbackSheets = _this4.fbsList;
	          _this4.setFirstFbs(_this4.feedbackSheets);
	        } else {
	          _this4.fbsExistenceFlg = false;
	        }
	
	        _this4.$timeout(function () {
	          _this4.commonFactory.overlayHidden();
	        }, 2200);
	        _this4.$scope.$apply();
	      }).catch(function (error) {
	        console.error(error);
	        _this4.commonFactory.overlayHidden();
	        _this4.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'setFirstVideo',
	    value: function setFirstVideo(videos) {
	      var _this5 = this;
	
	      this.videos = [];
	      videos.forEach(function (video) {
	        if (video.state & _this5.Const.VIDEO_STATE_FLAG.converted) {
	          _this5.videos.push(video);
	        }
	      });
	      // 最新の動画を最初に表示する
	      this.videoIndex = this.videos.length - 1;
	
	      if (this.$sessionStorage[this.Const.SSAPP_BROWSER_BACK_FORWARD] && this.$sessionStorage[this.Const.SSAPP_VIDEO_ID]) {
	        for (var i = 0; i < this.videos.length; i++) {
	          if (this.$sessionStorage[this.Const.SSAPP_VIDEO_ID] === this.videos[i].id) {
	            this.videoIndex = i;
	          }
	        }
	      }
	
	      if (this.videos.length === 0) {
	        this.isVideosExist = false;
	      } else if (this.videos.length >= 1) {
	        this.isVideosExist = true;
	        // check video is first video.
	        if (this.videoIndex === 0) {
	          this.isFirstVideo = true;
	        } else {
	          this.isFirstVideo = false;
	        }
	        // check video is last video.
	        if (this.videoIndex === this.videos.length - 1) {
	          this.isLastVideo = true;
	        } else {
	          this.isLastVideo = false;
	        }
	        this.videoRecDate = (0, _moment2.default)(this.videos[this.videoIndex].startedDate).format(VIDEO_DATE_FORMAT);
	        var that = this;
	        this.$timeout(function () {
	          // 再生ボタンをダウンロード不可にする
	          var el = document.getElementById('video-play-button-' + _this5.timestamp);
	          el.addEventListener('contextmenu', function (event) {
	            event.preventDefault();
	          }, false);
	          videojs('video-' + _this5.timestamp).ready(function () {
	            var sources = [{ 'type': FILE_TYPE, 'src': that.$sce.trustAsResourceUrl(that.videos[that.videoIndex].getUrls.original) }];
	            this.src(sources);
	            var getUrls = that.videos[that.videoIndex].getUrls;
	            if (getUrls && getUrls.thumb) {
	              // サムネイル表示
	              this.poster(getUrls.thumb);
	            } else {
	              this.load();
	            }
	          });
	        }, 1000);
	      }
	    }
	  }, {
	    key: 'setFirstFbs',
	    value: function setFirstFbs(feedbackSheets) {
	      if (feedbackSheets.length > 1) {
	        this.isFirstFbs = false;
	      }
	      // 初期表示は最新のFBS（配列の先頭の要素）
	      this.selectedFbs = feedbackSheets[0];
	    }
	  }, {
	    key: 'changeVideo',
	    value: function changeVideo(action) {
	      switch (action) {
	        case 'next':
	          this.videoIndex++;
	          this.isFirstVideo = false;
	          break;
	        case 'back':
	          this.videoIndex--;
	          this.isLastVideo = false;
	          break;
	      }
	      // サムネイルをリセット
	      videojs('video-' + this.timestamp).poster('');
	      if (this.videoIndex < 0 || this.videoIndex >= this.videos.length) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_UNEXPECTED_ERROR, 3000, false);
	      }
	      if (this.videoIndex === 0) {
	        this.isFirstVideo = true;
	      }
	      if (this.videoIndex === this.videos.length - 1) {
	        this.isLastVideo = true;
	      }
	
	      this.videoRecDate = (0, _moment2.default)(this.videos[this.videoIndex].startedDate).format(VIDEO_DATE_FORMAT);
	      var that = this;
	      videojs('video-' + this.timestamp).ready(function () {
	        var sources = [{ 'type': FILE_TYPE, 'src': that.$sce.trustAsResourceUrl(that.videos[that.videoIndex].getUrls.original) }];
	        this.src(sources);
	        var getUrls = that.videos[that.videoIndex].getUrls;
	        if (getUrls && getUrls.thumb) {
	          // サムネイル表示
	          this.poster(getUrls.thumb);
	        } else {
	          this.load();
	        }
	      });
	    }
	
	    // 基準からみて次の月に該当するコースを表示する
	
	  }, {
	    key: 'toNextMonth',
	    value: function toNextMonth() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	
	      this.getDataFin = false;
	      var currentDate = this.currentDate;
	      var nextMonthRnage = this.commonFactory.getMonthLater(currentDate);
	      // 次の月を基準とする
	      this.currentDate = new Date(nextMonthRnage.beginDateParam);
	      this.selectedYearMonth = (0, _moment2.default)(this.currentDate).format('YYYY年M月');
	      this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;
	      this.lessonList = [];
	      if (localStorage.getItem(this.Const.LSAPP_ROLE) === this.Const.LSAPP_ROLE_MEMBER) {
	        this.memberLogic(nextMonthRnage);
	      } else {
	        this.staffLogic(nextMonthRnage);
	      }
	    }
	
	    // 基準からみて前の月に該当するコースを表示する
	
	  }, {
	    key: 'tobeforeMonth',
	    value: function tobeforeMonth() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	
	      this.getDataFin = false;
	      var currentDate = this.currentDate;
	      var beforeMonthRnage = this.commonFactory.getMonthAgo(currentDate);
	      // 前の月を基準とする
	      this.currentDate = new Date(beforeMonthRnage.beginDateParam);
	      this.selectedYearMonth = (0, _moment2.default)(this.currentDate).format('YYYY年M月');
	      this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;
	      this.lessonList = [];
	      if (localStorage.getItem(this.Const.LSAPP_ROLE) === this.Const.LSAPP_ROLE_MEMBER) {
	        this.memberLogic(beforeMonthRnage);
	      } else {
	        this.staffLogic(beforeMonthRnage);
	      }
	    }
	
	    // 次の期に該当するFBSを表示する
	
	  }, {
	    key: 'toNextPeriod',
	    value: function toNextPeriod() {
	      this.fbsIndex--;
	      if (this.feedbackSheets.length - 1 >= this.fbsIndex) {
	        this.selectedFbs = this.feedbackSheets[this.fbsIndex];
	        this.isFirstFbs = false;
	      }
	
	      // 配列の先頭に辿り着いたら次の期に進むボタンを非表示にする
	      if (this.fbsIndex === 0) {
	        this.isLastFbs = true;
	      }
	    }
	
	    // 前の期に該当するFBSを表示する
	
	  }, {
	    key: 'tobeforePeriod',
	    value: function tobeforePeriod() {
	      this.fbsIndex++;
	      if (this.feedbackSheets.length - 1 >= this.fbsIndex) {
	        this.selectedFbs = this.feedbackSheets[this.fbsIndex];
	        this.isLastFbs = false;
	      }
	
	      // 配列の最後尾に辿り着いたら前の期に戻るボタンを非表示にする
	      if (this.feedbackSheets.length - 1 === this.fbsIndex) {
	        this.isFirstFbs = true;
	      }
	    }
	  }, {
	    key: 'toMemberLesson',
	    value: function toMemberLesson(lesson, idx) {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	
	      this.$sessionStorage[this.Const.SSAPP_DISP_LESSON_INDEX] = this.$sessionStorage[this.Const.SSAPP_TARGET_LESSON_INDEX] = idx;
	      this.$sessionStorage[this.Const.SSAPP_TARGET_LESSON_LIST] = this.lessonList;
	      if (this.$sessionStorage[this.Const.LSAPP_ROLE] === this.Const.LSAPP_ROLE_MEMBER && this.$sessionStorage[this.Const.SSAPP_SENSOR_RENTAL] === this.Const.SENSOR_RENTAL.unRegistered) {
	        this.UiSharedState.turnOn('dialogAdvertisePopup');
	        return;
	      }
	      this.$sessionStorage[this.Const.SSAPP_LESSON_NAME] = lesson.courseName;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_DATE] = lesson.date;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_DAY] = lesson.day;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_DATE] = lesson.startedDate;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_END_DATE] = lesson.endedDate;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_TIME] = lesson.beginTime;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_END_TIME] = lesson.endTime;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_COACH_NAME] = lesson.coachName;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_SUB_COACH_NAME] = lesson.subCoachName;
	      this.$location.path('/member/lesson');
	    }
	  }, {
	    key: 'toVideoPlayScreen',
	    value: function toVideoPlayScreen(urls) {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$sessionStorage[this.Const.SSAPP_VIDEO_ID] = this.videos[this.videoIndex].id;
	      this.$sessionStorage[this.Const.SSAPP_PRESIGNED_URLS] = this.videos[this.videoIndex].getUrls;
	      this.$sessionStorage['videoStartedDate'] = this.videos[this.videoIndex].startedDate;
	      this.$sessionStorage['videoEndedDate'] = this.videos[this.videoIndex].endedDate;
	      this.$location.path('/member/video');
	    }
	  }]);
	  return MemberTopController;
	}();
	
	_angular2.default.module('myApp').controller('MemberTopController', MemberTopController);

/***/ },

/***/ 237:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getIterator2 = __webpack_require__(230);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _promise = __webpack_require__(188);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _moment = __webpack_require__(59);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LessonDetailController = function () {
	  /* @ngInject */
	  LessonDetailController.$inject = ["$scope", "$routeParams", "$q", "$sessionStorage", "$window", "$resource", "$location", "SharedState", "sssSharedState", "SwingTypeConstants", "ImpactPointConstants", "commonApiFactory", "commonFactory", "Const", "Page"];
	  function LessonDetailController($scope, $routeParams, $q, $sessionStorage, $window, $resource, $location, SharedState, sssSharedState, SwingTypeConstants, ImpactPointConstants, commonApiFactory, commonFactory, Const, Page) {
	    (0, _classCallCheck3.default)(this, LessonDetailController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = '';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.commonFactory = commonFactory;
	    this.commonFactory.overlayHidden();
	    this.commonFactory.deleteErrorFlg();
	    this.$location = $location;
	
	    this.sharedState = sssSharedState;
	    this.sharedState.graphPromise = $q.defer();
	    this.UiSharedState = SharedState;
	    this.swingTypes = SwingTypeConstants;
	    this.impactPoints = ImpactPointConstants;
	    this.$q = $q;
	    this.$window = $window;
	    this.group_id = $routeParams.group_id;
	    this.date_range = $routeParams.range;
	    this.sharedState.title = 'Play Report';
	    this.datetimeFormatter = d3.time.format('%Y/%m/%d %X');
	    this.dateFormatter = d3.time.format('%Y/%m/%d');
	    this.monthFormatter = d3.time.format('%Y/%m');
	    this.yearFormatter = d3.time.format('%Y');
	    // 遷移時はheatmapを必ず非表示にする
	    this.$sessionStorage[this.Const.SSAPP_HEATMAP_FLG] = false;
	    // セッションストレージに表示するレッスン情報がない場合、生徒トップ画面へ戻す
	    if (this.$sessionStorage[this.Const.SSAPP_TARGET_LESSON_INDEX] == null) {
	      this.$location.path('/member');
	    }
	    // 前画面で表示されるレッスン一覧を取得
	    this.lessonList = this.$sessionStorage[this.Const.SSAPP_DISP_LESSON_LIST];
	    // 現在表示されているレッスン詳細が、取得したレッスン一覧の何番目のものかを判別する
	    this.currentIdx = this.$sessionStorage[this.Const.SSAPP_DISP_LESSON_INDEX];
	    /*
	     4つのレッスンがある月の4番目のレッスン詳細を開いたあと、
	     3つ以下のレッスンしかない月に遷移し、
	     端末の戻るボタン・ブラウザの戻るボタンでレッスン詳細に戻ると、
	     3つ以下のレッスンの4番目を検索してしまうため、
	     this.currentIdxに入る値を、戻るボタンを押す前に表示したレッスン一覧の数 - 1とする
	    */
	    if (this.currentIdx > this.lessonList.length - 1) {
	      this.currentIdx = this.lessonList.length - 1;
	    }
	    this.startedDate = this.lessonList[this.currentIdx].startedDate;
	    this.endedDate = this.lessonList[this.currentIdx].endedDate;
	    /*
	     表示しようとした内容がsession storageに格納されている値と違っていた場合、
	     session storageに格納されているものを正とする
	     this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_DATE]は、
	     レッスン詳細に遷移するときに格納される
	     端末の戻るボタン・ブラウザの戻るボタンでレッスン詳細に戻ると、不整合が生じる
	    */
	    if (this.startedDate !== this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_DATE]) {
	      this.lessonList = this.$sessionStorage[this.Const.SSAPP_DISP_LESSON_LIST] = this.$sessionStorage[this.Const.SSAPP_TARGET_LESSON_LIST];
	      this.currentIdx = this.$sessionStorage[this.Const.SSAPP_DISP_LESSON_INDEX] = this.$sessionStorage[this.Const.SSAPP_TARGET_LESSON_INDEX];
	      this.startedDate = this.lessonList[this.currentIdx].startedDate;
	      this.endedDate = this.lessonList[this.currentIdx].endedDate;
	    }
	    // 一番最後のレッスンを選択した場合、'>'を隠すために取得
	    this.lessonListLength = this.lessonList.length - 1;
	    if (this.currentIdx === this.lessonListLength) {
	      this.maxFlg = true;
	    } else {
	      this.maxFlg = false;
	    }
	    // APIからのデータ取得が完了したか判定する
	    this.renderFin = this.$sessionStorage[this.Const.SSAPP_RENDER_FIN] = false;
	
	    dc.chartRegistry.clear();
	    this.query = {};
	
	    this.installDateChangeListener(this.startedDate, this.endedDate);
	    this.shot = crossfilter();
	    this.tennis_chart = {
	      shot: this.shot,
	      reportCtrl: this
	    };
	
	    this.commonApiFactory = commonApiFactory;
	    this.shotData = [];
	    this.resource = $resource;
	
	    if (!navigator.onLine) {
	      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	      return;
	    } else {
	      this.commonFactory.overlayShow();
	    }
	
	    Page.setTitle(this.Const.TITLE.lesson);
	
	    LessonDetailController.$inject = ['$scope', '$routeParams', '$q', '$sessionStorage', '$window', '$resource', '$location', 'SharedState', 'sssSharedState', 'SwingTypeConstants', 'ImpactPointConstants', 'commonApiFactory', 'commonFactory', 'Const', 'Page'];
	  }
	
	  (0, _createClass3.default)(LessonDetailController, [{
	    key: 'setTennisChartCtrl',
	    value: function setTennisChartCtrl(ctrl) {
	      this.tennisChartCtrl = ctrl;
	    }
	  }, {
	    key: 'installDateChangeListener',
	    value: function installDateChangeListener(start, end) {
	      var _this = this;
	
	      var query = {};
	
	      if (this.date_range) {
	        this.$scope.$on('mobile-angular-ui.state.changed.dateMode', function (e, newVal, oldVal) {
	          query.range = oldVal ? newVal : _this.date_range;
	          if (query.range && query.date) _this.getReports(query, start, end);
	        });
	        this.$scope.$on('mobile-angular-ui.state.changed.date', function (e, newVal, oldVal) {
	          query.date = newVal;
	          if (query.range && query.date) _this.getReports(query, start, end);
	        });
	      } else {
	        this.$scope.$on('mobile-angular-ui.state.changed.dateMode', function (e, newVal, oldVal) {
	          console.log(newVal, oldVal);
	          query.range = newVal;
	          if (query.range && query.date) _this.getReports(query, start, end);
	        });
	        this.$scope.$on('mobile-angular-ui.state.changed.date', function (e, newVal, oldVal) {
	          query.date = newVal;
	          if (query.range && query.date) _this.getReports(query, start, end);
	        });
	      }
	    }
	  }, {
	    key: 'getReports',
	    value: function getReports(query, start, end) {
	      var _this2 = this;
	
	      query.range = 'day';
	      var promiseShot = this.queryShotData(query, start, end);
	      if (query.range === 'day') {
	        promiseShot.then(function () {
	          _this2.dcRender();
	        });
	      }
	    }
	  }, {
	    key: 'queryShotData',
	    value: function queryShotData(query, start, end) {
	      var _this3 = this;
	
	      var changed = false;
	      var deferred = this.$q.defer();
	      if (this.query.range !== query.range) {
	        this.query.range = query.range;
	        changed = true;
	      }
	      var date = void 0;
	      switch (query.range) {
	        case 'day':
	          date = this.dateFormatter(query.date);
	          break;
	        case 'week':
	          date = this.dateFormatter((0, _moment2.default)(query.date).day(0).toDate());
	          break;
	        case 'month':
	          date = this.monthFormatter(query.date);
	          break;
	        case 'year':
	          date = this.yearFormatter(query.date);
	          break;
	      }
	      if (changed || this.query.date !== date) {
	        this.query.date = date;
	        changed = true;
	      }
	      if (!changed) {
	        console.log('query not changed', this.query);
	        return;
	      }
	      console.log('querying', this.query);
	      // GET members/{memberId}/shots用
	      var getMembersMemberIdShotsParams = {
	        memberId: this.$sessionStorage[this.Const.SSAPP_MEMBER_ID],
	        endDateTime: end,
	        beginDateTime: start
	      };
	      // GET members/me/shots用
	      var getMembersMeShotsParams = {
	        endDateTime: end,
	        beginDateTime: start
	      };
	      var promiseArray = [];
	      if (localStorage.getItem(this.Const.LSAPP_ROLE) !== this.Const.LSAPP_ROLE_MEMBER) {
	        promiseArray.push(this.sharedState.graphPromise.promise);
	        promiseArray.push(this.commonApiFactory.getMembersMemberIdShots(getMembersMemberIdShotsParams));
	      } else {
	        promiseArray.push(this.sharedState.graphPromise.promise);
	        promiseArray.push(this.commonApiFactory.getMembersMeShots(getMembersMeShotsParams));
	      }
	      _promise2.default.all(promiseArray).then(function (arr) {
	        var chart = arr[0];
	        var shotData = arr[1]; // APIから取得したデータ
	        var dataArray = [];
	        var data = void 0;
	        var beginDate = void 0;
	        var endDate = void 0;
	        _this3.shotData = shotData;
	        for (var i = 0; i < _this3.shotData.length; i++) {
	          dataArray.push(_this3.shotData[i].summaryData);
	        }
	        data = dataArray;
	        if (data.length > 0) {
	          beginDate = new Date(start);
	          endDate = new Date(end);
	        } else {
	          beginDate = new Date(start);
	          endDate = new Date(end);
	          beginDate = new Date(beginDate.setHours(beginDate.getHours() - 23));
	          endDate = new Date(endDate.setHours(endDate.getHours() - 23));
	        }
	        _this3.formatShotData(data);
	        _this3.setShotData(data);
	        deferred.resolve();
	        _this3.tennisChartCtrl.userSeriesChart.x(d3.time.scale().domain([beginDate, endDate]));
	
	        // metricsChartY軸に設定する最小値/最大値
	        var yMax = -12;
	        var yMin = 12;
	        var rightYMax = 0;
	        var rightYMin = 220;
	        if (_this3.shotData.length > 0) {
	          // this.shotDataがある場合の初期値
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(_this3.shotData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var shot = _step.value;
	
	              var rightYTmp = 0;
	              // spin
	              yMax = shot.impact.spin >= yMax ? shot.impact.spin : yMax;
	              yMin = shot.impact.spin <= yMin ? shot.impact.spin : yMin;
	              // impact.speedとswing.speed
	              rightYTmp = shot.swing.speed >= shot.impact.speed ? shot.swing.speed : shot.impact.speed;
	              rightYMax = rightYTmp >= rightYMax ? rightYTmp : rightYMax;
	              rightYTmp = 0;
	              rightYTmp = shot.swing.speed <= shot.impact.speed ? shot.swing.speed : shot.impact.speed;
	              rightYMin = rightYTmp <= rightYMin ? rightYTmp : rightYMin;
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        } else {
	          // this.shotDataがなかった場合の初期値
	          yMax = 13;
	          yMin = -12;
	          rightYMax = 220;
	          rightYMin = 0;
	        }
	        // rightYMaxの一の位を切り上げる
	        rightYMax = rightYMax / 10;
	        rightYMax = Math.ceil(rightYMax) * 10;
	        // rightMinの小数点以下を切り捨てる
	        rightYMin = Math.floor(rightYMin);
	        // metricsChart左側Y軸に設定する最大値・最小値の設定
	        yMax = yMax + 0.5 > 10 ? 13 : yMax;
	        yMin = yMin - 0.5 < -10 ? -12 : yMin;
	        // metricsChart右側Y軸に設定する最大値・最小値の設定
	        rightYMax = rightYMax + 10 > 200 ? 220 : rightYMax;
	        rightYMin = rightYMin - 10 < 0 ? 0 : rightYMin;
	        // yMax、yMinを枠線に収まるように調整
	        var num = yMax - yMin;
	        if (_this3.shotData.length > 0) {
	          if (num === 0) {
	            yMax = 13;
	            yMin = -12;
	          } else if (yMax - yMin <= 4) {
	            yMax = yMax + 0.5;
	            yMin = yMin - 0.5;
	          } else if (yMax - yMin > 20) {
	            yMax = yMax + 0.5;
	            yMin = yMin - 0.5;
	          } else {
	            yMax = yMax + 3;
	            yMin = yMin - 2;
	          }
	        }
	        // rightYMax、rightYMinを枠線に収まるように調整
	        var rightNum = rightYMax - rightYMin;
	        if (rightNum >= 20) {
	          if (rightNum % 20 === 0) {
	            rightYMax = rightYMax + 20;
	            rightYMin = rightYMin - 20;
	          } else {
	            rightYMax = rightYMax + 15;
	            rightYMin = rightYMin - 15;
	          }
	        } else {
	          rightYMax = rightYMax + rightYMax % 20 + 3;
	          rightYMin = rightYMin - rightYMin % 20;
	        }
	        _this3.tennisChartCtrl.metricsChart.y(d3.scale.linear().domain([yMin, yMax]));
	        _this3.tennisChartCtrl.metricsChart.rightY(d3.scale.linear().domain([rightYMin, rightYMax]));
	
	        // brushOn:true の状態でデータが揃う前(X軸の範囲が確定する前)にredrawが起きると、
	        // グラフ中の要素のCSSにtranslate(NaN,0)が 設定されてしまうので、データが揃ってから
	        // brushOnする
	        chart.brushOn(true);
	      }).catch(function () {
	        _this3.commonFactory.overlayHidden();
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'dcRender',
	    value: function dcRender() {
	      var beginDate = new Date(this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_DATE]);
	      var endDate = new Date(this.$sessionStorage[this.Const.SSAPP_LESSON_END_DATE]);
	      dc.filterAll();
	      this.tennisChartCtrl.userSeriesChart.filter([beginDate, endDate]);
	      dc.renderAll();
	      dc.redrawAll();
	      // シークバーの高さ調整
	      var extentEle = document.getElementsByClassName('extent');
	      extentEle[0].setAttribute('height', '24');
	      // スライダーの領域調整
	      var resizeEle = document.getElementsByClassName('resize');
	      var resizeE = resizeEle[0].getElementsByTagName('rect');
	      var resizeW = resizeEle[1].getElementsByTagName('rect');
	      resizeE[0].setAttribute('width', '50');
	      resizeW[0].setAttribute('width', '50');
	      resizeE[0].setAttribute('height', '40');
	      resizeW[0].setAttribute('height', '40');
	      this.renderFin = this.$sessionStorage[this.Const.SSAPP_RENDER_FIN] = true;
	      this.commonFactory.overlayHidden();
	    }
	  }, {
	    key: 'formatShotData',
	    value: function formatShotData(data, hasDate) {
	      var _this4 = this;
	
	      if (!data.length) return;
	      data.forEach(function (d, i) {
	        d.index = data.length - i; // TODO
	        d.impact.spin = d.impact.spin >= 2850 ? 10 : d.impact.spin >= 2550 ? 9 : d.impact.spin >= 2250 ? 8 : d.impact.spin >= 1950 ? 7 : d.impact.spin >= 1650 ? 6 : d.impact.spin >= 1350 ? 5 : d.impact.spin >= 1050 ? 4 : d.impact.spin >= 750 ? 3 : d.impact.spin >= 450 ? 2 : d.impact.spin >= 150 ? 1 : d.impact.spin >= -150 ? 0 : d.impact.spin >= -450 ? -1 : d.impact.spin >= -750 ? -2 : d.impact.spin >= -1050 ? -3 : d.impact.spin >= -1350 ? -4 : d.impact.spin >= -1650 ? -5 : d.impact.spin >= -1950 ? -6 : d.impact.spin >= -2250 ? -7 : d.impact.spin >= -2550 ? -8 : d.impact.spin >= -2850 ? -9 : -10;
	        if (!hasDate) {
	          d.date = new Date(d.impact.timestamp * 1000);
	        }
	        d.swing_type = _this4.swingTypes.getLabel(d.swing.type);
	        d.minute = d3.time.minute(d.date);
	        d.hour = d3.time.hour(d.date);
	        d.day = d3.time.day(d.date);
	        d.second = d3.time.second(d.date);
	      });
	    }
	  }, {
	    key: 'setShotData',
	    value: function setShotData(data) {
	      data.sort(function (a, b) {
	        if (a.date > b.date) return 1;
	        if (a.date < b.date) return -1;
	        return 0;
	      });
	      this.shotData = data;
	      this.shot.remove();
	      this.shot.add(data);
	    }
	  }, {
	    key: 'toNextLesson',
	    value: function toNextLesson() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	
	      this.renderFin = this.$sessionStorage[this.Const.SSAPP_RENDER_FIN] = false;
	      this.currentIdx = this.currentIdx + 1;
	      this.$sessionStorage[this.Const.SSAPP_DISP_LESSON_INDEX] = this.$sessionStorage[this.Const.SSAPP_TARGET_LESSON_INDEX] = this.currentIdx;
	      var nextLesson = this.lessonList[this.currentIdx];
	      var nextStartedDate = nextLesson.startedDate;
	      var nextEndedDate = nextLesson.endedDate;
	      if (this.$sessionStorage[this.Const.SSAPP_DISP_LESSON_INDEX] === this.lessonListLength) {
	        this.maxFlg = true;
	      } else {
	        this.maxFlg = false;
	      }
	      this.$sessionStorage[this.Const.SSAPP_LESSON_NAME] = nextLesson.courseName;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_DATE] = nextLesson.date;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_DAY] = nextLesson.day;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_DATE] = nextLesson.startedDate;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_END_DATE] = nextLesson.endedDate;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_TIME] = nextLesson.beginTime;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_END_TIME] = nextLesson.endTime;
	      this.query.date = new Date(this.query.date);
	      this.resetChartStyle();
	      this.getReports(this.query, nextStartedDate, nextEndedDate);
	    }
	  }, {
	    key: 'toBeforeLesson',
	    value: function toBeforeLesson() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	
	      this.renderFin = this.$sessionStorage[this.Const.SSAPP_RENDER_FIN] = false;
	      this.currentIdx = this.currentIdx - 1;
	      this.$sessionStorage[this.Const.SSAPP_DISP_LESSON_INDEX] = this.$sessionStorage[this.Const.SSAPP_TARGET_LESSON_INDEX] = this.currentIdx;
	      var beforeLesson = this.lessonList[this.currentIdx];
	      var beforeStartedDate = beforeLesson.startedDate;
	      var beforeEndedDate = beforeLesson.endedDate;
	      if (this.currentIdx === this.lessonListLength) {
	        this.maxFlg = true;
	      } else {
	        this.maxFlg = false;
	      }
	      this.$sessionStorage[this.Const.SSAPP_LESSON_NAME] = beforeLesson.courseName;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_DATE] = beforeLesson.date;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_DAY] = beforeLesson.day;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_DATE] = beforeLesson.startedDate;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_END_DATE] = beforeLesson.endedDate;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_TIME] = beforeLesson.beginTime;
	      this.$sessionStorage[this.Const.SSAPP_LESSON_END_TIME] = beforeLesson.endTime;
	      this.query.date = new Date(this.query.date);
	      this.resetChartStyle();
	      this.getReports(this.query, beforeStartedDate, beforeEndedDate);
	    }
	  }, {
	    key: 'resetChartStyle',
	    value: function resetChartStyle() {
	      var _this5 = this;
	
	      dc.filterAll();
	      this.$sessionStorage[this.Const.SSAPP_HEATMAP_FLG] = false;
	      this.$sessionStorage[this.Const.SSAPP_SHOT_KIND] = this.Const.SHOT_TYPE.all;
	      this.tennisChartCtrl.userSeriesChart.selectAll('.dc-chart rect.bar').style('fill', function (d) {
	        return _this5.Const.SHOT_COLOR.all;
	      });
	      this.tennisChartCtrl.userSeriesChart.select('.dc-chart .brush rect.extent').style('fill', function (d) {
	        return _this5.Const.SHOT_COLOR.all;
	      });
	      this.tennisChartCtrl.userSeriesChart.selectAll('.dc-chart rect.bar.deselected').style('fill', function (d) {
	        return _this5.Const.SHOT_COLOR.deselected;
	      });
	      this.tennisChartCtrl.userSeriesChart.colorAccessor(function (d) {
	        if (d.value) {
	          _this5.tennisChartCtrl.userSeriesChart.selectAll('.dc-chart rect.bar').style('fill', function (d) {
	            return _this5.Const.SHOT_COLOR.all;
	          });
	          _this5.tennisChartCtrl.userSeriesChart.select('.dc-chart .brush rect.extent').style('fill', function (d) {
	            return _this5.Const.SHOT_COLOR.all;
	          });
	          _this5.tennisChartCtrl.userSeriesChart.selectAll('.dc-chart rect.bar.deselected').style('fill', function (d) {
	            return _this5.Const.SHOT_COLOR.deselected;
	          });
	        }
	      });
	    }
	  }]);
	  return LessonDetailController;
	}();
	
	_angular2.default.module('myApp').controller('LessonDetailController', LessonDetailController);

/***/ },

/***/ 238:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(239);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(230);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _reductioMin = __webpack_require__(56);
	
	var _reductioMin2 = _interopRequireDefault(_reductioMin);
	
	var _heatmap = __webpack_require__(55);
	
	var _heatmap2 = _interopRequireDefault(_heatmap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMPONENT_NAME = 'tennisGraph';
	var HEAT_MAP_WIDTH = 420;
	var HEAT_MAP_HEIGHT = 426;
	
	var TennisGraph = function () {
	  /* @ngInject */
	  TennisGraph.$inject = ["$scope", "$rootScope", "$element", "$q", "$http", "$parse", "$sessionStorage", "SwingTypeConstants", "ImpactPointConstants", "sssSharedState", "SharedState", "Const"];
	  function TennisGraph($scope, $rootScope, $element, $q, $http, $parse, $sessionStorage, SwingTypeConstants, ImpactPointConstants, sssSharedState, SharedState, Const) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, TennisGraph);
	
	    // TODO : 削除予定
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$http = $http;
	    this.$parse = $parse;
	    this.swingTypes = SwingTypeConstants;
	    this.impactPoints = ImpactPointConstants;
	    this.sharedState = sssSharedState;
	    this.UiSharedState = SharedState;
	    this.datetimeFormatter = d3.time.format('%Y/%m/%d %X');
	    this.valueFormatter = d3.format('.1f');
	    this.$sessionStorage = $sessionStorage;
	    this.$sessionStorage[this.Const.SSAPP_SHOT_KIND] = this.Const.SHOT_TYPE.all;
	
	    var shot = this.shot = this.chartinfo.shot;
	    this.shotdate = shot.dimension(function (d) {
	      return d.date;
	    });
	    this.chartinfo.reportCtrl.setTennisChartCtrl(this);
	
	    // for average value update in spin/swingspeed/ballspeed graph
	    this.spin = (0, _reductioMin2.default)().avg(function (d) {
	      return d.impact.spin;
	    })(shot.groupAll());
	
	    this.ballSpeed = (0, _reductioMin2.default)().avg(function (d) {
	      return d.impact.speed;
	    })(shot.groupAll());
	
	    this.swingSpeed = (0, _reductioMin2.default)().avg(function (d) {
	      return d.swing.speed;
	    })(shot.groupAll());
	
	    var userSeries = {};
	    userSeries.dim = shot.dimension(function (d) {
	      return d.minute;
	    });
	    userSeries.gp = userSeries.dim.group();
	
	    var userSeriesRangeBar = {};
	    userSeriesRangeBar.dim = shot.dimension(function (d) {
	      return d.minute;
	    });
	    userSeriesRangeBar.gp = userSeriesRangeBar.dim.group();
	
	    var swingType = {};
	    swingType.dim = shot.dimension(function (d) {
	      return d.swing_type;
	    });
	    swingType.gp = this.buildSwingTypeGroup(swingType.dim.group());
	
	    var impactPoint = {};
	    impactPoint.dim = shot.dimension(function (d) {
	      return d.impact.spot;
	    });
	    impactPoint.gp = impactPoint.dim.group();
	
	    var spin = {};
	    spin.dim = shot.dimension(function (d) {
	      return d.second;
	    });
	    spin.gp = this.reducer(spin.dim.group(), function (v) {
	      return v.impact.spin;
	    });
	
	    var swingSpeed = {};
	    swingSpeed.dim = shot.dimension(function (d) {
	      return d.second;
	    });
	    swingSpeed.gp = this.reducer(swingSpeed.dim.group(), function (v) {
	      return v.swing.speed;
	    });
	
	    var hitballSpeed = {};
	    hitballSpeed.dim = shot.dimension(function (d) {
	      return d.second;
	    });
	    hitballSpeed.gp = this.reducer(hitballSpeed.dim.group(), function (v) {
	      return v.impact.speed;
	    });
	
	    this.metricNames = ['showSpinMetric', 'showSwingspMetric', 'showHitballspMetric'];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      var _loop = function _loop() {
	        var value = _step.value;
	
	        // TODO : $watchを$scopeを参照しないように同等な別実装を行う
	        $parse(value).assign($scope, true);
	        $scope.$watch(value, function (on, _) {
	          _this.setMetricVisibility(value, on);
	        });
	      };
	
	      for (var _iterator = (0, _getIterator3.default)(this.metricNames), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        _loop();
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    this.userSeriesOptions = {
	      height: 78,
	      x: d3.time.scale().domain([Date(2015, 7, 1), Date()]),
	      dimension: userSeries.dim,
	      group: userSeries.gp,
	      margins: { left: 48, top: 0, right: 48, bottom: 30 },
	      elasticY: true,
	      elasticX: false,
	      brushOn: false, // データが揃ってからtrueにする
	      transitionDuration: 500,
	      postSetupChart: function postSetupChart(chart, options) {
	        var beginDate = void 0;
	        var endDate = void 0;
	        beginDate = new Date(_this.$sessionStorage[_this.Const.SSAPP_LESSON_BEGIN_DATE]);
	        endDate = new Date(_this.$sessionStorage[_this.Const.SSAPP_LESSON_END_DATE]);
	        chart.yAxis().ticks(0);
	        chart.filter([beginDate, endDate]);
	        _this.userSeriesChart = _this.$rootScope.userSeriesChart = chart;
	        _this.setResizeHandler(chart, 'userSeries');
	        _this.sharedState.graphPromise.resolve(chart);
	      }
	    };
	
	    this.drawFlaf = false;
	    var ccCounter = 0;
	    this.swingtypeChartOptions = {
	      dimension: swingType.dim,
	      group: swingType.gp,
	      legend: dc.legend().x(180).y(20),
	      renderLabel: false,
	      ordering: function ordering(d) {
	        return _this.swingTypes.getOrderIdByLabel(d.key);
	      },
	      colors: function colors(key) {
	        return _this.swingTypes.getColorByLabel(key);
	      },
	      transitionDuration: 500,
	      postSetupChart: function postSetupChart(chart) {
	        _this.swingtypeChart = _this.$rootScope.swingtypeChart = chart;
	        var legend = chart.legend();
	        legend.horizontal(false);
	        chart.on('pretransition', function (c) {
	          ccCounter = ccCounter + 1;
	          if (ccCounter > 2) {
	            _this.setRelayoutSwingtypeChart(chart, impactPoint.gp);
	          }
	        });
	        _this.setResizeHandler(chart, 'swingtypeChart');
	      }
	    };
	
	    var img = new Image();
	    var imgMask = new Image();
	    img.src = './res/st_detail/detail_heatmap_racquet.png';
	    imgMask.src = './res/st_detail/detail_heatmap_racquet_mask.png';
	
	    var canvas = document.getElementById('img_cvs');
	    var canvasMask = document.getElementById('img_cvs_mask');
	    img.onload = function () {
	      var ctx = canvas.getContext('2d');
	      ctx.drawImage(img, 0, 0);
	    };
	    imgMask.onload = function () {
	      var ctxMask = canvasMask.getContext('2d');
	      ctxMask.drawImage(imgMask, 0, 0);
	    };
	    var parentContainer = document.getElementById('heatmapContainer');
	    this.impactHeatmap = _heatmap2.default.create({
	      container: parentContainer,
	      width: HEAT_MAP_WIDTH,
	      height: HEAT_MAP_HEIGHT,
	      maxOpacity: 1,
	      minOpacity: 0,
	      blur: 0.65,
	      gradient: {
	        '.4': '#00E', // Blue
	        '.5': '#0EE', // Blue
	        '.7': '#0E0', // Green
	        '.75': '#EE0', // Yellow
	        '.8': '#E00' // Red
	      }
	    });
	
	    this.impactPointMapper = this.createMap(HEAT_MAP_WIDTH, HEAT_MAP_HEIGHT);
	
	    this.metricsChartOptions = {
	      height: 58.5,
	      margins: { left: 40, top: 0, right: 40, bottom: 5 },
	      brushOn: false,
	      transitionDuration: 500,
	      renderHorizontalGridLines: true,
	      dimension: spin.dim,
	      gap: 1,
	      x: d3.scale.linear().domain([0, 1000]),
	      y: d3.scale.linear().domain([-12, 13]),
	      rightY: d3.scale.linear().domain([0, 220]),
	      elasticX: true,
	      elasticY: false,
	      shareTitle: false,
	      postSetupChart: function postSetupChart(chart, options) {
	        _this.metricsChart = chart;
	        chart.compose([_this.buildMetricLineChart(chart, spin.gp, _this.backgroundColorByClassName('sss-label-spin')), _this.buildMetricLineChart(chart, swingSpeed.gp, _this.backgroundColorByClassName('sss-label-swingsp')).useRightYAxis(true), _this.buildMetricLineChart(chart, hitballSpeed.gp, _this.backgroundColorByClassName('sss-label-hitballsp')).useRightYAxis(true)]);
	        chart.yAxis().ticks(4);
	        chart.rightYAxis().ticks(4);
	        chart.rightYAxisLabel('km/h', 10);
	        _this.setResizeHandler(chart, 'metricsChart');
	        chart.on('pretransition', function (_chart) {
	          // 再描画時に表示/非表示を反映させる
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = (0, _getIterator3.default)(_this.metricNames), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var value = _step2.value;
	
	              // TODO : $scopeを参照しないように同等な別実装を行う
	              _this.setMetricVisibility(value, _this.$scope[value]);
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        });
	      }
	    };
	
	    TennisGraph.$inject = ['$scope', '$rootScope', '$element', '$q', '$http', '$parse', '$sessionStorage', 'SwingTypeConstants', 'ImpactPointConstants', 'sssSharedState', 'SharedState', 'Const'];
	  }
	
	  (0, _createClass3.default)(TennisGraph, [{
	    key: 'showSelectShot',
	    value: function showSelectShot() {
	      if (this.$sessionStorage[this.Const.SSAPP_RENDER_FIN] === false) {
	        return;
	      } else {
	        // ショット選択ダイアログ
	        this.UiSharedState.turnOn('dialogSelectShotPopup');
	
	        /*
	          ダイアログが表示されてからチェックするラジオボタンを判断する
	        */
	        var that = this;
	        $(function () {
	          var dialogRadioBtn = document.getElementsByName('shotRadio');
	          var idx = that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] === that.Const.SHOT_TYPE.all ? 0 : that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] === that.Const.SHOT_TYPE.foreF ? 1 : that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] === that.Const.SHOT_TYPE.foreS ? 2 : that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] === that.Const.SHOT_TYPE.backF ? 3 : that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] === that.Const.SHOT_TYPE.backS ? 4 : that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] === that.Const.SHOT_TYPE.foreV ? 5 : that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] === that.Const.SHOT_TYPE.backV ? 6 : that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] === that.Const.SHOT_TYPE.smash ? 7 : 8;
	          dialogRadioBtn[idx].checked = true;
	          that.$rootScope.lessonBeginDate = that.$sessionStorage[that.Const.SSAPP_LESSON_BEGIN_DATE];
	          that.$rootScope.lessonEndDate = that.$sessionStorage[that.Const.SSAPP_LESSON_END_DATE];
	        });
	      }
	    }
	  }, {
	    key: 'backgroundColorByClassName',
	    value: function backgroundColorByClassName(className) {
	      return window.getComputedStyle(document.getElementsByClassName(className)[0]).getPropertyValue('background-color');
	    }
	  }, {
	    key: 'buildMetricLineChart',
	    value: function buildMetricLineChart(chart, gp, color) {
	      return dc.lineChart(chart).group(gp).colors(color).keyAccessor(function (d) {
	        return d.value.pos;
	      }).title(function (d) {
	        return '' + Math.round(d.value.ave);
	      }).valueAccessor(function (d) {
	        return d.value.ave;
	      });
	    }
	  }, {
	    key: 'buildSwingTypeGroup',
	    value: function buildSwingTypeGroup(gp) {
	      var _this2 = this;
	
	      return {
	        all: function all() {
	          var all = gp.all();
	          if (all.length === _this2.swingTypes.length) {
	            return all;
	          }
	          var map = _this2.swingTypes.map(function (d, idx) {
	            for (var i = 0; i < all.length; ++i) {
	              if (all[i].key === d.label) {
	                return all[i];
	              }
	            }
	            return { key: d.label, value: 0 };
	          });
	          return map;
	        }
	      };
	    }
	  }, {
	    key: 'setMetricVisibility',
	    value: function setMetricVisibility(metricName, on) {
	      if (this.metricsChart) {
	        this.metricsChart.selectAll('.sub._' + this.metricNames.indexOf(metricName) + ' .chart-body').style('visibility', on ? 'visible' : 'hidden');
	      }
	    }
	  }, {
	    key: 'setRelayoutSwingtypeChart',
	    value: function setRelayoutSwingtypeChart(chart, gp) {
	      // heatmap refresh
	      this.updateImpactpointHeatmap(gp);
	      if (this.drawFlaf === false) {
	        this.drawFlaf = true;
	        chart.width(360).height(162).cx(85).cy(85).radius(70).innerRadius(56);
	        chart.redraw();
	      }
	    }
	  }, {
	    key: 'setResizeHandler',
	    value: function setResizeHandler(chart, name) {
	      var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	      var handler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	      var uiState = this.UiSharedState;
	      // TODO : $watchを$scopeを参照しないように同等な別実装を行う
	      this.$scope.$watch(function () {
	        return uiState.get(name);
	      }, function (newVal) {
	        chart.width(newVal);
	        if (ratio) {
	          chart.height(newVal * ratio);
	        }
	        if (handler) {
	          handler(chart);
	        }
	        if (chart.rescale) {
	          chart.rescale();
	        }
	        chart.redraw();
	      }, true);
	    }
	  }, {
	    key: 'reducer',
	    value: function reducer(group, valueAccessor) {
	      // 平均、最大、最小を求めつつReduce
	      var gp = group.reduce(
	      /* add */function (p, v) {
	        var value = valueAccessor(v);
	        p.count++;
	        p.objs[v.id] = v;
	        p.sum += value;
	        p.indexSum += v.index;
	        p.ave = p.count ? p.sum / p.count : 0;
	        p.indexAve = p.count ? p.indexSum / p.count : p.indexAve;
	        if (p.count === 1) {
	          p.max = value;
	          p.min = value;
	        } else {
	          p.max = p.max > value ? p.max : value;
	          p.min = p.min < value ? p.min : value;
	        }
	        return p;
	      },
	      /* remove */function (p, v) {
	        var value = valueAccessor(v);
	        p.count--;
	        delete p.objs[v.id];
	        p.sum -= value;
	        p.indexSum -= v.index;
	        p.ave = p.count ? p.sum / p.count : 0;
	        p.indexAve = p.count ? p.indexSum / p.count : p.indexAve;
	        if (p.count === 0) {
	          p.max = 0;
	          p.min = 0;
	        } else if (p.max <= value || p.min >= value) {
	          p.max = -Infinity;
	          p.min = Infinity;
	          (0, _keys2.default)(p.objs).forEach(function (id) {
	            var vv = valueAccessor(p.objs[id]);
	            p.max = p.max > vv ? p.max : vv;
	            p.min = p.min < vv ? p.min : vv;
	          });
	        }
	        return p;
	      },
	      /* initial */function () {
	        return {
	          objs: {},
	          count: 0,
	          sum: 0,
	          max: -Infinity,
	          min: Infinity,
	          indexSum: 0
	        };
	      });
	
	      // 空になったグループ(count=0)を、X軸スケールを歪めて非表示にする。
	      // 実際には軸のスケールではなくKeyの値を変更する。
	      // X軸は常に0~100として、中身のあるグループを等間隔に並べ、
	      // 中身のないグループの幅が0になるよう、直前の中身のあるグループと同じ値に調整する。
	      // これでフィルタリング時のアニメーションが正しいものになる。
	      return {
	        all: function all() {
	          var curr = 0.0;
	          var max = gp.all().filter(function (d) {
	            return d.value.count !== 0;
	          }).length;
	          var actual = gp.all().filter(function (d) {
	            return d.value.count !== 0;
	          }).length;
	          var div = max / actual;
	          var firstPosValue = {
	            pos: 0,
	            ave: 0,
	            min: 0,
	            max: 0
	          };
	          var lastValue = {
	            pos: 1,
	            ave: 0,
	            min: 0,
	            max: 0
	          };
	          var result = gp.all().map(function (d) {
	            var out = { key: d.key, value: d.value };
	            if (d.value.count !== 0) {
	              curr += div;
	              out.value.pos = curr;
	              if (out.value.pos === 1) {
	                // pos1のvalueを保持
	                firstPosValue = out.value;
	              }
	              lastValue = d.value;
	            } else {
	              // empty bin uses last value
	              out.value = {
	                pos: lastValue.pos,
	                ave: lastValue.ave,
	                min: lastValue.min,
	                max: lastValue.max
	              };
	            }
	            return out;
	          });
	          var _iteratorNormalCompletion3 = true;
	          var _didIteratorError3 = false;
	          var _iteratorError3 = undefined;
	
	          try {
	            for (var _iterator3 = (0, _getIterator3.default)(result), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	              var val = _step3.value;
	
	              // empty bin uses last valueが登録されてしまっているため、
	              // 実際にLineChartに表示されているpos1のvalueで更新しておく
	              if (val.value.pos === 1) {
	                val.value = firstPosValue;
	              }
	            }
	          } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	              }
	            } finally {
	              if (_didIteratorError3) {
	                throw _iteratorError3;
	              }
	            }
	          }
	
	          return result;
	        }
	      };
	    }
	
	    // impact point heatmap を更新する
	
	  }, {
	    key: 'updateImpactpointHeatmap',
	    value: function updateImpactpointHeatmap(impactPointGroup) {
	      var max = 100;
	      var min = 0;
	      var t = [];
	      var ret = impactPointGroup.top(impactPointGroup.size());
	      var impactMax = ret.length >= 1 ? ret[0].value : 0;
	      for (var i = 0; i < ret.length; ++i) {
	        var x = this.impactPointMapper[ret[i].key];
	        if (ret[i].value > 0) {
	          x.value = this.calHeatMapVal(impactMax, ret[i].value);
	          t.push(x);
	        } else {
	          x.value = 0;
	          t.push(x);
	        }
	      }
	      this.impactHeatmap.setData({
	        min: min,
	        max: max,
	        data: t
	      });
	    }
	
	    // 割合を計算
	
	  }, {
	    key: 'calHeatMapVal',
	    value: function calHeatMapVal(max, me) {
	      var val = max === 0 || me === 0 ? 0 : me / max * 100;
	      return val < 70 ? 50 : val < 99 ? 70 : val;
	    }
	
	    // 座標作成
	
	  }, {
	    key: 'createMap',
	    value: function createMap(width, height) {
	      var highRadius = 50;
	      var lowRadius = 50;
	      var X_SCALE = 0.11;
	      var X_OFFSET = 0.2;
	      var Y_SCALE = 0.1;
	      var Y_OFFSET = 0.1;
	
	      var array = [{ radius: lowRadius }, { radius: highRadius }, { radius: highRadius }, { radius: lowRadius }, { radius: lowRadius }, { radius: highRadius }, { radius: highRadius }, { radius: highRadius }, { radius: highRadius }, { radius: lowRadius }, { radius: highRadius }, { radius: highRadius }, { radius: highRadius }, { radius: highRadius }, { radius: highRadius }, { radius: highRadius }, { radius: lowRadius }, { radius: highRadius }, { radius: highRadius }, { radius: highRadius }, { radius: highRadius }, { radius: lowRadius }, { radius: lowRadius }, { radius: highRadius }, { radius: highRadius }, { radius: lowRadius }];
	
	      for (var i = 0; i < array.length; ++i) {
	        array[i].x = Math.floor(width * (X_OFFSET + X_SCALE * this.impactPoints[i][0]));
	        array[i].y = Math.floor(height * (Y_OFFSET + Y_SCALE * this.impactPoints[i][1]));
	        array[i].value = 0;
	      }
	
	      return array;
	    }
	  }]);
	  return TennisGraph;
	}();
	
	_angular2.default.module('myApp').component(COMPONENT_NAME, {
	  bindings: {
	    name: '@' + COMPONENT_NAME,
	    chartinfo: '=chartinfo'
	  },
	  controller: TennisGraph,
	  templateUrl: 'app/components/lesson-detail/graph.html'
	});

/***/ },

/***/ 243:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _shotDataView = __webpack_require__(244);
	
	var _shotDataView2 = _interopRequireDefault(_shotDataView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FILE_TYPE = 'video/mp4'; /*
	                               global
	                               videojs
	                             */
	
	var ORIGINAL = 'original';
	var LOW = 'low';
	var ORIGINAL_LABEL = '標準版';
	var LOW_LABEL = 'ライト版';
	var MAJOR_VERSION = 1;
	var FULL_SIZE = '100%';
	var AUTO_SIZE = 'auto';
	
	var VideoPlayScreen = function () {
	  /* @ngInject */
	  VideoPlayScreen.$inject = ["$scope", "$sessionStorage", "$location", "$sce", "$timeout", "commonApiFactory", "commonFactory", "SwingTypeConstants", "Const"];
	  function VideoPlayScreen($scope, $sessionStorage, $location, $sce, $timeout, commonApiFactory, commonFactory, SwingTypeConstants, Const) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, VideoPlayScreen);
	
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$location = $location;
	    this.$sce = $sce;
	    this.$timeout = $timeout;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.SwingTypeConstants = SwingTypeConstants;
	    this.Const = Const;
	
	    // ローディングが残っていた場合非表示にする
	    this.commonFactory.overlayHidden();
	    var presignedUrls = this.$sessionStorage[this.Const.SSAPP_PRESIGNED_URLS];
	    // セッションストレージに動画のpresignedUrlがない場合、生徒トップ画面へ戻す
	    if (!presignedUrls) {
	      this.$location.path('/member');
	      return;
	    }
	    if (presignedUrls && !presignedUrls.original) {
	      this.$location.path('/member');
	      return;
	    }
	
	    this.video = null;
	    this.presignedUrl = '';
	
	    this.activeMessage = false;
	    this.activePlayButton = true;
	    this.isSuccessCopy = false;
	    this.timestamp = new Date().getTime();
	    this.isFullScreen = false;
	
	    // device check
	    this.isIOS = this.checkIOS();
	    this.activeIOSLowVersionMessage = false;
	    this.isIOSLowVersion = false;
	    if (this.isIOS) {
	      // iPhone5Sのとき、landscape時にheightが101%以上でないとアドレスバーが隠れないため、101%を指定する
	      this.$sessionStorage[this.Const.SSAPP_FULL_SCREEN_IOS] = true;
	      this.activeIOSLowVersionMessage = true;
	      this.isIOSLowVersion = this.checkIOSLowVersion();
	      this.setTouchEvent();
	    }
	
	    // video size setting
	    this.videoThumbWidth = FULL_SIZE;
	    this.videoThumbHeight = AUTO_SIZE;
	    // landscape時にスクリーンのアスペクト比が16:9より横幅の比率が大きい場合は、横幅100%に動画を表示
	    this.isWidthMax = true;
	    this.setVideoSize();
	    window.onresize = function () {
	      _this.setVideoSize();
	      _this.$scope.$apply();
	    };
	
	    // resolution setting
	    this.activeResolutionWindow = false;
	    this.activeResolution = ORIGINAL;
	    this.resolutionLabel = ORIGINAL_LABEL;
	
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = false;
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = 'min-height-zero';
	    this.startedDate = new Date(this.$sessionStorage['videoStartedDate']).toISOString();
	    this.endedDate = new Date(this.$sessionStorage['videoEndedDate']).toISOString();
	    this.currentTime = 0;
	
	    // shot data setting
	    this.dataView = new _shotDataView2.default(this.SwingTypeConstants);
	    this.getShotData().then(function (shotDatas) {
	      _this.setVideo();
	      _this.dataView.appendShots(shotDatas, _this.startedDate, _this.endedDate);
	    });
	
	    window.addEventListener('online', function () {
	      if (_this.$location.path() === '/member/video') {
	        videojs('video-screen-' + _this.timestamp).removeClass('vjs-seeking');
	        _this.$scope.$apply();
	      }
	    }, false);
	
	    if (!this.isIOS) {
	      document.addEventListener('webkitfullscreenchange', function () {
	        _this.handleFullScreenEvent(event);
	      }, false);
	      document.addEventListener('mozfullscreenchange', function () {
	        _this.handleFullScreenEvent(event);
	      }, false);
	      document.addEventListener('fullscreenchange', function () {
	        _this.handleFullScreenEvent(event);
	      }, false);
	    }
	
	    VideoPlayScreen.$inject = ['$scope', '$sessionStorage', '$location', '$sce', '$timeout', 'commonApiFactory', 'commonFactory', 'SwingTypeConstants', 'Const'];
	  }
	
	  (0, _createClass3.default)(VideoPlayScreen, [{
	    key: 'handleFullScreenEvent',
	    value: function handleFullScreenEvent(event) {
	      var doc = window.document;
	      if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
	        this.activePlayButton = false;
	        this.togglePlay();
	        this.isFullScreen = false;
	      }
	      this.$scope.$apply();
	    }
	
	    // 動画のアスペクト比と表示領域のアスペクト比を比較して、動画のサイズを指定する
	
	  }, {
	    key: 'setVideoSize',
	    value: function setVideoSize() {
	      // 16:9 = width:height
	      var videoAspect = 16 / 9;
	      var windowAspect = void 0;
	      // iosだと、アドレスバー部分も表示領域に含まれるため、innerHeightとinnerWidthで計算できない
	      if (this.isIOS) {
	        if (window.innerHeight >= window.innerWidth) {
	          // iosでportraitのとき、動画の横幅に対応するのはwindow.parent.screen.widthになる
	          windowAspect = window.parent.screen.width / window.parent.screen.height;
	        } else {
	          // iosでlandscapeのとき、動画の横幅に対応するのはwindow.parent.screen.heightになる
	          windowAspect = window.parent.screen.height / window.parent.screen.width;
	        }
	      } else {
	        windowAspect = window.innerWidth / window.innerHeight;
	      }
	      // 画面のアスペクト比が16:9より小さい場合(16:9に対して縦の比率が大きい)
	      if (windowAspect < videoAspect) {
	        this.isWidthMax = true;
	        this.videoThumbWidth = FULL_SIZE;
	        this.videoThumbHeight = AUTO_SIZE;
	        // 画面のアスペクト比が16:9より大きいかつ、横幅が800pxより小さい場合(16:9に対して横の比率が大きい)
	      } else if (window.innerWidth < 800 && windowAspect > videoAspect) {
	        this.isWidthMax = false;
	        // iosの場合、アドレスバーで隠れている部分も表示位置に含まれているため、スクリーンの横幅で計算する。
	        if (this.isIOS) {
	          this.videoThumbWidth = window.parent.screen.width * videoAspect + 'px';
	        } else {
	          this.videoThumbWidth = window.innerHeight * videoAspect + 'px';
	        }
	        this.videoThumbHeight = FULL_SIZE;
	        // 画面のアスペクト比が16:9の場合
	      } else if (windowAspect === videoAspect) {
	        this.isWidthMax = true;
	        this.videoThumbWidth = FULL_SIZE;
	        this.videoThumbHeight = FULL_SIZE;
	        // その他の場合
	      } else {
	        this.isWidthMax = true;
	        this.videoThumbWidth = FULL_SIZE;
	        this.videoThumbHeight = AUTO_SIZE;
	      }
	    }
	  }, {
	    key: 'togglePlay',
	    value: function togglePlay() {
	      if (this.activePlayButton) {
	        this.fullScreen();
	        this.video.play();
	        this.activePlayButton = false;
	      } else {
	        this.video.pause();
	        this.activePlayButton = true;
	      }
	    }
	  }, {
	    key: 'checkIOS',
	    value: function checkIOS() {
	      if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	
	    // iosのバージョンが9以下かどうか判定
	
	  }, {
	    key: 'checkIOSLowVersion',
	    value: function checkIOSLowVersion() {
	      var ua = navigator.userAgent.toLowerCase();
	      var version = void 0;
	      // case of iphone or ipod
	      if (ua.match(/iphone/) || ua.match(/ipod touch/)) {
	        version = ua.match(/iphone os ([\d]+)_([\d]+)_([\d]+)/);
	        if (!version) {
	          version = ua.match(/iphone os ([\d]+)_([\d]+)/);
	        }
	      }
	      // case of ipad
	      if (ua.match(/ipad/)) {
	        version = ua.match(/cpu os ([\d]+)_([\d]+)_([\d]+)/);
	        if (!version) {
	          version = ua.match(/cpu os ([\d]+)_([\d]+)/);
	        }
	      }
	      if (version && version[MAJOR_VERSION] <= 9) {
	        return true;
	      }
	      return false;
	    }
	
	    // iOSにてタップ1回でclickイベントが効かない要素がある。
	    // touchstartでclickイベントを発火するようにする。
	
	  }, {
	    key: 'setTouchEvent',
	    value: function setTouchEvent() {
	      var messageButtons = document.querySelectorAll('.video-message-btn');
	
	      var _loop = function _loop(i) {
	        messageButtons[i].addEventListener('touchstart', function (event) {
	          messageButtons[i].click();
	        }, false);
	      };
	
	      for (var i = 0; i < messageButtons.length; i++) {
	        _loop(i);
	      }
	
	      var textbox = document.getElementById('presigned-url-textbox');
	      textbox.addEventListener('touchstart', function (event) {
	        textbox.click();
	      }, false);
	    }
	  }, {
	    key: 'setVideo',
	    value: function setVideo() {
	      var _this2 = this;
	
	      var urls = this.$sessionStorage[this.Const.SSAPP_PRESIGNED_URLS];
	      // defaultの解像度はoriginalの720p
	      var url = urls.original;
	      this.presignedUrl = url;
	      this.$scope.$apply();
	      // 描画タイミングの問題で、videoタグのidを見つけきれない場合があるため、0.5秒待つ
	      this.$timeout(function () {
	        var that = _this2;
	        // 再生ボタンをダウンロード不可にする
	        var el = document.getElementById('video-play-button-' + _this2.timestamp);
	        el.addEventListener('contextmenu', _this2.cancelEvent, false);
	        videojs('video-screen-' + _this2.timestamp).ready(function () {
	          var _this3 = this;
	
	          that.video = this;
	          this.controls(true);
	          // videojsが表示している再生ボタンをタップした場合に全画面表示にする
	          var playButton = document.getElementsByClassName(this.controlBar.playToggle.el_.className);
	          playButton[0].addEventListener('click', function () {
	            that.fullScreen();
	          }, false);
	          playButton[0].addEventListener('touchend', function () {
	            that.fullScreen();
	          }, false);
	          // iOS9以下の場合は、シークバーを非表示
	          if (that.isIOS && that.isIOSLowVersion) {
	            this.controlBar.addClass('visibility-hidden');
	          }
	          var sources = [{ 'type': FILE_TYPE, 'src': that.$sce.trustAsResourceUrl(url) }];
	          this.src(sources);
	          if (urls && urls.thumb) {
	            // サムネイル表示
	            this.poster(urls.thumb);
	          } else {
	            this.load();
	          }
	          this.on('play', function () {
	            that.activePlayButton = false;
	            // iosではない場合、全画面表示でないときは再生させない
	            if (!that.isFullScreen && !that.isIOS) {
	              _this3.pause();
	            }
	            that.$scope.$apply();
	          });
	          this.on('pause', function () {
	            that.activePlayButton = true;
	            that.$scope.$apply();
	          });
	          // iosだとvideoのcontrollerをタップした際に、clickイベントとtouchイベントの両方が発火する。
	          // そうすると、videojsの再生/停止の制御が2回動いて元の状態に戻ってしまう。
	          // そのためiosの場合のみ、もう一度再生/停止制御を実施する。
	          if (that.isIOS) {
	            this.on('click', function (event) {
	              var className = event.target.className;
	              // controllerの再生/停止ボタンをタップ時のみ再生/停止を行う
	              if (className.indexOf('vjs-play-control') === -1) {
	                return;
	              }
	              if (className.indexOf('vjs-playing') || className.indexOf('vjs-paused')) {
	                that.togglePlay();
	              }
	            });
	          }
	          this.on('timeupdate', function () {
	            that.dataView.updateShotData(_this3.currentTime());
	            that.$scope.$apply();
	          });
	          this.on('error', function () {
	            that.checkPresignedUrl(url);
	          });
	          // ネットワークが切断されて、読み込み分も再生しきったらloadingを表示する。
	          this.on('progress', function () {
	            var time = _this3.currentTime();
	            if (that.currentTime === time) {
	              if (!navigator.onLine) {
	                // loading表示
	                _this3.addClass('vjs-seeking');
	                that.$scope.$apply();
	              }
	            } else {
	              that.currentTime = time;
	            }
	          });
	          this.on('waiting', function () {
	            if (!navigator.onLine) {
	              // loading表示
	              _this3.addClass('vjs-seeking');
	              that.$scope.$apply();
	            }
	          });
	        });
	      }, 500);
	    }
	  }, {
	    key: 'checkPresignedUrl',
	    value: function checkPresignedUrl(url) {
	      var _this4 = this;
	
	      var xmlHttp = new XMLHttpRequest();
	      xmlHttp.onreadystatechange = function () {
	        if (xmlHttp.readyState === 4 && xmlHttp.status === 403) {
	          // 期限切れだった場合、生徒top画面に戻り、presignedUrlを取得し直す。
	          _this4.$location.path('/member');
	          _this4.$scope.$apply();
	        }
	      };
	      xmlHttp.open('GET', url, true);
	      xmlHttp.send(null);
	    }
	  }, {
	    key: 'getShotData',
	    value: function getShotData() {
	      if (localStorage.getItem(this.Const.LSAPP_ROLE) !== this.Const.LSAPP_ROLE_MEMBER) {
	        return this.getMembersShotData();
	      } else {
	        return this.getMeShotData();
	      }
	    }
	  }, {
	    key: 'getMeShotData',
	    value: function getMeShotData() {
	      var params = {
	        beginDateTime: this.startedDate,
	        endDateTime: this.endedDate
	      };
	      return this.commonApiFactory.getMembersMeShots(params);
	    }
	  }, {
	    key: 'getMembersShotData',
	    value: function getMembersShotData() {
	      var currentMemberId = this.$sessionStorage[this.Const.SSAPP_MEMBER_ID];
	      var params = {
	        memberId: currentMemberId,
	        beginDateTime: this.startedDate,
	        endDateTime: this.endedDate
	      };
	      return this.commonApiFactory.getMembersMemberIdShots(params);
	    }
	  }, {
	    key: 'toggleResolutionWindow',
	    value: function toggleResolutionWindow() {
	      if (this.activeResolutionWindow) {
	        this.activeResolutionWindow = false;
	      } else {
	        this.activeResolutionWindow = true;
	      }
	    }
	  }, {
	    key: 'changeResolution',
	    value: function changeResolution(resolution) {
	      // 再生中の解像度を選択した場合、なにもしない
	      if (resolution === this.activeResolution) {
	        this.activeResolutionWindow = false;
	        return;
	      }
	      var el = document.getElementById('video-screen-' + this.timestamp);
	      switch (resolution) {
	        case ORIGINAL:
	          el.removeEventListener('contextmenu', this.cancelEvent, false);
	          this.activeResolution = ORIGINAL;
	          this.resolutionLabel = ORIGINAL_LABEL;
	          break;
	        case LOW:
	          el.addEventListener('contextmenu', this.cancelEvent, false);
	          this.activeResolution = LOW;
	          this.resolutionLabel = LOW_LABEL;
	          break;
	      }
	      var urls = this.$sessionStorage[this.Const.SSAPP_PRESIGNED_URLS];
	      var url = urls[this.activeResolution];
	      var time = videojs('video-screen-' + this.timestamp).currentTime();
	      var that = this;
	      videojs('video-screen-' + that.timestamp).ready(function () {
	        var _this5 = this;
	
	        var sources = [{ 'type': FILE_TYPE, 'src': that.$sce.trustAsResourceUrl(url) }];
	        this.src(sources);
	        if (urls && urls.thumb) {
	          // サムネイル表示
	          this.poster(urls.thumb);
	        } else {
	          this.load();
	        }
	        // 切り替え前の再生時間を指定
	        this.on('loadedmetadata', function () {
	          _this5.currentTime(time);
	        });
	        this.on('timeupdate', function () {
	          that.dataView.updateShotData(_this5.currentTime());
	          that.$scope.$apply();
	        });
	        this.on('error', function () {
	          that.checkPresignedUrl(url);
	        });
	      });
	      this.activeResolutionWindow = false;
	    }
	  }, {
	    key: 'cancelEvent',
	    value: function cancelEvent(event) {
	      event.preventDefault();
	    }
	  }, {
	    key: 'checkActiveResolution',
	    value: function checkActiveResolution(resolution) {
	      return {
	        'active-resolution': this.activeResolution === resolution
	      };
	    }
	  }, {
	    key: 'closeMessage',
	    value: function closeMessage() {
	      this.activeMessage = false;
	    }
	  }, {
	    key: 'closeIOSLowVersionMessage',
	    value: function closeIOSLowVersionMessage() {
	      this.activeIOSLowVersionMessage = false;
	    }
	  }, {
	    key: 'copyUrl',
	    value: function copyUrl() {
	      var el = document.getElementById('hidden-presigned-url');
	      var range = document.createRange();
	      range.selectNode(el);
	      window.getSelection().addRange(range);
	      var result = document.execCommand('copy');
	      if (result) {
	        this.isSuccessCopy = true;
	      } else {
	        this.isSuccessCopy = false;
	      }
	      // ダイアログ表示中は動画停止
	      this.video.pause();
	      this.activeMessage = true;
	    }
	  }, {
	    key: 'fullScreen',
	    value: function fullScreen() {
	      if (this.isFullScreen || this.isIOS) {
	        return;
	      }
	      var doc = window.document;
	      var el = doc.getElementById('video-full-screen');
	      var requestFullScreen = el.requestFullscreen || el.mozRequestFullScreen || el.webkitRequestFullScreen || el.msRequestFullscreen;
	      if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
	        requestFullScreen.call(el);
	        this.isFullScreen = true;
	      }
	    }
	  }]);
	  return VideoPlayScreen;
	}();
	
	_angular2.default.module('myApp').controller('VideoPlayScreen', VideoPlayScreen);

/***/ },

/***/ 244:
/***/ function(module, exports, __webpack_require__) {

	/*global d3 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var X_OFFSET = 19;
	var Y_OFFSET = 11.5;
	var SCALE = 7.5;
	var QUERY_SHOT_INFO_ELEMENT = '#shot-info';
	var QUERY_SHOT_RACKET_ELEMENT = '#shot-racket';
	
	var ShotDataView = function () {
	  function ShotDataView(swingTypeConstants) {
	    (0, _classCallCheck3.default)(this, ShotDataView);
	
	    this.impactPoints = this.getImpactPoints();
	    this.shots = null;
	    this.drawingShotIndex = -1;
	    this.drawingShotTime = 0;
	    this.startedDate = 0;
	    this.endedDate = 0;
	    this.swingTypeConstants = swingTypeConstants;
	
	    var labelPositionY = 2;
	    var valuePositionY = labelPositionY + 12;
	    var unitPositionY = valuePositionY + 10;
	
	    this.hide();
	
	    // racket view
	    var svg = d3.select(QUERY_SHOT_RACKET_ELEMENT).append('svg').attr('preserveAspectRatio', 'xMinYMin meet').attr('viewBox', '0 0 67 67').classed('svg-content', true);
	    svg.append('image', 'g').attr('xlink:href', './res/st_movie/movie_play_racquet.png').attr('width', '100%').attr('height', '100%');
	
	    // impact point
	    this.shotsvg = svg.append('g').attr({
	      transform: function transform(d) {
	        return 'translate(' + -10 + ',' + -10 + ')';
	      }
	    });
	    this.shotsvg.append('circle').attr({
	      'r': function r(d) {
	        return 6;
	      },
	      'fill': function fill(d, i) {
	        return '#fcff35';
	      }
	    });
	
	    // shot info
	    svg = d3.select(QUERY_SHOT_INFO_ELEMENT).append('svg').attr('preserveAspectRatio', 'xMinYMin meet').attr('viewBox', '0 0 375 45').classed('svg-content', true);
	    svg.append('rect').attr({
	      'x': 0,
	      'y': 0,
	      'width': '100%',
	      'height': '100%',
	      'fill': 'black',
	      'opacity': 0.5
	    });
	
	    // swing type
	    this.swingType = svg.append('text').attr({
	      'x': '70',
	      'y': '8',
	      'fill': '#ffffff',
	      'dominant-baseline': 'text-before-edge'
	    }).classed('shot-type-value', true);
	    this.swingType.text('');
	    this.subSwingType = svg.append('text').attr({
	      'x': '70',
	      'y': '22.5',
	      'fill': '#ffffff',
	      'dominant-baseline': 'text-before-edge'
	    }).classed('shot-type-value', true);
	    this.subSwingType.text('');
	
	    // spin
	    svg.append('text').attr({
	      'x': '166',
	      'y': labelPositionY,
	      'fill': '#ffffff',
	      'dominant-baseline': 'text-before-edge'
	    }).text('ボール回転').classed('spin-label', true);
	    this.spin = svg.append('text').attr({
	      'x': '166',
	      'y': valuePositionY,
	      'fill': '#ffffff',
	      'dominant-baseline': 'text-before-edge'
	    }).classed('spin-value', true);
	    this.spin.text('0');
	
	    // swing speed
	    svg.append('text').attr({
	      'x': '222',
	      'y': labelPositionY,
	      'fill': '#ffffff',
	      'dominant-baseline': 'text-before-edge'
	    }).text('スイング速度').classed('swing-speed-label', true);
	    this.swingSpeed = svg.append('text').attr({
	      'x': '263',
	      'y': valuePositionY,
	      'fill': '#ffffff',
	      'dominant-baseline': 'text-before-edge',
	      'text-anchor': 'end'
	    }).classed('swing-speed-value', true);
	    this.swingSpeed.text('0');
	    svg.append('text').attr({
	      'x': '265',
	      'y': unitPositionY,
	      'font-size': '9',
	      'fill': '#ffffff',
	      'stroke-width': '1',
	      'dominant-baseline': 'text-before-edge'
	    }).text('km/h');
	
	    // ball speed
	    svg.append('text').attr({
	      'x': '290',
	      'y': labelPositionY,
	      'fill': '#ffffff',
	      'dominant-baseline': 'text-before-edge'
	    }).text('ボール速度').classed('ball-speed-label', true);
	    this.ballSpeed = svg.append('text').attr({
	      'x': '331',
	      'y': valuePositionY,
	      'fill': '#ffffff',
	      'dominant-baseline': 'text-before-edge',
	      'text-anchor': 'end'
	    }).classed('ball-speed-value', true);
	    this.ballSpeed.text('0');
	    svg.append('text').attr({
	      'x': '333',
	      'y': unitPositionY,
	      'font-size': '9',
	      'fill': '#ffffff',
	      'stroke-width': '1',
	      'dominant-baseline': 'text-before-edge'
	    }).text('km/h');
	  }
	
	  (0, _createClass3.default)(ShotDataView, [{
	    key: 'getImpactPoints',
	    value: function getImpactPoints() {
	      var basePoints = [[0, 4], [0, 3], [0, 2], [0, 1], [1, 5], [1, 4], [1, 3], [1, 2], [1, 1], [1, 0], [2, 5], [2, 4], [2, 3], [2, 2], [2, 1], [2, 0], [3, 5], [3, 4], [3, 3], [3, 2], [3, 1], [3, 0], [4, 4], [4, 3], [4, 2], [4, 1]];
	
	      return basePoints.map(function (point) {
	        return {
	          x: X_OFFSET + point[0] * SCALE,
	          y: Y_OFFSET + point[1] * SCALE
	        };
	      });
	    }
	  }, {
	    key: 'appendShots',
	    value: function appendShots(shots, start, end) {
	      this.startedDate = start;
	      this.endedDate = end;
	      if (!shots) {
	        console.error('shot response timing issue');
	      }
	      if (shots.length === 0) {
	        console.log('empty shot data');
	        return;
	      }
	
	      this.show();
	
	      if (end < shots[0].date || shots[shots.length - 1].date < start) {
	        console.error('video range mismatched');
	        return;
	      }
	      var startIndex = -1;
	      var endIndex = -1;
	      for (var i = 0; i < shots.length; i++) {
	        var shotDate = new Date(shots[i].shotDate).toISOString();
	        if (start < shotDate) {
	          startIndex = i;
	          break;
	        }
	      }
	      for (var j = startIndex; j < shots.length; j++) {
	        var _shotDate = new Date(shots[j].shotDate);
	        if (end < _shotDate) {
	          endIndex = j;
	          break;
	        }
	        if (j === shots.length - 1) {
	          endIndex = shots.length;
	          break;
	        }
	      }
	      this.shots = shots.slice(startIndex, endIndex);
	    }
	  }, {
	    key: 'updateShotData',
	    value: function updateShotData(time) {
	      // shot dataがない場合はなにもしない
	      if (!this.shots) {
	        return;
	      }
	      var lastShotIndex = this.shots.length - 1;
	
	      // 再生が戻った時は最初のshotから検索
	      if (time * 1000 < this.drawingShotTime) {
	        this.clearShot();
	        this.drawingShotIndex = -1;
	      }
	
	      // 動画の再生時間が次に描画するショットの時間以上になったときに、ショットデータ描画を行う
	      if (this.drawingShotIndex === lastShotIndex || time * 1000 < new Date(this.shots[this.drawingShotIndex + 1].shotDate) - new Date(this.startedDate)) {
	        return;
	      }
	
	      for (var i = this.drawingShotIndex + 1; i <= lastShotIndex; i++) {
	        var shotDate = new Date(this.shots[i].shotDate);
	        var startedDate = new Date(this.startedDate);
	        if (i === lastShotIndex || time * 1000 < new Date(this.shots[i + 1].shotDate) - startedDate) {
	          this.drawingShotIndex = i;
	          this.drawingShotTime = shotDate - startedDate;
	          this.drawShotData(this.shots[i].summaryData);
	          break;
	        }
	      }
	    }
	  }, {
	    key: 'drawShotData',
	    value: function drawShotData(shotSummaryData) {
	      var _this = this;
	
	      var swingType = this.swingTypeConstants.getLabel([shotSummaryData.swing.type]);
	      this.swingType.text(swingType.split(' ')[0]);
	      this.subSwingType.text(swingType.split(' ')[1]);
	      this.swingSpeed.text(Math.round(shotSummaryData.swing.speed));
	      this.ballSpeed.text(Math.round(shotSummaryData.impact.speed));
	      var spin = shotSummaryData.impact.spin >= 2850 ? 10 : shotSummaryData.impact.spin >= 2550 ? 9 : shotSummaryData.impact.spin >= 2250 ? 8 : shotSummaryData.impact.spin >= 1950 ? 7 : shotSummaryData.impact.spin >= 1650 ? 6 : shotSummaryData.impact.spin >= 1350 ? 5 : shotSummaryData.impact.spin >= 1050 ? 4 : shotSummaryData.impact.spin >= 750 ? 3 : shotSummaryData.impact.spin >= 450 ? 2 : shotSummaryData.impact.spin >= 150 ? 1 : shotSummaryData.impact.spin >= -150 ? 0 : shotSummaryData.impact.spin >= -450 ? -1 : shotSummaryData.impact.spin >= -750 ? -2 : shotSummaryData.impact.spin >= -1050 ? -3 : shotSummaryData.impact.spin >= -1350 ? -4 : shotSummaryData.impact.spin >= -1650 ? -5 : shotSummaryData.impact.spin >= -1950 ? -6 : shotSummaryData.impact.spin >= -2250 ? -7 : shotSummaryData.impact.spin >= -2550 ? -8 : shotSummaryData.impact.spin >= -2850 ? -9 : -10;
	      if (spin > 0) {
	        spin = '+' + spin;
	      }
	      this.spin.text(spin);
	      var spot = shotSummaryData.impact.spot;
	      this.shotsvg.attr({
	        transform: function transform(d) {
	          return 'translate(' + _this.impactPoints[spot].x + ',' + _this.impactPoints[spot].y + ')';
	        }
	      });
	    }
	  }, {
	    key: 'clearShot',
	    value: function clearShot() {
	      // impact pointの位置を再生前に戻す
	      this.shotsvg.attr({
	        transform: function transform(d) {
	          return 'translate(' + -10 + ',' + -10 + ')';
	        }
	      });
	      // 描画されたショット情報を空文字で更新
	      this.swingType.text('');
	      this.subSwingType.text('');
	      this.spin.text('0');
	      this.ballSpeed.text('0');
	      this.swingSpeed.text('0');
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      d3.select(QUERY_SHOT_INFO_ELEMENT).style({ 'visibility': 'hidden' });
	      d3.select(QUERY_SHOT_RACKET_ELEMENT).style({ 'visibility': 'hidden' });
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      d3.select(QUERY_SHOT_INFO_ELEMENT).style({ 'visibility': 'visible' });
	      d3.select(QUERY_SHOT_RACKET_ELEMENT).style({ 'visibility': 'visible' });
	    }
	  }]);
	  return ShotDataView;
	}();
	
	exports.default = ShotDataView;

/***/ },

/***/ 245:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _set = __webpack_require__(246);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _from = __webpack_require__(259);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CoachSignInController = function () {
	  /* @ngInject */
	  CoachSignInController.$inject = ["$scope", "$sessionStorage", "$location", "commonAuthFactory", "commonApiFactory", "commonFactory", "Const", "Page"];
	  function CoachSignInController($scope, $sessionStorage, $location, commonAuthFactory, commonApiFactory, commonFactory, Const, Page) {
	    (0, _classCallCheck3.default)(this, CoachSignInController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$location = $location;
	    this.commonAuthFactory = commonAuthFactory;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = false;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
	    this.$sessionStorage[this.Const.SSAPP_SMALL_HEIGHT] = 'small-height';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.$sessionStorage[this.Const.SSAPP_FULL_SCREEN_IOS] = false;
	    this.isFailed = false;
	    this.isLimit = false;
	    Page.setTitle(this.Const.TITLE.signInForStaff);
	    this.commonFactory.overlayHidden();
	    this.commonFactory.deleteErrorFlg();
	
	    var sessionRole = this.$sessionStorage[this.Const.LSAPP_ROLE];
	    var role = localStorage.getItem(this.Const.LSAPP_ROLE);
	    // Cognito Credentials
	    var userId = localStorage.getItem(this.Const.LSKEY_USER_ID);
	    var jwtToken = localStorage.getItem(this.Const.LSKEY_USER_ID_TOKEN);
	    var accessKeyId = localStorage.getItem(this.Const.LSKEY_USER_ACCESS_KEY_ID);
	    var secretAccessKey = localStorage.getItem(this.Const.LSKEY_USER_SECRET_ACCESS_KEY);
	    var sessionToken = localStorage.getItem(this.Const.LSKEY_USER_SESSION_TOKEN);
	    var refreshToken = localStorage.getItem(this.Const.LSKEY_USER_REFRESH_TOKEN);
	    var accessToken = localStorage.getItem(this.Const.LSKEY_USER_ACCESS_TOKEN);
	    var isCredential = false;
	    if (userId && jwtToken && accessKeyId && secretAccessKey && sessionToken && refreshToken && accessToken) {
	      isCredential = true;
	    }
	    if (!sessionRole && role && isCredential && role !== this.Const.LSAPP_ROLE_MEMBER) {
	      this.simplicitySignIn();
	    }
	    document.getElementById('user_id').focus();
	
	    CoachSignInController.$inject = ['$scope', '$sessionStorage', '$location', 'commonAuthFactory', 'commonApiFactory', 'commonFactory', 'Const', 'Page'];
	  }
	
	  (0, _createClass3.default)(CoachSignInController, [{
	    key: 'signIn',
	    value: function signIn() {
	      var _this = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	      this.isFailed = false;
	      this.isLimit = false;
	
	      var id = this.userId;
	      var password = this.userPass;
	      var userAuth = this.commonAuthFactory.staffLogin(id, password, null);
	      this.commonFactory.setStorage(this.Const.LSAPP_ROLE, this.Const.LSAPP_ROLE_STAFF);
	      userAuth.then(function (userCredentials) {
	        return _this.commonAuthFactory.getCredentialsForAPI(userCredentials, localStorage.getItem(_this.Const.LSAPP_ROLE));
	      }).then(function () {
	        return _this.commonApiFactory.getStaffsMe();
	      }).then(function (staff) {
	        switch (staff.role.name) {
	          case _this.Const.LSAPP_ROLE_C_ADMIN:
	            // Company Admin
	            _this.commonFactory.setStorage(_this.Const.LSAPP_ROLE, _this.Const.LSAPP_ROLE_C_ADMIN);
	            _this.$sessionStorage[_this.Const.SSAPP_COMPANY_ID] = staff.companyId;
	            _this.$location.path('/admin/school');
	            break;
	          case _this.Const.LSAPP_ROLE_S_ADMIN:
	            // School Admin
	            _this.commonFactory.setStorage(_this.Const.LSAPP_ROLE, _this.Const.LSAPP_ROLE_S_ADMIN);
	            _this.$sessionStorage[_this.Const.SSAPP_SCHOOL_ID] = staff.data.schoolId;
	            _this.$location.path('/admin');
	            break;
	          default:
	            // coach,reception
	            _this.commonFactory.setStorage(_this.Const.LSAPP_ROLE, _this.Const.LSAPP_ROLE_STAFF);
	            _this.$sessionStorage[_this.Const.SSAPP_COACH_NAME] = staff.name;
	            _this.$sessionStorage[_this.Const.SSAPP_COACH_GENDER] = staff.gender !== null ? staff.gender : 0;
	            var schoolIds = [];
	            return _this.commonApiFactory.getStaffsMeCourses().then(function (courses) {
	              courses.forEach(function (v) {
	                schoolIds.push(v.schoolId);
	              });
	              schoolIds = (0, _from2.default)(new _set2.default(schoolIds));
	              if (schoolIds.length === 0) {
	                _this.$location.path('/staff');
	              } else if (schoolIds.length === 1) {
	                _this.$sessionStorage[_this.Const.SSAPP_SCHOOL_ID] = courses[0].schoolId;
	                _this.$sessionStorage[_this.Const.SSAPP_SCHOOL_NAME] = courses[0].schoolName;
	                _this.$location.path('/staff');
	              } else {
	                // コーチに紐づくスクールが複数存在する場合はスクール一覧でスクールを選択する
	                _this.$location.path('/staff/school_list');
	              }
	            });
	        }
	      }).then(function () {
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      }).catch(function (error) {
	        console.log('error : ', error);
	        if (error) {
	          if (error.statusCode === 400 && ~error.message.indexOf('attempts exceeded')) {
	            _this.isFailed = false;
	            _this.isLimit = true;
	          } else {
	            _this.isFailed = true;
	            _this.isLimit = false;
	          }
	        } else {
	          _this.isFailed = true;
	          _this.isLimit = false;
	        }
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'simplicitySignIn',
	    value: function simplicitySignIn() {
	      var _this2 = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	      this.isFailed = false;
	      this.isLimit = false;
	
	      this.commonApiFactory.getStaffsMe().then(function (staff) {
	        switch (staff.role.name) {
	          case _this2.Const.LSAPP_ROLE_C_ADMIN:
	            // Company Admin
	            _this2.commonFactory.setStorage(_this2.Const.LSAPP_ROLE, _this2.Const.LSAPP_ROLE_C_ADMIN);
	            _this2.$sessionStorage[_this2.Const.SSAPP_COMPANY_ID] = staff.companyId;
	            _this2.$location.path('/admin/school');
	            break;
	          case _this2.Const.LSAPP_ROLE_S_ADMIN:
	            // School Admin
	            _this2.commonFactory.setStorage(_this2.Const.LSAPP_ROLE, _this2.Const.LSAPP_ROLE_S_ADMIN);
	            _this2.$sessionStorage[_this2.Const.SSAPP_SCHOOL_ID] = staff.data.schoolId;
	            _this2.$location.path('/admin');
	            break;
	          default:
	            // coach,reception
	            _this2.commonFactory.setStorage(_this2.Const.LSAPP_ROLE, _this2.Const.LSAPP_ROLE_STAFF);
	            _this2.$sessionStorage[_this2.Const.SSAPP_COACH_NAME] = staff.name;
	            _this2.$sessionStorage[_this2.Const.SSAPP_COACH_GENDER] = staff.gender !== null ? staff.gender : 0;
	            var schoolIds = [];
	            return _this2.commonApiFactory.getStaffsMeCourses().then(function (courses) {
	              courses.forEach(function (v) {
	                schoolIds.push(v.schoolId);
	              });
	              schoolIds = (0, _from2.default)(new _set2.default(schoolIds));
	              if (schoolIds.length === 0) {
	                _this2.$location.path('/staff');
	              } else if (schoolIds.length === 1) {
	                _this2.$sessionStorage[_this2.Const.SSAPP_SCHOOL_ID] = courses[0].schoolId;
	                _this2.$sessionStorage[_this2.Const.SSAPP_SCHOOL_NAME] = courses[0].schoolName;
	                _this2.$location.path('/staff');
	              } else {
	                // コーチに紐づくスクールが複数存在する場合はスクール一覧でスクールを選択する
	                _this2.$location.path('/staff/school_list');
	              }
	            });
	        }
	      }).then(function () {
	        _this2.commonFactory.overlayHidden();
	        _this2.$scope.$apply();
	      }).catch(function (error) {
	        console.log('error : ', error);
	        if (error) {
	          if (error.statusCode === 400 && ~error.message.indexOf('attempts exceeded')) {
	            _this2.isFailed = false;
	            _this2.isLimit = true;
	          } else {
	            _this2.isFailed = true;
	            _this2.isLimit = false;
	          }
	        } else {
	          _this2.isFailed = true;
	          _this2.isLimit = false;
	        }
	        _this2.commonFactory.overlayHidden();
	        _this2.$scope.$apply();
	      });
	    }
	  }]);
	  return CoachSignInController;
	}();
	
	_angular2.default.module('myApp').controller('CoachSignInController', CoachSignInController);

/***/ },

/***/ 263:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SchoolListController = function () {
	  /* @ngInject */
	  SchoolListController.$inject = ["$scope", "$sessionStorage", "$location", "commonApiFactory", "commonFactory", "Const", "Page"];
	  function SchoolListController($scope, $sessionStorage, $location, commonApiFactory, commonFactory, Const, Page) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, SchoolListController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.$location = $location;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.commonFactory.overlayHidden();
	    this.commonFactory.deleteErrorFlg();
	
	    // 当機能はstaff権限のみ
	    var role = localStorage.getItem(this.Const.LSAPP_ROLE);
	    if (role === this.Const.LSAPP_ROLE_MEMBER) {
	      this.$location.path('/member');
	    } else if (role === this.Const.LSAPP_ROLE_C_ADMIN) {
	      this.$location.path('/admin/school');
	    } else if (role === this.Const.LSAPP_ROLE_S_ADMIN) {
	      this.$location.path('/admin');
	    }
	
	    if (!navigator.onLine) {
	      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	      return;
	    } else {
	      this.commonFactory.overlayShow();
	    }
	
	    this.schoolList = [];
	    this.commonApiFactory.getStaffsMeCourses().then(function (courses) {
	      if (courses.length === 0) {
	        _this.$location.path('/staff');
	        return;
	      }
	
	      // course情報からschool情報を生成
	      var schools = [];
	      courses.forEach(function (v) {
	        var school = {
	          schoolId: v.schoolId,
	          schoolName: v.schoolName
	        };
	        schools.push(school);
	      });
	      // 生成したschool情報の重複分を削除
	      _this.schoolList = schools.filter(function (v1, i, arr) {
	        return arr.findIndex(function (v2) {
	          return v1.schoolId === v2.schoolId;
	        }) === i;
	      });
	
	      if (_this.schoolList.length > 0) {
	        _this.$sessionStorage[_this.Const.SSAPP_SCHOOL_ID] = _this.schoolList[0].schoolId;
	        _this.$sessionStorage[_this.Const.SSAPP_SCHOOL_NAME] = _this.schoolList[0].schoolName;
	        if (_this.schoolList.length === 1) {
	          _this.$location.path('/staff');
	          return;
	        }
	      }
	
	      _this.commonFactory.overlayHidden();
	      _this.$scope.$apply();
	    }).catch(function (error) {
	      console.error('error : ', error);
	      _this.commonFactory.overlayHidden();
	      _this.$scope.$apply();
	    });
	
	    SchoolListController.$inject = ['$scope', '$sessionStorage', '$location', 'commonApiFactory', 'commonFactory', 'Const', 'Page'];
	  }
	
	  (0, _createClass3.default)(SchoolListController, [{
	    key: 'toCoachTop',
	    value: function toCoachTop(school) {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID] = school.schoolId;
	      this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME] = school.schoolName;
	      this.$location.path('/staff');
	    }
	  }]);
	  return SchoolListController;
	}();
	
	_angular2.default.module('myApp').controller('SchoolListController', SchoolListController);

/***/ },

/***/ 264:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(188);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _moment = __webpack_require__(59);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CoachTopController = function () {
	  /* @ngInject */
	  CoachTopController.$inject = ["$scope", "$sessionStorage", "$location", "commonApiFactory", "commonFactory", "Const", "Page"];
	  function CoachTopController($scope, $sessionStorage, $location, commonApiFactory, commonFactory, Const, Page) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, CoachTopController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.$location = $location;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.commonFactory.overlayHidden();
	    this.commonFactory.deleteErrorFlg();
	    this.$sessionStorage[this.Const.SSAPP_ADMIN_COURSE_LIST_LOCATION] = '';
	
	    var role = localStorage.getItem(this.Const.LSAPP_ROLE);
	    if (role === this.Const.LSAPP_ROLE_MEMBER) {
	      this.$location.path('/member');
	    } else if (role === this.Const.LSAPP_ROLE_C_ADMIN) {
	      this.$location.path('/admin/school');
	    } else if (role === this.Const.LSAPP_ROLE_S_ADMIN) {
	      this.$location.path('/admin');
	    }
	
	    if (!navigator.onLine) {
	      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	      return;
	    } else {
	      this.commonFactory.overlayShow();
	    }
	
	    var today = new Date();
	    this.currentDate = today;
	    this.monthRange = this.commonFactory.getMonthRange(today);
	    this.selectedYearMonth = (0, _moment2.default)().format('YYYY年M月');
	    this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;
	
	    // 画面に表示するリスト
	    this.courseList = [];
	    // 全データ格納用リスト
	    this.allList = [];
	    this.commonApiFactory.getStaffsMeCourses().then(function (result) {
	      return result.forEach(function (d) {
	        if (d.schoolId === _this.$sessionStorage[_this.Const.SSAPP_SCHOOL_ID]) {
	          _this.allList.push(d);
	        }
	      });
	    }).then(function () {
	      var that = _this;
	      // 表示の基準となる期間を取得
	      var begin = _this.monthRange.beginDateParam;
	      var end = _this.monthRange.endDateParam;
	      return _this.squeezeCourse(that, begin, end);
	    }).then(function () {
	      _this.existenceFlg = true;
	      _this.commonFactory.overlayHidden();
	      _this.$scope.$apply();
	    }).catch(function (error) {
	      _this.existenceFlg = false;
	      console.error('error : ', error);
	      _this.commonFactory.overlayHidden();
	      _this.$scope.$apply();
	    });
	
	    Page.setTitle(this.Const.TITLE.topForStaff);
	
	    CoachTopController.$inject = ['$scope', '$sessionStorage', '$location', 'commonApiFactory', 'commonFactory', 'Const', 'Page'];
	  }
	
	  // 指定された期間に該当するコースを絞る
	
	
	  (0, _createClass3.default)(CoachTopController, [{
	    key: 'squeezeCourse',
	    value: function squeezeCourse(that, begin, end) {
	      return new _promise2.default(function (resolve, reject) {
	        that.allList.forEach(function (d) {
	          // コースの期間を変換
	          var courseStart = new Date(d.startedDate);
	          var courseEnd = new Date(d.endedDate);
	          courseStart = courseStart.toISOString();
	          courseEnd = courseEnd.toISOString();
	          // 表示対象を絞る
	          if (courseStart < begin && courseEnd > end) {
	            var courseObj = {
	              schoolName: d.schoolName,
	              courseId: d.id,
	              courseName: d.name
	            };
	            that.courseList.push(courseObj);
	          } else if (courseEnd >= begin && courseEnd <= end) {
	            var _courseObj = {
	              schoolName: d.schoolName,
	              courseId: d.id,
	              courseName: d.name
	            };
	            that.courseList.push(_courseObj);
	          } else if (courseStart >= begin && courseStart <= end) {
	            var _courseObj2 = {
	              schoolName: d.schoolName,
	              courseId: d.id,
	              courseName: d.name
	            };
	            that.courseList.push(_courseObj2);
	          }
	          that.$sessionStorage[that.Const.SSAPP_COURSE_LIST] = that.courseList;
	        });
	        if (that.courseList.length > 0) {
	          return resolve();
	        } else {
	          return reject();
	        }
	      });
	    }
	  }, {
	    key: 'toCourseDetail',
	    value: function toCourseDetail(obj, idx) {
	      this.$sessionStorage[this.Const.SSAPP_COURSE_INDEX] = idx;
	      this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME] = obj.schoolName;
	      // 次の画面でコースを受講している生徒を取得するために必要
	      this.$sessionStorage[this.Const.SSAPP_COURSE_ID] = obj.courseId;
	      this.$location.path('/staff/course');
	    }
	
	    // 基準からみて次の月に該当するコースを表示する
	
	  }, {
	    key: 'toNextMonth',
	    value: function toNextMonth() {
	      var _this2 = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	
	      var currentDate = this.currentDate;
	      var nextMonthRnage = this.commonFactory.getMonthLater(currentDate);
	      // 次の月を基準とする
	      this.currentDate = new Date(nextMonthRnage.beginDateParam);
	      this.selectedYearMonth = (0, _moment2.default)(this.currentDate).format('YYYY年M月');
	      this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;
	      var that = this;
	      var begin = nextMonthRnage.beginDateParam;
	      var end = nextMonthRnage.endDateParam;
	      this.courseList = [];
	      this.squeezeCourse(that, begin, end).then(function () {
	        _this2.existenceFlg = true;
	        _this2.$scope.$apply();
	      }).catch(function () {
	        _this2.existenceFlg = false;
	        _this2.$scope.$apply();
	      });
	    }
	
	    // 基準からみて前の月に該当するコースを表示する
	
	  }, {
	    key: 'tobeforeMonth',
	    value: function tobeforeMonth() {
	      var _this3 = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	
	      var currentDate = this.currentDate;
	      var beforeMonthRnage = this.commonFactory.getMonthAgo(currentDate);
	      // 前の月を基準とする
	      this.currentDate = new Date(beforeMonthRnage.beginDateParam);
	      this.selectedYearMonth = (0, _moment2.default)(this.currentDate).format('YYYY年M月');
	      this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;
	      var that = this;
	      var begin = beforeMonthRnage.beginDateParam;
	      var end = beforeMonthRnage.endDateParam;
	      this.courseList = [];
	      this.squeezeCourse(that, begin, end).then(function () {
	        _this3.existenceFlg = true;
	        _this3.$scope.$apply();
	      }).catch(function () {
	        _this3.existenceFlg = false;
	        _this3.$scope.$apply();
	      });
	    }
	
	    // 全クラス一覧ボタン押下
	
	  }, {
	    key: 'toCourseListAll',
	    value: function toCourseListAll() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$sessionStorage[this.Const.SSAPP_SELECTED_DATE] = this.currentDate;
	      this.$sessionStorage[this.Const.SSAPP_ADMIN_COURSE_LIST_LOCATION] = this.Const.ADMIN_COURSE_LIST_LOCATION.coachTop;
	      this.$location.path('/admin/course');
	    }
	
	    // ゲスト動画一覧ボタン押下
	
	  }, {
	    key: 'toGuestDetailList',
	    value: function toGuestDetailList() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$location.path('/staff/guest_video');
	    }
	
	    // 動画公開状況ボタン押下
	
	  }, {
	    key: 'toVideoBacklog',
	    value: function toVideoBacklog() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$location.path('/staff/video_backlog');
	    }
	  }]);
	  return CoachTopController;
	}();
	
	_angular2.default.module('myApp').controller('CoachTopController', CoachTopController);

/***/ },

/***/ 265:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GuestVideoController = function () {
	  /* @ngInject */
	  GuestVideoController.$inject = ["$scope", "$sessionStorage", "$rootScope", "$location", "commonApiFactory", "commonFactory", "Const", "Page"];
	  function GuestVideoController($scope, $sessionStorage, $rootScope, $location, commonApiFactory, commonFactory, Const, Page) {
	    (0, _classCallCheck3.default)(this, GuestVideoController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$location = $location;
	    this.$sessionStorage = $sessionStorage;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.commonFactory.overlayHidden();
	    this.commonFactory.deleteErrorFlg();
	    this.targetId = '';
	
	    if (localStorage.getItem(this.Const.LSAPP_ROLE) === this.Const.LSAPP_ROLE_MEMBER) {
	      this.$location.path('/member');
	    }
	    Page.setTitle(this.Const.TITLE.guestVideo);
	
	    this.videoList = [];
	    this.$rootScope.videoList = this.videoList;
	    this.existsGuestVideo = false;
	
	    if (!navigator.onLine) {
	      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	      return;
	    } else {
	      this.commonFactory.overlayShow();
	    }
	    // 権限がstaff、遷移元がゲスト動画画面、sessionにmemberIdとvideoIdを持っている場合、動画移動処理実施
	    if (this.$sessionStorage[this.Const.SSAPP_ADMIN_COURSE_LIST_LOCATION] === this.Const.ADMIN_COURSE_LIST_LOCATION.guestVideo && this.$sessionStorage[this.Const.SSAPP_MEMBER_ID_MOVE_TO_MEMBER] && this.$sessionStorage[this.Const.SSAPP_VIDEO_ID_MOVE_TO_MEMBER]) {
	      this.getGuestVideosAfterMoveToMember();
	    } else {
	      this.getGuestVideos();
	    }
	
	    GuestVideoController.$inject = ['$scope', '$sessionStorage', '$rootScope', '$location', 'commonApiFactory', 'commonFactory', 'Const', 'Page'];
	  }
	
	  (0, _createClass3.default)(GuestVideoController, [{
	    key: 'getGuestVideos',
	    value: function getGuestVideos() {
	      var _this = this;
	
	      var reqParams = {
	        schoolId: this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID],
	        limit: '',
	        beginDateTime: '',
	        order: 'desc',
	        url: ''
	      };
	      this.commonApiFactory.getSchoolsSchoolIdVideos(reqParams).then(function (videos) {
	        videos.forEach(function (video) {
	          if (video == null) {
	            return;
	          }
	          // ゲスト動画はschoolIdが指定されている
	          if (video.schoolId !== null) {
	            _this.videoList.push(video);
	          }
	        });
	        _this.existsGuestVideo = _this.videoList.length > 0;
	        if (!_this.existsGuestVideo) {
	          _this.videoList.push({});
	        }
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'getGuestVideosAfterMoveToMember',
	    value: function getGuestVideosAfterMoveToMember() {
	      var _this2 = this;
	
	      var reqParams = {
	        memberId: this.$sessionStorage[this.Const.SSAPP_MEMBER_ID_MOVE_TO_MEMBER],
	        sourceVideoId: this.$sessionStorage[this.Const.SSAPP_VIDEO_ID_MOVE_TO_MEMBER]
	      };
	      var reqBody = {};
	      this.commonApiFactory.postMembersVideosByVideoId(reqParams, reqBody).then(function (res) {
	        // 生徒動画を登録したのでゲスト動画を削除する
	        var deleteVideoParams = {
	          videoId: _this2.$sessionStorage[_this2.Const.SSAPP_VIDEO_ID_MOVE_TO_MEMBER]
	        };
	        return _this2.commonApiFactory.deleteVideosVideoId(deleteVideoParams);
	      }).then(function () {
	        // 削除後のゲスト動画一覧を取得する
	        return _this2.getGuestVideos();
	      }).then(function () {
	        _this2.commonFactory.flashErrorMessageFlag(_this2.Const.SSAPP_MOVE_VIDEO_TO_MEMBER_COMPLETE, 3000, false);
	        _this2.$sessionStorage[_this2.Const.SSAPP_ADMIN_COURSE_LIST_LOCATION] = '';
	        _this2.$sessionStorage[_this2.Const.SSAPP_MEMBER_ID_MOVE_TO_MEMBER] = '';
	        _this2.$sessionStorage[_this2.Const.SSAPP_VIDEO_ID_MOVE_TO_MEMBER] = '';
	      });
	    }
	  }, {
	    key: 'removeVideo',
	    value: function removeVideo(index) {
	      this.videoList.splice(index, 1);
	      this.existsGuestVideo = this.videoList.length > 0;
	      if (!this.existsGuestVideo) {
	        this.videoList.push({});
	      }
	      this.$scope.$apply();
	    }
	  }]);
	  return GuestVideoController;
	}();
	
	_angular2.default.module('myApp').controller('GuestVideoController', GuestVideoController);

/***/ },

/***/ 266:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(188);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CourseDetailController = function () {
	  /* @ngInject */
	  CourseDetailController.$inject = ["$scope", "$sessionStorage", "$location", "commonApiFactory", "commonFactory", "Const", "Page"];
	  function CourseDetailController($scope, $sessionStorage, $location, commonApiFactory, commonFactory, Const, Page) {
	    (0, _classCallCheck3.default)(this, CourseDetailController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.$location = $location;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.commonFactory.overlayHidden();
	    this.commonFactory.deleteErrorFlg();
	
	    if (localStorage.getItem(this.Const.LSAPP_ROLE) === this.Const.LSAPP_ROLE_MEMBER) {
	      this.$location.path('/member');
	    }
	    if (!this.$sessionStorage[this.Const.SSAPP_COURSE_ID]) {
	      this.$location.path('/staff');
	    }
	
	    if (!navigator.onLine) {
	      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	      return;
	    }
	
	    // 前画面で表示されるコース一覧を取得
	    this.courseList = this.$sessionStorage[this.Const.SSAPP_COURSE_LIST];
	    // 現在表示されている生徒一覧が、取得したコース一覧の何番目のものかを判別する
	    this.currentIdx = this.$sessionStorage[this.Const.SSAPP_COURSE_INDEX];
	    // 一番最後のコースを選択した場合、'>'を隠すために取得
	    this.courseListLength = this.courseList.length - 1;
	    if (this.currentIdx === this.courseListLength) {
	      this.maxFlg = true;
	    } else {
	      this.maxFlg = false;
	    }
	    // APIからのデータ取得が完了したか判定する
	    this.getDataFin = false;
	
	    // 表示する校名/クラス名
	    this.displaySchoolName = this.courseList[this.currentIdx].schoolName;
	    this.displayCourseName = this.courseList[this.currentIdx].courseName;
	
	    // 表示する生徒の一覧
	    this.memberList = [];
	    // APIから取得した生徒が存在している場合：true
	    // APIから取得した生徒が存在していない場合：false
	    this.existenceFlg = true;
	
	    // 選択したコースのID
	    var currentCourseId = this.$sessionStorage[this.Const.SSAPP_COURSE_ID];
	    var getCoursesCourseIdMembersParams = {
	      courseId: currentCourseId
	    };
	    this.getCoursesCourseIdMembers(getCoursesCourseIdMembersParams);
	
	    Page.setTitle(this.Const.TITLE.memberList);
	
	    CourseDetailController.$inject = ['$scope', '$sessionStorage', '$location', 'commonApiFactory', 'commonFactory', 'Const', 'Page'];
	  }
	
	  (0, _createClass3.default)(CourseDetailController, [{
	    key: 'getCoursesCourseIdMembers',
	    value: function getCoursesCourseIdMembers(params) {
	      var _this = this;
	
	      this.commonFactory.overlayShow();
	      this.commonApiFactory.getCoursesCourseIdMembers(params).then(function (result) {
	        return new _promise2.default(function (resolve) {
	          if (result.length === 0) {
	            _this.existenceFlg = false;
	            return resolve();
	          }
	          result.forEach(function (d) {
	            var memberObj = {
	              id: d.id,
	              name: d.name,
	              gender: d.gender,
	              imagePath: ''
	            };
	            var imgPath = void 0;
	            switch (d.gender) {
	              case _this.Const.GENDER_TYPE.male:
	                imgPath = 'res/st_top/common_icon_user_male.png';
	                break;
	              case _this.Const.GENDER_TYPE.female:
	                imgPath = 'res/st_top/common_icon_user_female.png';
	                break;
	              default:
	                imgPath = 'res/st_top/common_icon_user_default.png';
	            }
	            memberObj.imagePath = imgPath;
	            _this.memberList.push(memberObj);
	          });
	          _this.existenceFlg = true;
	          return resolve();
	        });
	      }).then(function () {
	        _this.getDataFin = true;
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      }).catch(function (error) {
	        console.error('error : ', error);
	        _this.existenceFlg = false;
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'toMemberDetail',
	    value: function toMemberDetail(obj) {
	      // 遷移元がゲスト動画、sessionにvideoIdを持っている場合動画移動処理実施
	      if (this.$sessionStorage[this.Const.SSAPP_ADMIN_COURSE_LIST_LOCATION] === this.Const.ADMIN_COURSE_LIST_LOCATION.guestVideo && this.$sessionStorage[this.Const.SSAPP_VIDEO_ID_MOVE_TO_MEMBER]) {
	        this.$sessionStorage[this.Const.SSAPP_MEMBER_ID_MOVE_TO_MEMBER] = obj.id;
	        this.$location.path('/staff/guest_video');
	      } else {
	        this.$sessionStorage[this.Const.SSAPP_MEMBER_ID] = obj.id;
	        this.$sessionStorage[this.Const.SSAPP_USER_NAME] = obj.name;
	        this.$sessionStorage[this.Const.SSAPP_GENDER] = obj.gender;
	        this.$location.path('/staff/member_detail');
	      }
	    }
	
	    // 現在選択されているコースより、
	    // 前画面で一つ下に表示されていたコースの生徒一覧を表示する
	
	  }, {
	    key: 'toNextCourseDetail',
	    value: function toNextCourseDetail() {
	      this.getDataFin = false;
	      // 表示されている生徒一覧をクリア
	      this.memberList = [];
	      this.currentIdx = this.currentIdx + 1;
	      this.setCourseDetail();
	    }
	
	    // 現在選択されているコースより、
	    // 前画面で一つ上に表示されていたコースの生徒一覧を表示する
	
	  }, {
	    key: 'toBeforeCourseDetail',
	    value: function toBeforeCourseDetail() {
	      this.getDataFin = false;
	      // '>'を表示させる
	      this.maxFlg = false;
	      // 表示されている生徒一覧をクリア
	      this.memberList = [];
	      this.currentIdx = this.currentIdx - 1;
	      this.setCourseDetail();
	    }
	  }, {
	    key: 'setCourseDetail',
	    value: function setCourseDetail() {
	      var currentCourse = this.courseList[this.currentIdx];
	      var currentCourseId = currentCourse.courseId;
	      var currentSchoolName = currentCourse.schoolName;
	      var currentCourseName = currentCourse.courseName;
	      if (this.currentIdx === this.courseListLength) {
	        this.maxFlg = true;
	      } else {
	        this.maxFlg = false;
	      }
	      this.$sessionStorage[this.Const.SSAPP_COURSE_INDEX] = this.currentIdx;
	      this.$sessionStorage[this.Const.SSAPP_COURSE_ID] = currentCourseId;
	      this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME] = currentSchoolName;
	      // 表示する校名/クラス名
	      this.displaySchoolName = currentSchoolName;
	      this.displayCourseName = currentCourseName;
	      var getCoursesCourseIdMembersParams = {
	        courseId: currentCourseId
	      };
	      this.getCoursesCourseIdMembers(getCoursesCourseIdMembersParams);
	    }
	  }]);
	  return CourseDetailController;
	}();
	
	_angular2.default.module('myApp').controller('CourseDetailController', CourseDetailController);

/***/ },

/***/ 267:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _moment = __webpack_require__(59);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COURSE_MEMBER_PATH = '/staff/course';
	var SCHOOL_MEMBER_PATH = '/admin/member';
	var VIDEO_BACKLOG_PATH = '/staff/video_backlog';
	
	var MemberDetailController = function () {
	  /* @ngInject */
	  MemberDetailController.$inject = ["$scope", "$sessionStorage", "$rootScope", "$location", "$timeout", "commonApiFactory", "commonFactory", "Const", "Page"];
	  function MemberDetailController($scope, $sessionStorage, $rootScope, $location, $timeout, commonApiFactory, commonFactory, Const, Page) {
	    (0, _classCallCheck3.default)(this, MemberDetailController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$location = $location;
	    this.$timeout = $timeout;
	    this.$sessionStorage = $sessionStorage;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.commonFactory.overlayHidden();
	    this.commonFactory.deleteErrorFlg();
	
	    if (localStorage.getItem(this.Const.LSAPP_ROLE) === this.Const.LSAPP_ROLE_MEMBER) {
	      this.$location.path('/member');
	    }
	
	    if (!this.$sessionStorage[this.Const.SSAPP_MEMBER_ID]) {
	      this.$location.path('/course');
	    }
	
	    this.getMemberIdMessages();
	
	    Page.setTitle(this.Const.TITLE.memberDetail);
	
	    this.videoList = [];
	    this.$rootScope.videoList = this.videoList;
	    this.getMemberIdVideos();
	
	    var oldLocation = this.$sessionStorage[this.Const.SSAPP_OLD_LOCATION];
	    if (oldLocation === SCHOOL_MEMBER_PATH) {
	      this.$sessionStorage[this.Const.SSAPP_BREAD_CRUMB_PATTERN] = 0;
	    } else if (oldLocation === COURSE_MEMBER_PATH) {
	      this.$sessionStorage[this.Const.SSAPP_BREAD_CRUMB_PATTERN] = 1;
	    } else if (oldLocation === VIDEO_BACKLOG_PATH) {
	      this.$sessionStorage[this.Const.SSAPP_BREAD_CRUMB_PATTERN] = 2;
	    }
	
	    MemberDetailController.$inject = ['$scope', '$sessionStorage', '$rootScope', '$location', '$timeout', 'commonApiFactory', 'commonFactory', 'Const', 'Page'];
	  }
	
	  (0, _createClass3.default)(MemberDetailController, [{
	    key: 'getMemberIdMessages',
	    value: function getMemberIdMessages() {
	      var _this = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	
	      var getMembersMemberIdMessagesParams = {
	        memberId: this.$sessionStorage[this.Const.SSAPP_MEMBER_ID],
	        type: 1
	      };
	      this.commonApiFactory.getMembersMemberIdMessages(getMembersMemberIdMessagesParams).then(function (result) {
	        _this.messageList = [];
	        result.forEach(function (message) {
	          // 一時保存中のメッセージは表出対象から除外する
	          if (!message['data']['isUnpublished']) {
	            var messageObj = {
	              message: message['data']['message'],
	              displayYear: (0, _moment2.default)(message['createdAt']).format('YYYY'),
	              displayMonth: (0, _moment2.default)(message['createdAt']).format('MM'),
	              displayDate: (0, _moment2.default)(message['createdAt']).format('DD')
	            };
	            _this.messageList.push(messageObj);
	          }
	        });
	        // リストを反転し最初のメッセージ(現在のテーマ)を削除
	        _this.messageList.reverse();
	        _this.messageList.shift();
	        _this.$timeout(function () {
	          _this.commonFactory.overlayHidden();
	        }, 2200);
	        _this.$scope.$apply();
	      }).catch(function (error) {
	        console.error(error);
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'toMemberTop',
	    value: function toMemberTop() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$location.path('/member');
	    }
	  }, {
	    key: 'getMemberIdVideos',
	    value: function getMemberIdVideos() {
	      var _this2 = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	      var reqParams = {
	        memberId: this.$sessionStorage[this.Const.SSAPP_MEMBER_ID],
	        limit: '',
	        beginDateTime: '',
	        order: 'desc',
	        url: ''
	      };
	      this.commonApiFactory.getMembersMemberIdVideos(reqParams).then(function (videos) {
	        videos.forEach(function (video) {
	          if (video == null) {
	            return;
	          }
	          // アップロード済みの動画のみ表示
	          if (video.state & _this2.Const.VIDEO_STATE_FLAG.uploaded) {
	            _this2.videoList.push(video);
	          }
	        });
	        if (_this2.videoList.length === 0) {
	          _this2.videoList.push({});
	        }
	        _this2.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'removeVideo',
	    value: function removeVideo(index) {
	      this.videoList.splice(index, 1);
	      if (this.videoList.length === 0) {
	        this.videoList.push({});
	      }
	      this.$scope.$apply();
	    }
	  }, {
	    key: 'addVideoUploadForm',
	    value: function addVideoUploadForm() {
	      this.videoList.push({});
	    }
	  }]);
	  return MemberDetailController;
	}();
	
	_angular2.default.module('myApp').controller('MemberDetailController', MemberDetailController);

/***/ },

/***/ 268:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getIterator2 = __webpack_require__(230);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideoBacklogController = function () {
	  /* @ngInject */
	  VideoBacklogController.$inject = ["$scope", "$sessionStorage", "$location", "commonApiFactory", "commonFactory", "Const", "Page"];
	  function VideoBacklogController($scope, $sessionStorage, $location, commonApiFactory, commonFactory, Const, Page) {
	    (0, _classCallCheck3.default)(this, VideoBacklogController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.$location = $location;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.commonFactory.deleteErrorFlg();
	    this.schoolName = '';
	    this.waitingForPreviewCountSummary = '';
	    this.waitingForPublicationCountSummary = '';
	    this.guestVideoCountSummary = '';
	    this.existenceFlg = true;
	    this.memberList = [];
	
	    var role = localStorage.getItem(this.Const.LSAPP_ROLE);
	    if (role === this.Const.LSAPP_ROLE_MEMBER) {
	      this.$location.path('/member');
	    }
	
	    this.getMemberVideoBacklog();
	
	    Page.setTitle(this.Const.TITLE.videoBacklog);
	
	    VideoBacklogController.$inject = ['$scope', '$sessionStorage', '$location', 'commonApiFactory', 'commonFactory', 'Const', 'Page'];
	  }
	
	  (0, _createClass3.default)(VideoBacklogController, [{
	    key: 'getMemberVideoBacklog',
	    value: function getMemberVideoBacklog() {
	      var _this = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	      var reqParams = {
	        schoolId: this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID]
	      };
	      return this.commonApiFactory.getSchoolsSchoolIdMembersVideosBacklogsMembers(reqParams).then(function (backlog) {
	        if (!backlog) return;
	
	        _this.schoolName = _this.$sessionStorage[_this.Const.SSAPP_SCHOOL_NAME];
	        _this.waitingForPreviewCountSummary = backlog.videoSummary.waitingForPreviewCount;
	        _this.waitingForPublicationCountSummary = backlog.videoSummary.waitingForPublicationCount;
	        _this.existenceFlg = backlog.members && backlog.members.length > 0;
	
	        backlog.members.forEach(function (member) {
	          var statusList = [_this.Const.VIDEO_BACKLOG.public, _this.Const.VIDEO_BACKLOG.preview];
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            var _loop = function _loop() {
	              var status = _step.value;
	
	              var countLabel = status === _this.Const.VIDEO_BACKLOG.public ? 'waitingForPublicationCount' : 'waitingForPreviewCount';
	              for (var i = 0; i < member.videoSummary[countLabel]; i++) {
	                if (member.courses.length !== 0) {
	                  member.courses.forEach(function (course) {
	                    _this.createViewList(status, member, course);
	                  });
	                } else {
	                  _this.createViewList(status, member, null);
	                }
	              }
	            };
	
	            for (var _iterator = (0, _getIterator3.default)(statusList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              _loop();
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          _this.sortViewList(_this.memberList);
	        });
	        return _this.commonApiFactory.getSchoolsSchoolIdVideosSummary(reqParams);
	      }).then(function (res) {
	        _this.guestVideoCountSummary = res.guestVideoCount;
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      }).catch(function (error) {
	        console.log(error);
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'createViewList',
	    value: function createViewList(status, member, course) {
	      var viewData = {
	        status: status,
	        statusLabel: this.Const.VIDEO_BACKLOG_LABEL[status],
	        genderImagePath: this.getMemberGenderImagePath(member.gender),
	        id: member.id,
	        name: member.name,
	        courseSubDisplayId: course ? course.subDisplayId : '',
	        courseName: course ? course.name : '',
	        staffName: course ? this.getStaffName(course.staffs) : ''
	      };
	      this.memberList.push(viewData);
	    }
	  }, {
	    key: 'sortViewList',
	    value: function sortViewList(list) {
	      list.sort(function (a, b) {
	        if (a.courseSubDisplayId === '') return 1;
	        if (b.courseSubDisplayId === '') return -1;
	        if (a.courseSubDisplayId > b.courseSubDisplayId) return 1;
	        if (a.courseSubDisplayId < b.courseSubDisplayId) return -1;
	      });
	    }
	  }, {
	    key: 'getStaffName',
	    value: function getStaffName(staffs) {
	      // Array.prototype.find() は古いブラウザでは使えない
	      var staff = staffs.filter(function (v) {
	        return v.type === 1;
	      })[0];
	      return staff ? staff.name : '';
	    }
	  }, {
	    key: 'getMemberGenderImagePath',
	    value: function getMemberGenderImagePath(gender) {
	      switch (gender) {
	        case this.Const.GENDER_TYPE.male:
	          return 'res/st_top/common_icon_user_male.png';
	        case this.Const.GENDER_TYPE.female:
	          return 'res/st_top/common_icon_user_female.png';
	        default:
	          return 'res/st_top/common_icon_user_default.png';
	      }
	    }
	  }, {
	    key: 'toMemberDetail',
	    value: function toMemberDetail(member) {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$sessionStorage[this.Const.SSAPP_MEMBER_ID] = member.id;
	      this.$sessionStorage[this.Const.SSAPP_USER_NAME] = member.name;
	      this.$sessionStorage[this.Const.SSAPP_GENDER] = member.gender;
	      this.$location.path('/staff/member_detail');
	    }
	  }, {
	    key: 'toGuestVideoList',
	    value: function toGuestVideoList() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$location.path('/staff/guest_video');
	    }
	  }]);
	  return VideoBacklogController;
	}();
	
	_angular2.default.module('myApp').controller('VideoBacklogController', VideoBacklogController);

/***/ },

/***/ 269:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMPONENT_NAME = 'dialogAdvertise';
	
	var DialogAdvertise =
	/* @ngInject */
	["Resource", function DialogAdvertise(Resource) {
	  (0, _classCallCheck3.default)(this, DialogAdvertise);
	
	  this.Resource = Resource;
	  DialogAdvertise.$inject = ['Resource'];
	}];
	
	_angular2.default.module('myApp').component(COMPONENT_NAME, {
	  bindings: {
	    name: '@' + COMPONENT_NAME
	  },
	  controller: DialogAdvertise,
	  templateUrl: 'app/components/dialog/advertise/dialog-advertise.template.html'
	});

/***/ },

/***/ 270:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMPONENT_NAME = 'dialogInterimPassword';
	
	var DialogInterimPassword = function () {
	  /* @ngInject */
	  DialogInterimPassword.$inject = ["$rootScope", "$scope", "$sessionStorage", "$location", "commonApiFactory", "commonFactory", "Const"];
	  function DialogInterimPassword($rootScope, $scope, $sessionStorage, $location, commonApiFactory, commonFactory, Const) {
	    (0, _classCallCheck3.default)(this, DialogInterimPassword);
	
	    this.Const = Const;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$location = $location;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    DialogInterimPassword.$inject = ['$rootScope', '$scope', '$sessionStorage', '$location', 'commonApiFactory', 'commonFactory', 'Const'];
	  }
	
	  // TODO: password reset
	
	
	  (0, _createClass3.default)(DialogInterimPassword, [{
	    key: 'resetPassword',
	    value: function resetPassword() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      console.log(this.$rootScope.password + ' にresetします。');
	      var url = window.location.href;
	      var fromScreen = ~url.indexOf('/admin/school') ? this.Const.ADMIN_SCREEN_TYPE.schoolList : ~url.indexOf('/admin/coach') ? this.Const.ADMIN_SCREEN_TYPE.coachList : ~url.indexOf('/admin/member') ? this.Const.ADMIN_SCREEN_TYPE.memberList : this.Const.ADMIN_SCREEN_TYPE.unknown;
	
	      // 遷移元画面によって関数を呼び分ける
	      switch (fromScreen) {
	        case this.Const.ADMIN_SCREEN_TYPE.schoolList:
	          this.postCompaniesMeSchoolsSchoolIdAdminPasswordReset();
	          break;
	        case this.Const.ADMIN_SCREEN_TYPE.coachList:
	          this.postSchoolsSchoolIdStaffsStaffIdPasswordReset();
	          break;
	        case this.Const.ADMIN_SCREEN_TYPE.memberList:
	          this.postSchoolsSchoolIdMembersMemberIdPasswordReset();
	          break;
	        default:
	        // unknown...
	      }
	    }
	
	    // company Adminがschool Adminの仮パスワードを発行するためのAPI
	
	  }, {
	    key: 'postCompaniesMeSchoolsSchoolIdAdminPasswordReset',
	    value: function postCompaniesMeSchoolsSchoolIdAdminPasswordReset() {
	      var _this = this;
	
	      var params = { schoolId: this.$rootScope.targetId };
	      var bodies = { temporaryPassword: this.$rootScope.password };
	      this.commonApiFactory.postAdminCompaniesMeSchoolsSchoolIdAdminPasswordReset(params, bodies).then(function (result) {
	        // OK
	      }).catch(function (error) {
	        console.log('error : ', error);
	        _this.commonFactory.flashErrorMessageFlag(_this.Const.SSAPP_HAS_UNEXPECTED_ERROR, 5000, false);
	      });
	    }
	
	    // School Adminがコーチの仮パスワードを発行するためのAPI
	
	  }, {
	    key: 'postSchoolsSchoolIdStaffsStaffIdPasswordReset',
	    value: function postSchoolsSchoolIdStaffsStaffIdPasswordReset() {
	      var _this2 = this;
	
	      var params = { staffId: this.$rootScope.targetId, schoolId: this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID] };
	      var bodies = { temporaryPassword: this.$rootScope.password };
	      this.commonApiFactory.postAdminSchoolsSchoolIdStaffsStaffIdPasswordReset(params, bodies).then(function (result) {
	        // OK
	      }).catch(function (error) {
	        console.log('error : ', error);
	        _this2.commonFactory.flashErrorMessageFlag(_this2.Const.SSAPP_HAS_UNEXPECTED_ERROR, 5000, false);
	      });
	    }
	
	    // School Adminが生徒の仮パスワードを発行するためのAPI
	
	  }, {
	    key: 'postSchoolsSchoolIdMembersMemberIdPasswordReset',
	    value: function postSchoolsSchoolIdMembersMemberIdPasswordReset() {
	      var _this3 = this;
	
	      var params = { memberId: this.$rootScope.targetId, schoolId: this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID] };
	      var bodies = { temporaryPassword: this.$rootScope.password };
	      this.commonApiFactory.postAdminSchoolsSchoolIdMembersMemberIdPasswordReset(params, bodies).then(function (result) {
	        // OK
	      }).catch(function (error) {
	        console.log('error : ', error);
	        _this3.commonFactory.flashErrorMessageFlag(_this3.Const.SSAPP_HAS_UNEXPECTED_ERROR, 5000, false);
	      });
	    }
	  }]);
	  return DialogInterimPassword;
	}();
	
	_angular2.default.module('myApp').component(COMPONENT_NAME, {
	  bindings: {
	    name: '@' + COMPONENT_NAME
	  },
	  controller: DialogInterimPassword,
	  templateUrl: 'app/components/dialog/interim-password/dialog-interim-password.template.html'
	});

/***/ },

/***/ 271:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(188);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMPONENT_NAME = 'dialogSelectShot';
	
	var DialogSelectShot = function () {
	  /* @ngInject */
	  DialogSelectShot.$inject = ["$rootScope", "$scope", "$sessionStorage", "Resource", "SharedState", "Const"];
	  function DialogSelectShot($rootScope, $scope, $sessionStorage, Resource, SharedState, Const) {
	    (0, _classCallCheck3.default)(this, DialogSelectShot);
	
	    this.Const = Const;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.UiSharedState = SharedState;
	    this.Resource = Resource;
	
	    this.seriesLegend = [this.Const.SHOT_TYPE.all, this.Const.SHOT_TYPE.foreF, this.Const.SHOT_TYPE.foreS, this.Const.SHOT_TYPE.backF, this.Const.SHOT_TYPE.backS, this.Const.SHOT_TYPE.foreV, this.Const.SHOT_TYPE.backV, this.Const.SHOT_TYPE.smash, this.Const.SHOT_TYPE.serve];
	
	    this.legendStyle = [this.Const.SHOT_COLOR.all, this.Const.SHOT_COLOR.foreF, this.Const.SHOT_COLOR.foreS, this.Const.SHOT_COLOR.backF, this.Const.SHOT_COLOR.backS, this.Const.SHOT_COLOR.foreV, this.Const.SHOT_COLOR.backV, this.Const.SHOT_COLOR.smash, this.Const.SHOT_COLOR.serve];
	
	    DialogSelectShot.$inject = ['$rootScope', '$scope', '$sessionStorage', 'Resource', 'SharedState', 'Const'];
	  }
	
	  (0, _createClass3.default)(DialogSelectShot, [{
	    key: 'selectShot',
	    value: function selectShot($event, $index) {
	      var _this = this;
	
	      var that = this;
	      this.beforeAddStyle($event, $index, that).then(function ($index) {
	        // シークバーの高さ調整
	        var extentEle = document.getElementsByClassName('extent');
	        extentEle[0].setAttribute('height', '24');
	        // スライダーの領域調整
	        var resizeEle = document.getElementsByClassName('resize');
	        var resizeE = resizeEle[0].getElementsByTagName('rect');
	        var resizeW = resizeEle[1].getElementsByTagName('rect');
	        resizeE[0].setAttribute('width', '50');
	        resizeW[0].setAttribute('width', '50');
	        resizeE[0].setAttribute('height', '40');
	        resizeW[0].setAttribute('height', '40');
	        _this.$rootScope.userSeriesChart.selectAll('.dc-chart rect.bar').style('fill', function (d) {
	          return _this.legendStyle[$index];
	        });
	        _this.$rootScope.userSeriesChart.select('.dc-chart .brush rect.extent').style('fill', function (d) {
	          return _this.legendStyle[$index];
	        });
	        _this.$rootScope.userSeriesChart.selectAll('.dc-chart rect.bar.deselected').style('fill', function (d) {
	          return _this.Const.SHOT_COLOR.deselected;
	        });
	        _this.$rootScope.userSeriesChart.colorAccessor(function (d) {
	          if (d.value) {
	            _this.$rootScope.userSeriesChart.selectAll('.dc-chart rect.bar').style('fill', function (d) {
	              return _this.legendStyle[$index];
	            });
	            _this.$rootScope.userSeriesChart.select('.dc-chart .brush rect.extent').style('fill', function (d) {
	              return _this.legendStyle[$index];
	            });
	            _this.$rootScope.userSeriesChart.selectAll('.dc-chart rect.bar.deselected').style('fill', function (d) {
	              return _this.Const.SHOT_COLOR.deselected;
	            });
	          }
	        });
	      }).catch(function (error) {
	        console.error('error : ', error);
	      });
	    }
	  }, {
	    key: 'beforeAddStyle',
	    value: function beforeAddStyle($event, $index, that) {
	      return new _promise2.default(function (resolve) {
	        /*
	          ダイアログでは$sessionStorageを取得できないため、
	          graph.es6のshowSelectShot()内で$rootScopeに値を代入している
	        */
	        var beginDate = new Date(that.$rootScope.lessonBeginDate);
	        var endDate = new Date(that.$rootScope.lessonEndDate);
	        var targetShotKind = '';
	        if ($event.target.defaultValue) {
	          targetShotKind = $event.target.defaultValue;
	        } else {
	          var trimInnerText = $event.target.innerText.trim();
	          targetShotKind = trimInnerText;
	        }
	        if (that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] === targetShotKind) {
	          that.UiSharedState.turnOff('dialogSelectShotPopup');
	          return resolve($index);
	        }
	        that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] = targetShotKind;
	        if ($index === 0) {
	          // すべてのショット選択時はHeatmapを表示させない
	          that.$sessionStorage[that.Const.SSAPP_HEATMAP_FLG] = false;
	          dc.filterAll();
	          that.$rootScope.userSeriesChart.filter([beginDate, endDate]);
	          dc.renderAll();
	          that.UiSharedState.turnOff('dialogSelectShotPopup');
	          return resolve($index);
	        } else {
	          // データに合わせフォアハンド スピン/フラットを0とする
	          var idx = $index - 1;
	          // すべてのショット選択時はHeatmapを表示させる
	          that.$sessionStorage[that.Const.SSAPP_HEATMAP_FLG] = true;
	          // 正しい情報を表示するため一度リセットしてからフィルターをかける
	          dc.filterAll();
	          that.$rootScope.userSeriesChart.filter([beginDate, endDate]);
	          // ダイアログで選択したショットでフィルターをかける
	          that.$rootScope.swingtypeChart._onClick(that.$rootScope.swingtypeChart.data()[idx]);
	          dc.renderAll();
	          that.UiSharedState.turnOff('dialogSelectShotPopup');
	          return resolve($index);
	        }
	      });
	    }
	  }]);
	  return DialogSelectShot;
	}();
	
	_angular2.default.module('myApp').component(COMPONENT_NAME, {
	  bindings: {
	    name: '@' + COMPONENT_NAME
	  },
	  controller: DialogSelectShot,
	  templateUrl: 'app/components/dialog/select-shot/dialog-select-shot.template.html'
	});

/***/ },

/***/ 272:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMPONENT_NAME = 'dialogSignOut';
	
	var DialogSignOut = function () {
	  /* @ngInject */
	  DialogSignOut.$inject = ["$location", "$sessionStorage", "Resource", "SharedState", "commonFactory", "Const"];
	  function DialogSignOut($location, $sessionStorage, Resource, SharedState, commonFactory, Const) {
	    (0, _classCallCheck3.default)(this, DialogSignOut);
	
	    this.Const = Const;
	    this.Resource = Resource;
	    this.$location = $location;
	    this.$sessionStorage = $sessionStorage;
	    this.UiSharedState = SharedState;
	    this.commonFactory = commonFactory;
	    DialogSignOut.$inject = ['$location', '$sessionStorage', 'Resource', 'SharedState', 'commonFactory', 'Const'];
	  }
	
	  (0, _createClass3.default)(DialogSignOut, [{
	    key: 'signOut',
	    value: function signOut() {
	      this.UiSharedState.turnOff('dialogSignOutPopup');
	      if (localStorage.getItem(this.Const.LSAPP_ROLE) === this.Const.LSAPP_ROLE_MEMBER) {
	        this.$location.path('/member/login');
	      } else {
	        this.$location.path('/staff/login');
	      }
	      this.commonFactory.deleteLocalStorage();
	      this.commonFactory.deleteSessionStorage();
	      this.commonFactory.deleteErrorFlg();
	    }
	  }]);
	  return DialogSignOut;
	}();
	
	_angular2.default.module('myApp').component(COMPONENT_NAME, {
	  bindings: {
	    name: '@' + COMPONENT_NAME
	  },
	  controller: DialogSignOut,
	  templateUrl: 'app/components/dialog/sign-out/dialog-sign-out.template.html'
	});

/***/ },

/***/ 273:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMPONENT_NAME = 'dialogDeleteVideo';
	
	var DialogDeleteVideo = function () {
	  /* @ngInject */
	  DialogDeleteVideo.$inject = ["$rootScope", "$scope", "SharedState", "commonApiFactory", "commonFactory", "Const"];
	  function DialogDeleteVideo($rootScope, $scope, SharedState, commonApiFactory, commonFactory, Const) {
	    (0, _classCallCheck3.default)(this, DialogDeleteVideo);
	
	    this.Const = Const;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.UiSharedState = SharedState;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    DialogDeleteVideo.$inject = ['$rootScope', '$scope', 'SharedState', 'commonApiFactory', 'commonFactory', 'Const'];
	  }
	
	  (0, _createClass3.default)(DialogDeleteVideo, [{
	    key: 'deleteVideo',
	    value: function deleteVideo() {
	      var _this = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      var pathParams = {
	        videoId: this.$rootScope.videoId
	      };
	      return this.commonApiFactory.deleteVideosVideoId(pathParams).then(function () {
	        return _this.commonApiFactory.deleteNotificationsVideosVideoId(pathParams);
	      }).then(function (res) {
	        _this.$rootScope.videoList.splice(_this.$rootScope.fileIndex, 1);
	        if (_this.$rootScope.videoList.length === 0) {
	          _this.$rootScope.videoList.push({});
	        }
	        _this.$rootScope.parentScope.$apply();
	      }).catch(function (err) {
	        throw err;
	      });
	    }
	  }]);
	  return DialogDeleteVideo;
	}();
	
	_angular2.default.module('myApp').component(COMPONENT_NAME, {
	  bindings: {
	    name: '@' + COMPONENT_NAME
	  },
	  controller: DialogDeleteVideo,
	  templateUrl: 'app/components/dialog/delete-video/dialog-delete-video.template.html'
	});

/***/ },

/***/ 274:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMPONENT_NAME = 'dialogMoveVideoToGuest';
	
	var DialogMoveVideoToGuest = function () {
	  /* @ngInject */
	  DialogMoveVideoToGuest.$inject = ["$rootScope", "$scope", "$sessionStorage", "SharedState", "commonApiFactory", "commonFactory", "Const"];
	  function DialogMoveVideoToGuest($rootScope, $scope, $sessionStorage, SharedState, commonApiFactory, commonFactory, Const) {
	    (0, _classCallCheck3.default)(this, DialogMoveVideoToGuest);
	
	    this.Const = Const;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.UiSharedState = SharedState;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    DialogMoveVideoToGuest.$inject = ['$rootScope', '$scope', '$sessionStorage', 'SharedState', 'commonApiFactory', 'commonFactory', 'Const'];
	  }
	
	  (0, _createClass3.default)(DialogMoveVideoToGuest, [{
	    key: 'moveVideoToGuest',
	    value: function moveVideoToGuest() {
	      var _this = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.commonFactory.overlayShow();
	
	      // ゲスト動画登録
	      var postGuestVideoParams = {
	        schoolId: this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID],
	        sourceVideoId: this.$rootScope.videoId
	      };
	      var requestBody = {};
	      this.commonApiFactory.postSchoolsSchoolIdVideos(postGuestVideoParams, requestBody).then(function (res) {
	        var deleteVideoParams = {
	          videoId: _this.$rootScope.videoId
	        };
	        // 生徒動画削除
	        return _this.commonApiFactory.deleteVideosVideoId(deleteVideoParams);
	      }).then(function (res) {
	        _this.$rootScope.videoList.splice(_this.$rootScope.fileIndex, 1);
	        if (_this.$rootScope.videoList.length === 0) {
	          _this.$rootScope.videoList.push({});
	        }
	        _this.commonFactory.flashErrorMessageFlag(_this.Const.SSAPP_MOVE_VIDEO_TO_GUEST_COMPLETE, 3000, false);
	        _this.commonFactory.overlayHidden();
	        _this.$rootScope.parentScope.$apply();
	      }).catch(function (err) {
	        throw err;
	      });
	    }
	  }]);
	  return DialogMoveVideoToGuest;
	}();
	
	_angular2.default.module('myApp').component(COMPONENT_NAME, {
	  bindings: {
	    name: '@' + COMPONENT_NAME
	  },
	  controller: DialogMoveVideoToGuest,
	  templateUrl: 'app/components/dialog/move-video-to-guest/dialog-move-video-to-guest.template.html'
	});

/***/ },

/***/ 275:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(188);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _moment = __webpack_require__(59);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMPONENT_NAME = 'videoUpload'; /*
	                                      global
	                                      videojs
	                                    */
	
	var FILE_TYPE = 'video/mp4';
	var SERVER_SIDE_ENCRYPTION = 'AES256';
	var DATE_FORMAT = 'YYYY年MM月DD日';
	var MAX_RETRY_COUNT = 3;
	
	var INITIAL_STATE_MESSAGE = 'ファイルが選択されていません';
	
	var VideoUpload = function () {
	  /* @ngInject */
	  VideoUpload.$inject = ["$scope", "$sessionStorage", "$rootScope", "$location", "$sce", "$timeout", "videoParser", "commonApiFactory", "commonFactory", "Const", "Upload", "SharedState"];
	  function VideoUpload($scope, $sessionStorage, $rootScope, $location, $sce, $timeout, videoParser, commonApiFactory, commonFactory, Const, Upload, SharedState) {
	    (0, _classCallCheck3.default)(this, VideoUpload);
	
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$rootScope = $rootScope;
	    this.$sce = $sce;
	    this.$timeout = $timeout;
	    this.videoParser = videoParser;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.Const = Const;
	    this.Upload = Upload;
	    this.UiSharedState = SharedState;
	
	    this.stateMessage = INITIAL_STATE_MESSAGE;
	    this.errorStateMessage = '選択したファイルが不正です。ファイルを選択しなおしてください';
	    this.timestamp = new Date().getTime();
	    this.errorCount = 0;
	
	    if ($sessionStorage[Const.SSAPP_PUBLIC_VIDEO_COMPLETE] !== null) {
	      delete $sessionStorage[Const.SSAPP_PUBLIC_VIDEO_COMPLETE];
	    }
	    if ($sessionStorage[Const.SSAPP_PRIVATE_VIDEO_COMPLETE] !== null) {
	      delete $sessionStorage[Const.SSAPP_PRIVATE_VIDEO_COMPLETE];
	    }
	    if ($sessionStorage[Const.SSAPP_PREVIEW_VIDEO_ON_COMPLETE] !== null) {
	      delete $sessionStorage[Const.SSAPP_PREVIEW_VIDEO_ON_COMPLETE];
	    }
	    if ($sessionStorage[Const.SSAPP_PREVIEW_VIDEO_OFF_COMPLETE] !== null) {
	      delete $sessionStorage[Const.SSAPP_PREVIEW_VIDEO_OFF_COMPLETE];
	    }
	
	    // component state
	    this.isUploading = false;
	    this.isFileSelected = false;
	    this.isPreview = this.isUploaded;
	    this.isInvalidFile = false;
	    this.isVideoStopped = true;
	
	    // video info
	    this.videoFile = '';
	    this.videoId = '';
	    this.fileName = '';
	    this.size = '';
	    this.startedDate = '';
	    this.displayStartedDate = '';
	    this.endedDate = '';
	    this.resolution = '';
	    this.isUploaded = false;
	    if (this.videoData.getUrls) {
	      this.isUploaded = true;
	      this.setUploadedVideo();
	    }
	    this.isStatusPublic = false;
	
	    VideoUpload.$inject = ['$scope', '$sessionStorage', '$rootScope', '$location', '$sce', '$timeout', 'videoParser', 'commonApiFactory', 'commonFactory', 'Const', 'Upload', 'SharedState'];
	  }
	
	  (0, _createClass3.default)(VideoUpload, [{
	    key: 'play',
	    value: function play() {
	      this.isVideoStopped = false;
	      var video = videojs('video-' + this.timestamp + '-' + this.index);
	      video.play();
	    }
	  }, {
	    key: 'setUploadedVideo',
	    value: function setUploadedVideo() {
	      var _this = this;
	
	      this.videoId = this.videoData.id;
	      if (this.videoData.fileName) {
	        this.fileName = this.videoData.fileName;
	      } else {
	        this.fileName = 'ファイル名を取得できませんでした';
	      }
	      if (this.videoData.startedDate) {
	        this.displayStartedDate = (0, _moment2.default)(this.videoData.startedDate).format(DATE_FORMAT);
	      } else {
	        this.displayStartedDate = '撮影日を取得できませんでした';
	      }
	      this.stateMessage = this.fileName;
	
	      // elementが描画されるのを待つ
	      this.$timeout(function () {
	        if (_this.videoData.state & _this.Const.VIDEO_STATE_FLAG.publiced) {
	          var checkbox = document.getElementById('public-check-box-' + _this.timestamp + '-' + _this.index);
	          checkbox.setAttribute('checked', 'checked');
	          _this.isStatusPublic = true;
	        } else if (_this.videoData.state & _this.Const.VIDEO_STATE_FLAG.previewed) {
	          var _checkbox = document.getElementById('preview-check-box-' + _this.timestamp + '-' + _this.index);
	          _checkbox.setAttribute('checked', 'checked');
	          _this.$scope.checkPreview = true;
	        }
	        var that = _this;
	        videojs('video-' + _this.timestamp + '-' + _this.index).ready(function () {
	          var sources = [{ 'type': FILE_TYPE, 'src': that.$sce.trustAsResourceUrl(that.videoData.getUrls.original) }];
	          this.src(sources);
	          this.on('play', function () {
	            that.isVideoStopped = false;
	            that.$scope.$apply();
	          });
	          var getUrls = that.videoData.getUrls;
	          if (getUrls && getUrls.thumb) {
	            // サムネイル表示
	            this.poster(getUrls.thumb);
	          } else {
	            console.log('thumb not found [' + that.videoId + ']');
	            this.load();
	          }
	        });
	      }, 1000);
	      this.isPreview = true;
	    }
	  }, {
	    key: 'activateUpload',
	    value: function activateUpload(files) {
	      var _this2 = this;
	
	      if (files.length === 0) {
	        var formatError = this.uploadForm.inputFile.$error;
	        if (formatError.maxSize) {
	          this.errorStateMessage = '動画のサイズが制限を超えています。150MB以下の動画を選択してください。';
	          this.changeErrorState();
	        }
	        if (formatError.pattern) {
	          this.errorStateMessage = '対応していないファイル形式です。mp4ファイルを選択してください。';
	          this.changeErrorState();
	        }
	        return;
	      }
	      this.videoFile = files[0];
	      this.videoParser.setDataToMP4Box(this.videoFile).then(function (res) {
	        _this2.fileName = _this2.videoFile.name;
	        _this2.size = _this2.videoFile.size;
	        _this2.startedDate = new Date(_this2.videoParser.getStartUnixTime()).toISOString();
	        _this2.displayStartedDate = (0, _moment2.default)(_this2.startedDate).format(DATE_FORMAT);
	        _this2.endedDate = new Date(_this2.videoParser.getEndUnixTime()).toISOString();
	        _this2.resolution = _this2.videoParser.getResolution();
	        var videoUrl = URL.createObjectURL(_this2.videoFile);
	        videojs('video-' + _this2.timestamp + '-' + _this2.index).ready(function () {
	          this.src(videoUrl);
	        });
	        _this2.changeFileSelectedState();
	        _this2.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'changeErrorState',
	    value: function changeErrorState() {
	      this.displayStartedDate = '';
	      this.filename = '';
	      this.isFileSelected = false;
	      this.videoFile = null;
	      this.isPreview = false;
	      this.isInvalidFile = true;
	    }
	  }, {
	    key: 'changeFileSelectedState',
	    value: function changeFileSelectedState() {
	      this.stateMessage = this.fileName;
	      this.isPreview = true;
	      this.isInvalidFile = false;
	      this.isFileSelected = true;
	    }
	  }, {
	    key: 'changeStateToUploadFailed',
	    value: function changeStateToUploadFailed() {
	      var _this3 = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_UNEXPECTED_ERROR, 5000, false);
	      var pathParams = {
	        memberId: this.$sessionStorage[this.Const.SSAPP_MEMBER_ID],
	        videoId: this.videoId
	      };
	      // アップロードに失敗した動画をDB上から削除する
	      return this.commonApiFactory.deleteMembersMemberIdVideosVideoId(pathParams).then(function (res) {
	        _this3.isUploading = false;
	        _this3.stateMessage = _this3.fileName;
	        _this3.errorCount = 0;
	        _this3.$scope.$apply();
	      }).catch(function (err) {
	        console.log(err);
	        _this3.removeVideo({ 'index': _this3.index });
	      });
	    }
	  }, {
	    key: 'upload',
	    value: function upload() {
	      var _this4 = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.stateMessage = 'アップロード中・・・(0%)';
	      this.isUploading = true;
	      var requestBody = {
	        startedDate: this.startedDate,
	        endedDate: this.endedDate,
	        size: this.size,
	        resolution: this.resolution,
	        fileName: this.fileName
	      };
	      var pathParams = {
	        memberId: this.$sessionStorage[this.Const.SSAPP_MEMBER_ID]
	      };
	      return this.commonApiFactory.postMembersVideos(pathParams, requestBody).then(function (res) {
	        _this4.videoId = res.id;
	        return _this4.uploadToS3(res);
	      }).then(function (res) {
	        // アップロード完了を把握しやすいように0.5秒待つ
	        setTimeout(function () {
	          _this4.finishUpload();
	        }, 500);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'uploadToS3',
	    value: function uploadToS3(video) {
	      var _this5 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        _this5.Upload.http({
	          url: video.putUrl,
	          headers: {
	            'Content-Type': FILE_TYPE,
	            'x-amz-server-side-encryption': SERVER_SIDE_ENCRYPTION
	          },
	          method: 'PUT',
	          data: _this5.videoFile
	        }).then(function (res) {
	          resolve(res);
	        }, function (err) {
	          console.log(err);
	          _this5.$timeout(function () {
	            if (_this5.errorCount < MAX_RETRY_COUNT) {
	              _this5.errorCount++;
	              return _this5.uploadToS3(video);
	            }
	            // TODO: 呼び出し元でcatchできない
	            return reject(_this5.changeStateToUploadFailed());
	          }, 1000);
	        }, function (evt) {
	          var progress = Math.floor(evt.loaded / evt.total * 100);
	          if (isNaN(progress)) {
	            _this5.stateMessage = 'アップロード中・・・(0%)';
	          } else {
	            _this5.stateMessage = '\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u4E2D\u30FB\u30FB\u30FB(' + progress + '%)';
	          }
	        });
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      this.$rootScope.videoId = this.videoId;
	      this.$rootScope.fileIndex = this.index;
	      this.$rootScope.fileName = this.fileName;
	      this.$rootScope.parentScope = this.$scope;
	      this.UiSharedState.turnOn('dialogDeleteVideoPopup');
	    }
	  }, {
	    key: 'moveToGuest',
	    value: function moveToGuest() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.errorCount = 0;
	      this.stateMessage = 'ゲスト動画へ移動準備中・・・';
	      this.moveVideoToGuest();
	    }
	  }, {
	    key: 'moveVideoToGuest',
	    value: function moveVideoToGuest() {
	      var _this6 = this;
	
	      var reqParams = {
	        videoId: this.videoId,
	        url: 'off'
	      };
	      return this.commonApiFactory.getVideosVideoId(reqParams).then(function (res) {
	        if (res === null || res.state === _this6.Const.VIDEO_STATE_FLAG.uploaded || res.state === _this6.Const.VIDEO_STATE_FLAG.converted) {
	          _this6.$timeout(function () {
	            if (_this6.errorCount < MAX_RETRY_COUNT) {
	              _this6.errorCount++;
	              return _this6.moveVideoToGuest();
	            }
	            _this6.errorStateMessage = 'ゲスト動画への移動に失敗しました。再度実行してください';
	            _this6.isInvalidFile = true;
	          }, 1000);
	          _this6.$scope.$apply();
	        } else {
	          _this6.stateMessage = _this6.fileName;
	          _this6.$rootScope.videoId = _this6.videoId;
	          _this6.$rootScope.fileIndex = _this6.index;
	          _this6.$rootScope.fileName = _this6.fileName;
	          _this6.$rootScope.parentScope = _this6.$scope;
	          _this6.UiSharedState.turnOn('dialogMoveVideoToGuestPopup');
	          _this6.$scope.$apply();
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'deleteVideo',
	    value: function deleteVideo() {
	      var _this7 = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.stateMessage = '削除中・・・';
	      var pathParams = {
	        videoId: this.$rootScope.videoId
	      };
	      return this.commonApiFactory.deleteVideosVideoId(pathParams).then(function () {
	        return _this7.commonApiFactory.deleteNotificationsVideosVideoId(pathParams);
	      }).then(function (res) {
	        _this7.removeVideo({ 'index': _this7.index });
	      }).catch(function (err) {
	        throw err;
	      });
	    }
	  }, {
	    key: 'finishUpload',
	    value: function finishUpload() {
	      this.isUploaded = true;
	      this.stateMessage = this.fileName;
	      this.$scope.$apply();
	    }
	  }, {
	    key: 'publicVideo',
	    value: function publicVideo() {
	      var _this8 = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      var isCheck = !document.getElementById('public-check-box-' + this.timestamp + '-' + this.index).checked;
	      document.getElementById('public-check-box-' + this.timestamp + '-' + this.index).checked = isCheck;
	      document.getElementById('preview-check-box-' + this.timestamp + '-' + this.index).checked = isCheck;
	      var reqParams = {
	        videoId: this.videoId
	      };
	      var reqBody = {
	        previewedFlag: true,
	        publishedFlag: isCheck
	      };
	
	      this.commonApiFactory.putVideosVideoId(reqParams, reqBody).then(function (res) {
	        var reqParamsForNotification = {
	          videoId: _this8.videoId
	        };
	        if (isCheck) {
	          _this8.commonApiFactory.postNotificationsVideosVideoId(reqParamsForNotification).then(function (res) {
	            _this8.commonFactory.flashErrorMessageFlag(_this8.Const.SSAPP_PUBLIC_VIDEO_COMPLETE, 3000, false);
	            _this8.$scope.$apply();
	          }).catch(function (err) {
	            console.log(err);
	            throw err;
	          });
	        } else {
	          _this8.commonApiFactory.deleteNotificationsVideosVideoId(reqParamsForNotification).then(function (res) {
	            _this8.commonFactory.flashErrorMessageFlag(_this8.Const.SSAPP_PRIVATE_VIDEO_COMPLETE, 3000, false);
	            _this8.$scope.$apply();
	          }).catch(function (err) {
	            console.log(err);
	            throw err;
	          });
	        }
	        _this8.$scope.checkPreview = !isCheck;
	        _this8.isStatusPublic = isCheck;
	      });
	    }
	  }, {
	    key: 'previewVideo',
	    value: function previewVideo() {
	      var _this9 = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      var isCheck = document.getElementById('preview-check-box-' + this.timestamp + '-' + this.index).checked;
	
	      var reqParams = {
	        videoId: this.videoId
	      };
	      var reqBody = {
	        previewedFlag: isCheck,
	        publishedFlg: false
	      };
	      this.commonApiFactory.putVideosVideoId(reqParams, reqBody).then(function (res) {
	        if (isCheck) {
	          _this9.commonFactory.flashErrorMessageFlag(_this9.Const.SSAPP_PREVIEW_VIDEO_ON_COMPLETE, 3000, false);
	        } else {
	          _this9.commonFactory.flashErrorMessageFlag(_this9.Const.SSAPP_PREVIEW_VIDEO_OFF_COMPLETE, 3000, false);
	        }
	        _this9.$scope.$apply();
	      });
	    }
	  }]);
	  return VideoUpload;
	}();
	
	_angular2.default.module('myApp').component(COMPONENT_NAME, {
	  bindings: {
	    name: '@' + COMPONENT_NAME,
	    videoData: '=videodata',
	    index: '=index',
	    removeVideo: '&removevideo'
	  },
	  controller: VideoUpload,
	  templateUrl: 'app/components/video/upload/video-upload.template.html'
	});

/***/ },

/***/ 276:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _moment = __webpack_require__(59);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMPONENT_NAME = 'videoGuest'; /*
	                                     global
	                                     videojs
	                                   */
	
	var FILE_TYPE = 'video/mp4';
	var DATE_FORMAT = 'YYYY年MM月DD日';
	
	var INITIAL_STATE_MESSAGE = 'ファイルが選択されていません';
	
	var VideoGuest = function () {
	  /* @ngInject */
	  VideoGuest.$inject = ["$scope", "$sessionStorage", "$rootScope", "$location", "$sce", "$timeout", "commonApiFactory", "commonFactory", "Const", "SharedState"];
	  function VideoGuest($scope, $sessionStorage, $rootScope, $location, $sce, $timeout, commonApiFactory, commonFactory, Const, SharedState) {
	    (0, _classCallCheck3.default)(this, VideoGuest);
	
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$rootScope = $rootScope;
	    this.$location = $location;
	    this.$sce = $sce;
	    this.$timeout = $timeout;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.Const = Const;
	    this.UiSharedState = SharedState;
	
	    this.stateMessage = INITIAL_STATE_MESSAGE;
	    this.errorStateMessage = '選択したファイルが不正です。ファイルを選択しなおしてください';
	    this.timestamp = new Date().getTime();
	    this.errorCount = 0;
	
	    // component state
	    this.isUploading = false;
	    // this.isFileSelected = false;
	    this.isPreview = this.isUploaded;
	    this.isInvalidFile = false;
	    this.isVideoStopped = true;
	
	    // video info
	    this.videoId = '';
	    this.fileName = '';
	    this.displayStartedDate = '';
	    this.isUploaded = false;
	    if (this.videoData.getUrls) {
	      this.isUploaded = true;
	      this.setUploadedVideo();
	    }
	    VideoGuest.$inject = ['$scope', '$sessionStorage', '$rootScope', '$location', '$sce', '$timeout', 'commonApiFactory', 'commonFactory', 'Const', 'SharedState'];
	  }
	
	  (0, _createClass3.default)(VideoGuest, [{
	    key: 'play',
	    value: function play() {
	      this.isVideoStopped = false;
	      var video = videojs('video-' + this.timestamp + '-' + this.index);
	      video.play();
	    }
	  }, {
	    key: 'setUploadedVideo',
	    value: function setUploadedVideo() {
	      var _this = this;
	
	      this.videoId = this.videoData.id;
	      if (this.videoData.fileName) {
	        this.fileName = this.videoData.fileName;
	      } else {
	        this.fileName = 'ファイル名を取得できませんでした';
	      }
	      if (this.videoData.startedDate) {
	        this.displayStartedDate = (0, _moment2.default)(this.videoData.startedDate).format(DATE_FORMAT);
	      } else {
	        this.displayStartedDate = '撮影日を取得できませんでした';
	      }
	      this.stateMessage = this.fileName;
	
	      // elementが描画されるのを待つ
	      this.$timeout(function () {
	        var that = _this;
	        videojs('video-' + _this.timestamp + '-' + _this.index).ready(function () {
	          var sources = [{ 'type': FILE_TYPE, 'src': that.$sce.trustAsResourceUrl(that.videoData.getUrls.original) }];
	          this.src(sources);
	          this.on('play', function () {
	            that.isVideoStopped = false;
	            that.$scope.$apply();
	          });
	          var getUrls = that.videoData.getUrls;
	          if (getUrls && getUrls.thumb) {
	            // サムネイル表示
	            this.poster(getUrls.thumb);
	          } else {
	            console.log('thumb not found [' + that.videoId + ']');
	            this.load();
	          }
	        });
	      }, 1000);
	      this.isPreview = true;
	    }
	
	    // 削除ボタン押下
	
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      this.$rootScope.videoId = this.videoId;
	      this.$rootScope.fileIndex = this.index;
	      this.$rootScope.fileName = this.fileName;
	      this.$rootScope.parentScope = this.$scope;
	      this.UiSharedState.turnOn('dialogDeleteVideoPopup');
	    }
	
	    // 生徒アカウントへ移動ボタン押下
	
	  }, {
	    key: 'moveToMember',
	    value: function moveToMember() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$sessionStorage[this.Const.SSAPP_SELECTED_DATE] = new Date();
	      this.$sessionStorage[this.Const.SSAPP_VIDEO_ID_MOVE_TO_MEMBER] = this.videoId;
	      this.$sessionStorage[this.Const.SSAPP_ADMIN_COURSE_LIST_LOCATION] = this.Const.ADMIN_COURSE_LIST_LOCATION.guestVideo;
	      this.$location.path('/admin/course');
	    }
	  }]);
	  return VideoGuest;
	}();
	
	_angular2.default.module('myApp').component(COMPONENT_NAME, {
	  bindings: {
	    name: '@' + COMPONENT_NAME,
	    videoData: '=videodata',
	    index: '=index',
	    removeVideo: '&removevideo'
	  },
	  controller: VideoGuest,
	  templateUrl: 'app/components/video/guest/video-guest.template.html'
	});

/***/ },

/***/ 277:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EulaController = function () {
	  /* @ngInject */
	  EulaController.$inject = ["$scope", "$sessionStorage", "$location", "$window", "commonApiFactory", "commonFactory", "Const", "Page"];
	  function EulaController($scope, $sessionStorage, $location, $window, commonApiFactory, commonFactory, Const, Page) {
	    (0, _classCallCheck3.default)(this, EulaController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = false;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.$location = $location;
	    this.$window = $window;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.commonFactory.overlayHidden();
	    this.commonFactory.deleteErrorFlg();
	    this.eulaChecked = false;
	    this.eulaCheck = function () {
	      this.eulaChecked = !this.eulaChecked;
	    };
	    Page.setTitle(this.Const.TITLE.eula);
	
	    if (localStorage.getItem(Const.LSAPP_ROLE) !== this.Const.LSAPP_ROLE_MEMBER) {
	      this.back();
	    }
	
	    EulaController.$inject = ['$scope', '$sessionStorage', '$location', '$window', 'commonApiFactory', 'commonFactory', 'Const', 'Page'];
	  }
	
	  (0, _createClass3.default)(EulaController, [{
	    key: 'agree',
	    value: function agree() {
	      var _this = this;
	
	      if (this.eulaChecked) {
	        var memberMeParams = { data: { eulaAgree: this.Const.EULA_AGREE_TYPE.agreed } };
	        this.commonApiFactory.putMembersMe(memberMeParams).then(function (member) {
	          _this.$sessionStorage[_this.Const.SSAPP_EULA_AGREE] = member.data.eulaAgree;
	          _this.$location.path('/member');
	          _this.$scope.$apply();
	        }).catch(function (error) {
	          console.log('error : ', error);
	          _this.commonFactory.flashErrorMessageFlag(_this.Const.SSAPP_HAS_UNEXPECTED_ERROR, 5000, false);
	        });
	      }
	    }
	  }, {
	    key: 'back',
	    value: function back() {
	      this.$window.history.back();
	    }
	  }]);
	  return EulaController;
	}();
	
	_angular2.default.module('myApp').controller('EulaController', EulaController);

/***/ },

/***/ 278:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PasswordForgetController = function () {
	  /* @ngInject */
	  PasswordForgetController.$inject = ["$scope", "$sessionStorage", "$location", "$window", "commonApiFactory", "commonFactory", "Const", "Page"];
	  function PasswordForgetController($scope, $sessionStorage, $location, $window, commonApiFactory, commonFactory, Const, Page) {
	    (0, _classCallCheck3.default)(this, PasswordForgetController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$location = $location;
	    this.$window = $window;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = false;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.$sessionStorage[this.Const.SSAPP_FULL_SCREEN_IOS] = false;
	    this.commonFactory.overlayHidden();
	    this.commonFactory.deleteErrorFlg();
	
	    this.isLoginFailed = false; // サインインチェック
	    this.isPleaseInput = false; // 必須入力
	    this.sendOk = false;
	
	    Page.setTitle(this.Const.TITLE.passForget);
	
	    PasswordForgetController.$inject = ['$scope', '$sessionStorage', '$location', '$window', 'commonApiFactory', 'commonFactory', 'Const', 'Page'];
	  }
	
	  (0, _createClass3.default)(PasswordForgetController, [{
	    key: 'submit',
	    value: function submit() {
	      var _this = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	
	      if (!this.userId || !this.mail) {
	        this.switchErrorMessage(this.Const.ERROR_TYPE.pleaseInput);
	        this.commonFactory.overlayHidden();
	        return;
	      }
	      this.switchErrorMessage(this.Const.ERROR_TYPE.clear);
	      var MembersMePasswordReset = {
	        companyCode: 'RNSS',
	        displayId: this.userId,
	        email: this.mail
	      };
	      this.commonApiFactory.postMembersPasswordReset(MembersMePasswordReset).then(function (result) {
	        _this.isLoginFailed = false; // サインインチェック
	        _this.isPleaseInput = false; // 必須入力
	        _this.sendOk = !_this.sendOk;
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      }).catch(function (error) {
	        console.log('error : ', error);
	        _this.switchErrorMessage(_this.Const.ERROR_TYPE.loginFailed);
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$location.path('/member/login');
	    }
	  }, {
	    key: 'switchErrorMessage',
	    value: function switchErrorMessage(errorType) {
	      switch (errorType) {
	        case this.Const.ERROR_TYPE.loginFailed:
	          this.changeErrorMessage(true, false);
	          break;
	        case this.Const.ERROR_TYPE.pleaseInput:
	          this.changeErrorMessage(false, true);
	          break;
	        case this.Const.ERROR_TYPE.clear:
	          this.changeErrorMessage(false, false);
	          break;
	        default:
	          this.changeErrorMessage(false, false);
	      }
	    }
	  }, {
	    key: 'changeErrorMessage',
	    value: function changeErrorMessage(loginFailedFlag, pleaseInput) {
	      this.isLoginFailed = loginFailedFlag;
	      this.isPleaseInput = pleaseInput;
	    }
	  }, {
	    key: 'back',
	    value: function back() {
	      this.$window.history.back();
	    }
	  }]);
	  return PasswordForgetController;
	}();
	
	_angular2.default.module('myApp').controller('PasswordForgetController', PasswordForgetController);

/***/ },

/***/ 279:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PasswordChangeController = function () {
	  /* @ngInject */
	  PasswordChangeController.$inject = ["$scope", "$sessionStorage", "$location", "$window", "$timeout", "commonAuthFactory", "commonApiFactory", "commonFactory", "Const", "Page"];
	  function PasswordChangeController($scope, $sessionStorage, $location, $window, $timeout, commonAuthFactory, commonApiFactory, commonFactory, Const, Page) {
	    (0, _classCallCheck3.default)(this, PasswordChangeController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = false;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.$location = $location;
	    this.$window = $window;
	    this.$timeout = $timeout;
	    this.commonAuthFactory = commonAuthFactory;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.commonFactory.overlayHidden();
	    this.commonFactory.deleteErrorFlg();
	
	    // エラー領域初期化
	    this.isPleaseInput = false; // 入力チェック
	    this.isLoginFailed = false; // 現在のパスワードチェック
	    this.isSamePassword = false; // 現在パスワード = 新しいパスワード
	    this.isProhibitionChars = false; // 禁則文字チェック
	    this.isMismatchPassword = false; // 新しいパスワード != 新しいパスワード確認
	    this.isPasswordPolicy = false; // パスワードポリシーチェック
	    this.isChangeSuccess = false; // パスワード変更完了
	    this.isLimit = false; // 一定時間内のパスワード変更可能回数エラー
	
	    Page.setTitle(this.Const.TITLE.passChange);
	
	    PasswordChangeController.$inject = ['$scope', '$sessionStorage', '$location', '$window', '$timeout', 'commonAuthFactory', 'commonApiFactory', 'commonFactory', 'Const', 'Page'];
	  }
	
	  (0, _createClass3.default)(PasswordChangeController, [{
	    key: 'submit',
	    value: function submit() {
	      var _this = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.switchErrorMessage(this.Const.ERROR_TYPE.clear);
	        this.commonFactory.overlayShow();
	      }
	
	      // 仮パスワード/本パスワード
	      var nowPass = this.$sessionStorage[this.Const.SSAPP_IS_TMP_PASSWORD] ? this.tmpPass : this.oldPass;
	      // 新しいパスワード
	      var newPass = this.newPass;
	      // 新しいパスワードの確認
	      var confirmPass = this.confirmPass;
	      // パスワードが未入力
	      if (!nowPass || !newPass || !confirmPass) {
	        this.commonFactory.overlayHidden();
	        return this.switchErrorMessage(this.Const.ERROR_TYPE.pleaseInput);
	      }
	      // 新しいパスワード != 新しいパスワードの確認
	      if (newPass !== confirmPass) {
	        this.commonFactory.overlayHidden();
	        return this.switchErrorMessage(this.Const.ERROR_TYPE.mismatchPassword);
	      }
	      // 現在パスワード = 新しいパスワード
	      if (nowPass === newPass) {
	        this.commonFactory.overlayHidden();
	        return this.switchErrorMessage(this.Const.ERROR_TYPE.samePassword);
	      }
	      // 禁則文字
	      if (this.commonFactory.isProhibitionChars(newPass)) {
	        this.commonFactory.overlayHidden();
	        return this.switchErrorMessage(this.Const.ERROR_TYPE.prohibitionChars);
	      }
	
	      // 妥当チェック
	      // アルファベット小文字、数字(アルファベット大文字、記号は任意)を1文字以上含む8文字以上か
	      if (newPass.length < 8 || !this.commonFactory.isPasswordPolicy(this.newPass)) {
	        this.commonFactory.overlayHidden();
	        return this.switchErrorMessage(this.Const.ERROR_TYPE.passwordPolicy);
	      }
	
	      if (this.$sessionStorage[this.Const.SSAPP_IS_TMP_PASSWORD]) {
	        var id = localStorage.getItem(this.Const.LSKEY_USER_ID);
	        if (localStorage.getItem(this.Const.LSAPP_ROLE) === this.Const.LSAPP_ROLE_MEMBER) {
	          this.userLogin(id, nowPass, newPass);
	        } else {
	          this.staffLogin(id, nowPass, newPass);
	        }
	      } else {
	        this.commonAuthFactory.changePassword(nowPass, newPass).then(function () {
	          _this.switchErrorMessage(_this.Const.ERROR_TYPE.clear);
	          _this.isChangeSuccess = true;
	          _this.$scope.$apply();
	          _this.$timeout(function () {
	            _this.commonFactory.overlayHidden();
	            _this.$scope.$apply();
	            _this.$window.history.back();
	          }, 1500);
	        }).catch(function (error) {
	          console.log('error : ', error);
	          if (error) {
	            if (error.statusCode === 400 && ~error.message.indexOf('limit exceeded')) {
	              _this.switchErrorMessage(_this.Const.ERROR_TYPE.limit);
	            } else {
	              _this.switchErrorMessage(_this.Const.ERROR_TYPE.loginFailed);
	            }
	          } else {
	            _this.switchErrorMessage(_this.Const.ERROR_TYPE.loginFailed);
	          }
	          _this.commonFactory.overlayHidden();
	          _this.$scope.$apply();
	        });
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$window.history.back();
	    }
	  }, {
	    key: 'switchErrorMessage',
	    value: function switchErrorMessage(errorType) {
	      switch (errorType) {
	        case this.Const.ERROR_TYPE.loginFailed:
	          this.changeErrorMessage(true, false, false, false, false, false, false);
	          break;
	        case this.Const.ERROR_TYPE.samePassword:
	          this.changeErrorMessage(false, true, false, false, false, false, false);
	          break;
	        case this.Const.ERROR_TYPE.prohibitionChars:
	          this.changeErrorMessage(false, false, true, false, false, false, false);
	          break;
	        case this.Const.ERROR_TYPE.mismatchPassword:
	          this.changeErrorMessage(false, false, false, true, false, false, false);
	          break;
	        case this.Const.ERROR_TYPE.pleaseInput:
	          this.changeErrorMessage(false, false, false, false, true, false, false);
	          break;
	        case this.Const.ERROR_TYPE.passwordPolicy:
	          this.changeErrorMessage(false, false, false, false, false, true, false);
	          break;
	        case this.Const.ERROR_TYPE.limit:
	          this.changeErrorMessage(false, false, false, false, false, false, true);
	          break;
	        case this.Const.ERROR_TYPE.clear:
	          this.changeErrorMessage(false, false, false, false, false, false, false);
	          break;
	        default:
	          this.changeErrorMessage(false, false, false, false, false, false, false);
	      }
	    }
	  }, {
	    key: 'changeErrorMessage',
	    value: function changeErrorMessage(loginFailedFlag, samePasswordFlag, prohibitionCharsFlag, mismatchPassword, pleaseInput, passwordPolicy, limit) {
	      this.isLoginFailed = loginFailedFlag;
	      this.isSamePassword = samePasswordFlag;
	      this.isProhibitionChars = prohibitionCharsFlag;
	      this.isMismatchPassword = mismatchPassword;
	      this.isPleaseInput = pleaseInput;
	      this.isPasswordPolicy = passwordPolicy;
	      this.isLimit = limit;
	    }
	  }, {
	    key: 'userLogin',
	    value: function userLogin(id, tmpPass, newPass) {
	      var _this2 = this;
	
	      var userAuth = this.commonAuthFactory.userLogin;
	      userAuth(id, tmpPass, newPass).then(function (userCredentials) {
	        return _this2.commonAuthFactory.getCredentialsForAPI(userCredentials, localStorage.getItem(_this2.Const.LSAPP_ROLE));
	      }).then(function () {
	        return _this2.commonApiFactory.getMembersMe();
	      }).then(function (member) {
	        _this2.switchErrorMessage(_this2.Const.ERROR_TYPE.clear);
	        _this2.isChangeSuccess = true;
	        _this2.$scope.$apply();
	        _this2.commonFactory.setStorage(_this2.Const.LSAPP_ROLE, _this2.Const.LSAPP_ROLE_MEMBER);
	        // 生徒情報を追加時に他修正が必要な箇所
	        // ・member-sign-in-controller.es6
	        // ・simplicity-sign-in-controller.es6
	        _this2.$sessionStorage[_this2.Const.SSAPP_MEMBER_ID] = member.id;
	        _this2.$sessionStorage[_this2.Const.SSAPP_USER_NAME] = member.name;
	        _this2.$sessionStorage[_this2.Const.SSAPP_GENDER] = member.gender;
	        _this2.$sessionStorage[_this2.Const.SSAPP_EULA_AGREE] = member.data.eulaAgree;
	        _this2.$sessionStorage[_this2.Const.SSAPP_SENSOR_RENTAL] = member.data.sensorRental;
	        _this2.$sessionStorage[_this2.Const.SSAPP_IS_TMP_PASSWORD] = false;
	        _this2.$timeout(function () {
	          if (member.data.eulaAgree !== null && member.data.eulaAgree === 1) {
	            _this2.$location.path('/member');
	          } else {
	            _this2.$location.path('/eula');
	          }
	          _this2.commonFactory.overlayHidden();
	          _this2.$scope.$apply();
	        }, 1500);
	      }).catch(function (error) {
	        console.log('error : ', error);
	        if (error) {
	          if (error.statusCode === 400 && ~error.message.indexOf('limit exceeded')) {
	            _this2.switchErrorMessage(_this2.Const.ERROR_TYPE.limit);
	          } else {
	            _this2.switchErrorMessage(_this2.Const.ERROR_TYPE.loginFailed);
	          }
	        } else {
	          _this2.switchErrorMessage(_this2.Const.ERROR_TYPE.loginFailed);
	        }
	        _this2.commonFactory.overlayHidden();
	        _this2.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'staffLogin',
	    value: function staffLogin(id, tmpPass, newPass) {
	      var _this3 = this;
	
	      var userAuth = this.commonAuthFactory.staffLogin;
	      userAuth(id, tmpPass, newPass).then(function (userCredentials) {
	        return _this3.commonAuthFactory.getCredentialsForAPI(userCredentials, localStorage.getItem(_this3.Const.LSAPP_ROLE));
	      }).then(function () {
	        return _this3.commonApiFactory.getStaffsMe();
	      }).then(function (staff) {
	        _this3.switchErrorMessage(_this3.Const.ERROR_TYPE.clear);
	        _this3.isChangeSuccess = true;
	        _this3.$scope.$apply();
	        _this3.$sessionStorage[_this3.Const.SSAPP_IS_TMP_PASSWORD] = false;
	        _this3.$timeout(function () {
	          switch (staff.role.name) {
	            case _this3.Const.LSAPP_ROLE_C_ADMIN:
	              // Company Admin
	              _this3.commonFactory.setStorage(_this3.Const.LSAPP_ROLE, _this3.Const.LSAPP_ROLE_C_ADMIN);
	              _this3.$sessionStorage[_this3.Const.SSAPP_COMPANY_ID] = staff.companyId;
	              _this3.$location.path('/admin/school');
	              break;
	            case _this3.Const.LSAPP_ROLE_S_ADMIN:
	              // School Admin
	              _this3.commonFactory.setStorage(_this3.Const.LSAPP_ROLE, _this3.Const.LSAPP_ROLE_S_ADMIN);
	              _this3.$sessionStorage[_this3.Const.SSAPP_SCHOOL_ID] = staff.data.schoolId;
	              _this3.$location.path('/admin');
	              break;
	            case _this3.Const.ROLE_COACH:
	              // Staff
	              _this3.$sessionStorage[_this3.Const.SSAPP_COACH_NAME] = staff.name;
	              _this3.$sessionStorage[_this3.Const.SSAPP_COACH_GENDER] = staff.gender;
	              _this3.$location.path('/staff');
	              break;
	            default:
	              // Invalid Role
	              _this3.commonFactory.flashErrorMessageFlag(_this3.Const.SSAPP_HAS_UNEXPECTED_ERROR, 5000, true);
	          }
	          _this3.commonFactory.overlayHidden();
	          _this3.$scope.$apply();
	        }, 1500);
	      }).catch(function (error) {
	        console.log('error : ', error);
	        if (error) {
	          if (error.statusCode === 400 && ~error.message.indexOf('limit exceeded')) {
	            _this3.switchErrorMessage(_this3.Const.ERROR_TYPE.limit);
	          } else {
	            _this3.switchErrorMessage(_this3.Const.ERROR_TYPE.loginFailed);
	          }
	        } else {
	          _this3.switchErrorMessage(_this3.Const.ERROR_TYPE.loginFailed);
	        }
	        _this3.commonFactory.overlayHidden();
	        _this3.$scope.$apply();
	      });
	    }
	  }]);
	  return PasswordChangeController;
	}();
	
	_angular2.default.module('myApp').controller('PasswordChangeController', PasswordChangeController);

/***/ },

/***/ 280:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SimplicitySignInController = function () {
	  /* @ngInject */
	  SimplicitySignInController.$inject = ["$scope", "$sessionStorage", "$location", "commonApiFactory", "commonFactory", "Const"];
	  function SimplicitySignInController($scope, $sessionStorage, $location, commonApiFactory, commonFactory, Const) {
	    (0, _classCallCheck3.default)(this, SimplicitySignInController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$location = $location;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = false;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = '';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.$sessionStorage[this.Const.SSAPP_FULL_SCREEN_IOS] = false;
	    this.commonFactory.overlayHidden();
	
	    var sessionRole = this.$sessionStorage[Const.LSAPP_ROLE];
	    var role = localStorage.getItem(Const.LSAPP_ROLE);
	    this.role = role;
	
	    if (role === this.Const.LSAPP_ROLE_MEMBER) {
	      this.$sessionStorage[this.Const.SSAPP_SMALL_HEIGHT] = '';
	    } else {
	      this.$sessionStorage[this.Const.SSAPP_SMALL_HEIGHT] = 'small-height';
	    }
	
	    // Cognito Credentials
	    var userId = localStorage.getItem(Const.LSKEY_USER_ID);
	    var jwtToken = localStorage.getItem(Const.LSKEY_USER_ID_TOKEN);
	    var accessKeyId = localStorage.getItem(Const.LSKEY_USER_ACCESS_KEY_ID);
	    var secretAccessKey = localStorage.getItem(Const.LSKEY_USER_SECRET_ACCESS_KEY);
	    var sessionToken = localStorage.getItem(Const.LSKEY_USER_SESSION_TOKEN);
	    var refreshToken = localStorage.getItem(Const.LSKEY_USER_REFRESH_TOKEN);
	    var accessToken = localStorage.getItem(Const.LSKEY_USER_ACCESS_TOKEN);
	    var isCredential = false;
	    if (userId && jwtToken && accessKeyId && secretAccessKey && sessionToken && refreshToken && accessToken) {
	      isCredential = true;
	    }
	    if (!sessionRole && role && isCredential) {
	      this.simplicitySignIn();
	    } else {
	      this.goToSignIn();
	    }
	
	    SimplicitySignInController.$inject = ['$scope', '$sessionStorage', '$location', 'commonApiFactory', 'commonFactory', 'Const'];
	  }
	
	  (0, _createClass3.default)(SimplicitySignInController, [{
	    key: 'simplicitySignIn',
	    value: function simplicitySignIn() {
	      var _this = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	      switch (this.role) {
	        case this.Const.LSAPP_ROLE_STAFF:
	        case this.Const.LSAPP_ROLE_RECEPTION:
	        case this.Const.LSAPP_ROLE_S_ADMIN:
	        case this.Const.LSAPP_ROLE_C_ADMIN:
	          this.commonApiFactory.getStaffsMe().then(function (staff) {
	            switch (staff.role.name) {
	              case _this.Const.LSAPP_ROLE_C_ADMIN:
	                // Company Admin
	                _this.commonFactory.setStorage(_this.Const.LSAPP_ROLE, _this.Const.LSAPP_ROLE_C_ADMIN);
	                _this.$sessionStorage[_this.Const.SSAPP_COMPANY_ID] = staff.companyId;
	                _this.$location.path('/admin/school');
	                break;
	              case _this.Const.LSAPP_ROLE_S_ADMIN:
	                // School Admin
	                _this.commonFactory.setStorage(_this.Const.LSAPP_ROLE, _this.Const.LSAPP_ROLE_S_ADMIN);
	                _this.$sessionStorage[_this.Const.SSAPP_SCHOOL_ID] = staff.data.schoolId;
	                _this.$location.path('/admin');
	                break;
	              default:
	                // coach,reception
	                _this.commonFactory.setStorage(_this.Const.LSAPP_ROLE, _this.Const.LSAPP_ROLE_STAFF);
	                _this.$sessionStorage[_this.Const.SSAPP_COACH_NAME] = staff.name;
	                if (staff.gender === null) {
	                  staff.gender = 0;
	                }
	                _this.$sessionStorage[_this.Const.SSAPP_COACH_GENDER] = staff.gender;
	                _this.$location.path('/staff');
	            }
	            _this.commonFactory.overlayHidden();
	            _this.$scope.$apply();
	          }).catch(function () {
	            _this.$location.path('/staff/login');
	            _this.commonFactory.overlayHidden();
	            _this.$scope.$apply();
	          });
	          break;
	        case this.Const.LSAPP_ROLE_MEMBER:
	        default:
	          this.commonApiFactory.getMembersMe().then(function (member) {
	            _this.commonFactory.setStorage(_this.Const.LSAPP_ROLE, _this.Const.LSAPP_ROLE_MEMBER);
	            // 生徒情報を追加時に他修正が必要な箇所
	            // ・member-sign-in-controller.es6
	            // ・password-change-controller.es6
	            _this.$sessionStorage[_this.Const.SSAPP_MEMBER_ID] = member.id;
	            _this.$sessionStorage[_this.Const.SSAPP_USER_NAME] = member.name;
	            _this.$sessionStorage[_this.Const.SSAPP_GENDER] = member.gender;
	            _this.$sessionStorage[_this.Const.SSAPP_EULA_AGREE] = member.data.eulaAgree;
	            _this.$sessionStorage[_this.Const.SSAPP_SENSOR_RENTAL] = member.data.sensorRental;
	            _this.$location.path('/member');
	            _this.commonFactory.overlayHidden();
	            _this.$scope.$apply();
	          }).catch(function () {
	            _this.$location.path('/member/login');
	            _this.commonFactory.overlayHidden();
	            _this.$scope.$apply();
	          });
	      }
	    }
	  }, {
	    key: 'goToSignIn',
	    value: function goToSignIn() {
	      switch (this.role) {
	        case this.Const.LSAPP_ROLE_STAFF:
	        case this.Const.LSAPP_ROLE_RECEPTION:
	        case this.Const.LSAPP_ROLE_S_ADMIN:
	        case this.Const.LSAPP_ROLE_C_ADMIN:
	          this.commonFactory.overlayHidden();
	          this.$scope.$apply();
	          this.$location.path('/staff/login');
	          break;
	        case this.Const.LSAPP_ROLE_MEMBER:
	        default:
	          this.commonFactory.overlayHidden();
	          this.$scope.$apply();
	          this.$location.path('/member/login');
	          break;
	      }
	    }
	  }]);
	  return SimplicitySignInController;
	}();
	
	_angular2.default.module('myApp').controller('SimplicitySignInController', SimplicitySignInController);

/***/ },

/***/ 281:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NOTIFICATION_PERMISSION_NOT_NOTIFIED = 0;
	var NOTIFICATION_PERMISSION_BE_NOTIFIED = 1;
	
	var NotificationConfigrationController = function () {
	  /* @ngInject */
	  NotificationConfigrationController.$inject = ["$scope", "$sessionStorage", "$location", "$window", "$timeout", "commonAuthFactory", "commonApiFactory", "commonFactory", "Const", "Page"];
	  function NotificationConfigrationController($scope, $sessionStorage, $location, $window, $timeout, commonAuthFactory, commonApiFactory, commonFactory, Const, Page) {
	    (0, _classCallCheck3.default)(this, NotificationConfigrationController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = false;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.$location = $location;
	    this.$window = $window;
	    this.$timeout = $timeout;
	    this.commonAuthFactory = commonAuthFactory;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.commonFactory.overlayHidden();
	    this.commonFactory.deleteErrorFlg();
	
	    this.notificationPermission = false; // ビデオ通知許可
	
	    Page.setTitle(this.Const.TITLE.notificationConfigration);
	
	    this.setNotificationConfigration();
	
	    NotificationConfigrationController.$inject = ['$scope', '$sessionStorage', '$location', '$window', '$timeout', 'commonAuthFactory', 'commonApiFactory', 'commonFactory', 'Const', 'Page'];
	  }
	
	  (0, _createClass3.default)(NotificationConfigrationController, [{
	    key: 'setNotificationConfigration',
	    value: function setNotificationConfigration() {
	      var _this = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	      this.commonApiFactory.getMembersMe().then(function (member) {
	        // data.notificationPermisisonが未設定の場合は通知許可
	        _this.notificationPermission = member.data.notificationPermission === undefined || member.data.notificationPermission === NOTIFICATION_PERMISSION_BE_NOTIFIED;
	        if (_this.notificationPermission) {
	          document.getElementById('notification-permission').setAttribute('checked', 'checked');
	        }
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      }).catch(function (error) {
	        console.log('error : ', error);
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	      this.notificationPermission = document.getElementById('notification-permission').checked ? NOTIFICATION_PERMISSION_BE_NOTIFIED : NOTIFICATION_PERMISSION_NOT_NOTIFIED;
	      var memberMeParams = { data: { notificationPermission: this.notificationPermission } };
	      this.commonApiFactory.putMembersMe(memberMeParams).then(function (member) {
	        _this2.$timeout(function () {
	          _this2.commonFactory.overlayHidden();
	          _this2.$scope.$apply();
	          _this2.$window.history.back();
	        }, 1500);
	      }).catch(function (error) {
	        console.log('error : ', error);
	        _this2.commonFactory.overlayHidden();
	        _this2.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$window.history.back();
	    }
	  }]);
	  return NotificationConfigrationController;
	}();
	
	_angular2.default.module('myApp').controller('NotificationConfigrationController', NotificationConfigrationController);

/***/ },

/***/ 282:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminCoachListController = function () {
	  /* @ngInject */
	  AdminCoachListController.$inject = ["$rootScope", "$scope", "$sessionStorage", "commonApiFactory", "commonFactory", "Const", "Page"];
	  function AdminCoachListController($rootScope, $scope, $sessionStorage, commonApiFactory, commonFactory, Const, Page) {
	    (0, _classCallCheck3.default)(this, AdminCoachListController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.$rootScope = $rootScope;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.commonFactory.overlayHidden();
	    this.commonFactory.deleteErrorFlg();
	
	    // APIから取得したコーチが存在している場合：true
	    // APIから取得したコーチが存在していない場合：false
	    this.existenceFlg = true;
	
	    this.getSchoolsSchoolIdStaffs();
	
	    Page.setTitle(this.Const.TITLE.staffList);
	
	    AdminCoachListController.$inject = ['$rootScope', '$scope', '$sessionStorage', 'commonApiFactory', 'commonFactory', 'Const', 'Page'];
	  }
	
	  (0, _createClass3.default)(AdminCoachListController, [{
	    key: 'getSchoolsSchoolIdStaffs',
	    value: function getSchoolsSchoolIdStaffs() {
	      var _this = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	
	      var staffsParams = {
	        schoolId: this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID]
	      };
	      this.commonApiFactory.getAdminSchoolsSchoolIdStaffs(staffsParams).then(function (result) {
	        _this.staffList = [];
	        if (result.length === 0) {
	          _this.existenceFlg = false;
	          _this.commonFactory.overlayHidden();
	          _this.$scope.$apply();
	          return;
	        }
	        result.forEach(function (staff) {
	          var staffObj = {
	            id: staff.id,
	            displayId: staff.displayId,
	            name: staff.name
	          };
	          _this.staffList.push(staffObj);
	        });
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      }).catch(function (error) {
	        _this.existenceFlg = false;
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	        console.log('error : ', error);
	      });
	    }
	  }, {
	    key: 'generatePassword',
	    value: function generatePassword(staff) {
	      this.$rootScope.targetId = staff.id;
	      this.$rootScope.password = this.commonFactory.createImterimPassword();
	    }
	  }]);
	  return AdminCoachListController;
	}();
	
	_angular2.default.module('myApp').controller('AdminCoachListController', AdminCoachListController);

/***/ },

/***/ 283:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminMemberListController = function () {
	  /* @ngInject */
	  AdminMemberListController.$inject = ["$rootScope", "$scope", "$sessionStorage", "$location", "commonApiFactory", "commonFactory", "Const", "Page"];
	  function AdminMemberListController($rootScope, $scope, $sessionStorage, $location, commonApiFactory, commonFactory, Const, Page) {
	    (0, _classCallCheck3.default)(this, AdminMemberListController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.$rootScope = $rootScope;
	    this.$location = $location;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.commonFactory.overlayHidden();
	    this.commonFactory.deleteErrorFlg();
	
	    // APIから取得した生徒が存在している場合：true
	    // APIから取得した生徒が存在していない場合：false
	    this.existenceFlg = true;
	
	    this.getSchoolsSchoolIdMembers();
	
	    Page.setTitle(this.Const.TITLE.memberListForAdmin);
	
	    AdminMemberListController.$inject = ['$rootScope', '$scope', '$sessionStorage', '$location', 'commonApiFactory', 'commonFactory', 'Const', 'Page'];
	  }
	
	  (0, _createClass3.default)(AdminMemberListController, [{
	    key: 'getSchoolsSchoolIdMembers',
	    value: function getSchoolsSchoolIdMembers() {
	      var _this = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	      var membersParams = {
	        schoolId: this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID]
	      };
	      this.commonApiFactory.getAdminSchoolsSchoolIdMembers(membersParams).then(function (result) {
	        _this.memberList = [];
	        if (result.length === 0) {
	          _this.existenceFlg = false;
	          _this.commonFactory.overlayHidden();
	          _this.$scope.$apply();
	          return;
	        }
	        result.forEach(function (member) {
	          var memberObj = {
	            id: member.id,
	            displayId: member.displayId,
	            name: member.name,
	            gender: _this.commonFactory.getGenderName(member.gender),
	            status: _this.commonFactory.getPaddingZero(member.data.sensorRental, 2) + '-' + _this.commonFactory.getPaddingZero(member.data.user_type, 8) + '-' + _this.commonFactory.getPaddingZero(member.data.passwordStatus, 2)
	          };
	          _this.memberList.push(memberObj);
	        });
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      }).catch(function (error) {
	        _this.existenceFlg = false;
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	        console.log('error : ', error);
	      });
	    }
	  }, {
	    key: 'generatePassword',
	    value: function generatePassword(member, event) {
	      event.stopPropagation();
	      this.$rootScope.targetId = member.id;
	      this.$rootScope.password = this.commonFactory.createImterimPassword();
	    }
	  }, {
	    key: 'toMemberDetail',
	    value: function toMemberDetail(member) {
	      this.$sessionStorage[this.Const.SSAPP_MEMBER_ID] = member.id;
	      this.$sessionStorage[this.Const.SSAPP_USER_NAME] = member.name;
	      this.$sessionStorage[this.Const.SSAPP_GENDER] = member.gender;
	      this.$location.path('/staff/member_detail');
	    }
	  }]);
	  return AdminMemberListController;
	}();
	
	_angular2.default.module('myApp').controller('AdminMemberListController', AdminMemberListController);

/***/ },

/***/ 284:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(239);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminTopController = function () {
	  /* @ngInject */
	  AdminTopController.$inject = ["$scope", "$sessionStorage", "$location", "commonApiFactory", "commonFactory", "Const", "Page"];
	  function AdminTopController($scope, $sessionStorage, $location, commonApiFactory, commonFactory, Const, Page) {
	    (0, _classCallCheck3.default)(this, AdminTopController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.$location = $location;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.schoolName = '';
	    this.commonFactory.overlayHidden();
	    this.commonFactory.deleteErrorFlg();
	
	    if (!navigator.onLine) {
	      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	      return;
	    }
	
	    if (localStorage.getItem(this.Const.LSAPP_ROLE) === this.Const.LSAPP_ROLE_S_ADMIN) {
	      // 表示校名取得
	      this.getCompaniesMeSchools();
	    } else {
	      // 表示校名
	      this.schoolName = this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME];
	    }
	
	    Page.setTitle(this.Const.TITLE.topForSchoolAdmin);
	
	    AdminTopController.$inject = ['$scope', '$sessionStorage', '$location', 'commonApiFactory', 'commonFactory', 'Const', 'Page'];
	  }
	
	  (0, _createClass3.default)(AdminTopController, [{
	    key: 'getCompaniesMeSchools',
	    value: function getCompaniesMeSchools() {
	      var _this = this;
	
	      this.commonFactory.overlayShow();
	      this.commonApiFactory.getAdminCompaniesMeSchools().then(function (result) {
	        _this.schoolList = [];
	        result.forEach(function (school) {
	          var schoolObj = {
	            id: school.id,
	            name: school.name
	          };
	          _this.schoolList.push(schoolObj);
	        });
	        var schoolFilter = _this.schoolList.filter(function (item) {
	          if (parseInt(item.id) === this.r) return true;
	        }, { r: _this.$sessionStorage[_this.Const.SSAPP_SCHOOL_ID] });
	        if ((0, _keys2.default)(schoolFilter).length > 0) {
	          var targetSchool = schoolFilter.shift();
	          _this.$sessionStorage[_this.Const.SSAPP_SCHOOL_NAME] = targetSchool.name;
	          _this.schoolName = _this.$sessionStorage[_this.Const.SSAPP_SCHOOL_NAME];
	        }
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      }).catch(function (error) {
	        console.log('error : ', error);
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'toCoachList',
	    value: function toCoachList() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$location.path('/admin/coach');
	    }
	  }, {
	    key: 'toMemberList',
	    value: function toMemberList() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$location.path('/admin/member');
	    }
	  }, {
	    key: 'toCourseList',
	    value: function toCourseList() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$sessionStorage[this.Const.SSAPP_ADMIN_COURSE_LIST_LOCATION] = this.Const.ADMIN_COURSE_LIST_LOCATION.adminTop;
	      this.$location.path('/admin/course');
	    }
	  }]);
	  return AdminTopController;
	}();
	
	_angular2.default.module('myApp').controller('AdminTopController', AdminTopController);

/***/ },

/***/ 285:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminSchoolListController = function () {
	  /* @ngInject */
	  AdminSchoolListController.$inject = ["$rootScope", "$scope", "$sessionStorage", "$location", "commonApiFactory", "commonFactory", "Const", "Page"];
	  function AdminSchoolListController($rootScope, $scope, $sessionStorage, $location, commonApiFactory, commonFactory, Const, Page) {
	    (0, _classCallCheck3.default)(this, AdminSchoolListController);
	
	    this.Const = Const;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.$location = $location;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.commonFactory.overlayHidden();
	    this.commonFactory.deleteErrorFlg();
	
	    // School AdminもCompany AdminのAPIを叩けてしまうため、
	    // 画面遷移を阻止
	    if (localStorage.getItem(this.Const.LSAPP_ROLE) !== this.Const.LSAPP_ROLE_C_ADMIN) {
	      this.$location.path('/admin');
	    }
	
	    // APIから取得したスクールが存在している場合：true
	    // APIから取得したスクールが存在していない場合：false
	    this.existenceFlg = true;
	
	    this.getCompaniesMeSchools();
	
	    Page.setTitle(this.Const.TITLE.topForCompanyAdmin);
	
	    AdminSchoolListController.$inject = ['$rootScope', '$scope', '$sessionStorage', '$location', 'commonApiFactory', 'commonFactory', 'Const', 'Page'];
	  }
	
	  (0, _createClass3.default)(AdminSchoolListController, [{
	    key: 'getCompaniesMeSchools',
	    value: function getCompaniesMeSchools() {
	      var _this = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	      this.commonApiFactory.getAdminCompaniesMeSchools().then(function (result) {
	        _this.schoolList = [];
	        if (result.length === 0) {
	          _this.existenceFlg = false;
	          _this.commonFactory.overlayHidden();
	          _this.$scope.$apply();
	          return;
	        }
	        result.forEach(function (school) {
	          var schoolObj = {
	            id: school.id,
	            name: school.name
	          };
	          _this.schoolList.push(schoolObj);
	        });
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      }).catch(function (error) {
	        _this.existenceFlg = false;
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	        console.log('error : ', error);
	      });
	    }
	  }, {
	    key: 'toSchoolTop',
	    value: function toSchoolTop(school) {
	      this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID] = school.id;
	      this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME] = school.name;
	      this.$location.path('/admin');
	    }
	  }, {
	    key: 'generatePassword',
	    value: function generatePassword(school) {
	      this.$rootScope.targetId = school.id;
	      this.$rootScope.password = this.commonFactory.createImterimPassword();
	    }
	  }]);
	  return AdminSchoolListController;
	}();
	
	_angular2.default.module('myApp').controller('AdminSchoolListController', AdminSchoolListController);

/***/ },

/***/ 286:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _moment = __webpack_require__(59);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminCourseListController = function () {
	  /* @ngInject */
	  AdminCourseListController.$inject = ["$rootScope", "$scope", "$sessionStorage", "$location", "commonApiFactory", "commonFactory", "Const", "Page"];
	  function AdminCourseListController($rootScope, $scope, $sessionStorage, $location, commonApiFactory, commonFactory, Const, Page) {
	    (0, _classCallCheck3.default)(this, AdminCourseListController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
	    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
	    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
	    this.$rootScope = $rootScope;
	    this.$location = $location;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	    this.commonFactory.overlayHidden();
	    this.commonFactory.deleteErrorFlg();
	    var role = localStorage.getItem(this.Const.LSAPP_ROLE);
	    if (role === this.Const.LSAPP_ROLE_MEMBER) {
	      this.$location.path('/member');
	    }
	
	    // APIから取得したコースが存在している場合：true
	    // APIから取得したコースが存在していない場合：false
	    this.existenceFlg = true;
	
	    // ゲスト動画からの遷移の場合、下部ボタンリストを表示しない
	    this.showButtonList = this.$sessionStorage[this.Const.SSAPP_ADMIN_COURSE_LIST_LOCATION] !== this.Const.ADMIN_COURSE_LIST_LOCATION.guestVideo;
	
	    // staffは全クラス一覧ボタン押下から選択日付を持って遷移
	    this.currentDate = this.$sessionStorage[this.Const.SSAPP_SELECTED_DATE] ? new Date(this.$sessionStorage[this.Const.SSAPP_SELECTED_DATE]) : new Date();
	    // staff権限は当月、admin権限は前後三ヵ月を抽出Rangeとする
	    if (role === this.Const.LSAPP_ROLE_STAFF) {
	      this.monthRange = this.commonFactory.getMonthRange(this.currentDate);
	      this.selectedYearMonth = (0, _moment2.default)(this.currentDate).format('YYYY年M月');
	      this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;
	      Page.setTitle(this.Const.TITLE.courseListForStaff);
	    } else {
	      this.monthRange = this.commonFactory.getThreeMonthsBeforeAndAfter(this.currentDate);
	      Page.setTitle(this.Const.TITLE.courseList);
	    }
	    this.getSchoolsSchoolIdCourses(this.monthRange.beginDateParam, this.monthRange.endDateParam);
	
	    AdminCourseListController.$inject = ['$rootScope', '$scope', '$sessionStorage', '$location', 'commonApiFactory', 'commonFactory', 'Const', 'Page'];
	  }
	
	  (0, _createClass3.default)(AdminCourseListController, [{
	    key: 'getSchoolsSchoolIdCourses',
	    value: function getSchoolsSchoolIdCourses(begin, end) {
	      var _this = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	      this.coursesParams = {
	        schoolId: this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID],
	        beginDateTime: begin,
	        endDateTime: end
	      };
	      this.commonApiFactory.getAdminSchoolsSchoolIdCourses(this.coursesParams).then(function (result) {
	        _this.courseList = [];
	        if (result.length === 0) {
	          _this.existenceFlg = false;
	          _this.commonFactory.overlayHidden();
	          _this.$scope.$apply();
	          return;
	        }
	        result.forEach(function (course) {
	          var courseObj = {
	            courseId: course.id,
	            schoolId: course.schoolId,
	            schoolName: _this.$sessionStorage[_this.Const.SSAPP_SCHOOL_NAME],
	            courseName: course.name
	          };
	          _this.courseList.push(courseObj);
	        });
	        _this.$sessionStorage[_this.Const.SSAPP_COURSE_LIST] = _this.courseList;
	        _this.existenceFlg = true;
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	      }).catch(function (error) {
	        _this.existenceFlg = false;
	        _this.commonFactory.overlayHidden();
	        _this.$scope.$apply();
	        console.log('error : ', error);
	      });
	    }
	
	    // 基準からみて次の月に該当するコースを表示する
	
	  }, {
	    key: 'toNextMonth',
	    value: function toNextMonth() {
	      var currentDate = this.currentDate;
	      var nextMonthRange = this.commonFactory.getMonthLater(currentDate);
	      // 次の月を基準とする
	      this.currentDate = new Date(nextMonthRange.beginDateParam);
	      this.selectedYearMonth = (0, _moment2.default)(this.currentDate).format('YYYY年M月');
	      this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;
	      this.getSchoolsSchoolIdCourses(nextMonthRange.beginDateParam, nextMonthRange.endDateParam);
	    }
	
	    // 基準からみて前の月に該当するコースを表示する
	
	  }, {
	    key: 'toBeforeMonth',
	    value: function toBeforeMonth() {
	      var currentDate = this.currentDate;
	      var beforeMonthRange = this.commonFactory.getMonthAgo(currentDate);
	      // 前の月を基準とする
	      this.currentDate = new Date(beforeMonthRange.beginDateParam);
	      this.selectedYearMonth = (0, _moment2.default)(this.currentDate).format('YYYY年M月');
	      this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;
	      this.getSchoolsSchoolIdCourses(beforeMonthRange.beginDateParam, beforeMonthRange.endDateParam);
	    }
	  }, {
	    key: 'toCourseDetail',
	    value: function toCourseDetail(course, idx) {
	      this.$sessionStorage[this.Const.SSAPP_COURSE_INDEX] = idx;
	      this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME] = course.schoolName;
	      // 次の画面でコースを受講している生徒を取得するために必要
	      this.$sessionStorage[this.Const.SSAPP_COURSE_ID] = course.courseId;
	      this.$location.path('/staff/course');
	    }
	  }, {
	    key: 'toGuestVideoList',
	    value: function toGuestVideoList() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$location.path('/staff/guest_video');
	    }
	  }, {
	    key: 'toVideoBacklog',
	    value: function toVideoBacklog() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.$location.path('/staff/video_backlog');
	    }
	  }]);
	  return AdminCourseListController;
	}();
	
	_angular2.default.module('myApp').controller('AdminCourseListController', AdminCourseListController);

/***/ },

/***/ 287:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _moment = __webpack_require__(59);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMPONENT_NAME = 'personalCard';
	
	var PersonalCardController = function () {
	  /* @ngInject */
	  PersonalCardController.$inject = ["$scope", "$sessionStorage", "$timeout", "commonApiFactory", "commonFactory", "Const"];
	  function PersonalCardController($scope, $sessionStorage, $timeout, commonApiFactory, commonFactory, Const) {
	    (0, _classCallCheck3.default)(this, PersonalCardController);
	
	    this.Const = Const;
	    this.$scope = $scope;
	    this.$sessionStorage = $sessionStorage;
	    this.$timeout = $timeout;
	    this.commonApiFactory = commonApiFactory;
	    this.commonFactory = commonFactory;
	
	    this.hasMessage = false;
	    this.isCoach = localStorage.getItem(this.Const.LSAPP_ROLE) !== this.Const.LSAPP_ROLE_MEMBER;
	
	    this.isCreateMode = false;
	    this.isUpdateMode = false;
	    this.isDialogOpened = false;
	
	    // 表示名 表示性別 敬称 テーマ対象
	    this.displayName = '';
	    this.displayGender = '';
	    this.honorificTitle = '';
	    this.targetId = '';
	
	    // 表示メッセージ
	    this.message = '';
	    this.initMessage = '';
	    this.displayYear = '';
	    this.displayMonth = '';
	    this.displayDate = '';
	
	    // 表示メッセージ(一時保存用)
	    this.hasDraftMessage = false;
	    this.draftMessage = '';
	
	    // テーマ設定
	    this.themeMinHeight = 60;
	    this.themeMaxHeight = 80;
	    this.isOverflow = false;
	    this.isAllView = false;
	    this.readMoreLabel = this.Const.READ_MORE_LABEL.open;
	    this.draftMinHeight = 60;
	    this.draftMaxHeight = 80;
	    this.isDraftOverflow = false;
	    this.isDraftAllView = false;
	    this.draftReadMoreLabel = this.Const.READ_MORE_LABEL.open;
	
	    // validateメッセージ表示判定
	    this.validationForPersonalCard = {
	      isEmpty: false,
	      isOverLength: false,
	      isProhibitionChars: false
	    };
	
	    if (this.isCoach) {
	      if (this.coachView) {
	        // 生徒の情報を参照
	        this.displayName = this.$sessionStorage[this.Const.SSAPP_USER_NAME];
	        this.displayGender = this.$sessionStorage[this.Const.SSAPP_GENDER];
	        this.honorificTitle = 'さん';
	        this.targetId = this.$sessionStorage[this.Const.SSAPP_MEMBER_ID];
	      } else {
	        // 自身の情報を参照
	        this.displayName = this.$sessionStorage[this.Const.SSAPP_COACH_NAME];
	        this.displayGender = this.$sessionStorage[this.Const.SSAPP_COACH_GENDER];
	        this.honorificTitle = 'コーチ';
	        this.targetId = '';
	      }
	    } else {
	      // 生徒自身の情報を参照
	      this.displayName = this.$sessionStorage[this.Const.SSAPP_USER_NAME];
	      this.displayGender = this.$sessionStorage[this.Const.SSAPP_GENDER];
	      this.honorificTitle = 'さん';
	      this.targetId = '';
	    }
	
	    // genderのimagePath取得
	    switch (this.displayGender) {
	      case this.Const.GENDER_TYPE.male:
	        this.displayImagePath = 'res/st_top/common_icon_user_male.png';
	        break;
	      case this.Const.GENDER_TYPE.female:
	        this.displayImagePath = 'res/st_top/common_icon_user_female.png';
	        break;
	      default:
	        this.displayImagePath = 'res/st_top/common_icon_user_default.png';
	    }
	
	    // 整合性チェック
	    if (!this.showTheme) {
	      // テーマ非表示の場合、編集不可&データ取得不要
	      this.editMode = false;
	      this.targetId = '';
	    }
	    // 編集可能なのにコーチではない
	    if (this.editMode && !this.isCoach) {
	      // 編集不可に
	      this.editMode = false;
	    }
	
	    if (this.targetId) {
	      this.getMemberIdMessages();
	    } else {
	      if (!this.isCoach) {
	        this.getMeMessages();
	      }
	    }
	
	    this.initThemeView();
	    this.initDraftView();
	
	    PersonalCardController.$inject = ['$scope', '$sessionStorage', '$timeout', 'commonApiFactory', 'commonFactory', 'Const'];
	  }
	
	  (0, _createClass3.default)(PersonalCardController, [{
	    key: 'initThemeView',
	    value: function initThemeView() {
	      var _this = this;
	
	      /*
	        min-heightは表示が3行になる高さに指定。
	        max-heightは表示が4行になる高さに指定。
	        表示情報がmin-heightを下回ればmin-heightが適用。上回ればmax-heightが適用。
	        overflow:hiddenを適用しているのでそれ以上は表示されない。
	        scrollHeightは非表示を含めた実値のためそれを上回る高さの場合は
	      */
	      this.$timeout(function () {
	        if (document.getElementById('viewTheme')) {
	          if (_this.themeViewAll) {
	            _this.readMore();
	          } else {
	            var sHeight = document.getElementById('viewTheme').scrollHeight;
	            _this.isOverflow = sHeight > _this.themeMaxHeight;
	            if (_this.isOverflow) {
	              // themeMaxHeightを底上げしたのは半透明部分
	              _this.themeMaxHeight = 120;
	            }
	            _this.readMoreLabel = _this.isOverflow ? _this.Const.READ_MORE_LABEL.open : _this.Const.READ_MORE_LABEL.close;
	          }
	        }
	      }, 3000);
	    }
	  }, {
	    key: 'initDraftView',
	    value: function initDraftView() {
	      var _this2 = this;
	
	      this.$timeout(function () {
	        if (document.getElementById('viewDraft')) {
	          _this2.draftReadMore();
	        }
	      }, 3000);
	    }
	  }, {
	    key: 'readMore',
	    value: function readMore() {
	      this.isAllView = !this.isAllView;
	      if (this.isAllView) {
	        this.themeMaxHeight = document.getElementById('viewTheme').scrollHeight;
	        this.readMoreLabel = this.Const.READ_MORE_LABEL.close;
	        // オープン時にリンクを削除対応。以下を削除するとcloseリンク出力
	        this.isOverflow = false;
	      } else {
	        this.themeMaxHeight = 80;
	        this.readMoreLabel = this.Const.READ_MORE_LABEL.open;
	      }
	    }
	  }, {
	    key: 'draftReadMore',
	    value: function draftReadMore() {
	      this.isDraftAllView = !this.isDraftAllView;
	      if (this.isDraftAllView) {
	        this.draftMaxHeight = document.getElementById('viewDraft').scrollHeight;
	        this.draftReadMoreLabel = this.Const.READ_MORE_LABEL.close;
	        // オープン時にリンクを削除対応。以下を削除するとcloseリンク出力
	        this.isDraftOverflow = false;
	      } else {
	        this.draftMaxHeight = 80;
	        this.draftReadMoreLabel = this.Const.READ_MORE_LABEL.open;
	      }
	    }
	  }, {
	    key: 'getMemberIdMessages',
	    value: function getMemberIdMessages() {
	      var _this3 = this;
	
	      var getMembersMemberIdMessagesParams = {
	        memberId: this.targetId,
	        type: 1
	      };
	      this.commonApiFactory.getMembersMemberIdMessages(getMembersMemberIdMessagesParams).then(function (result) {
	        _this3.hasMessage = false;
	        if (result.length > 0) {
	          result.reverse();
	          result = result.filter(function (element) {
	            if (element['data']['isUnpublished']) {
	              _this3.hasDraftMessage = true;
	              _this3.draftMessageId = element['id'];
	              _this3.draftMessage = element['data']['message'];
	            }
	            return !element['data']['isUnpublished'];
	          });
	          // 一時保存テーマを除外したresultからさらに最新のテーマを取得する
	          if (result.length > 0) {
	            var message = result.shift();
	            _this3.hasMessage = true;
	            _this3.messageId = message['id'];
	            _this3.message = message['data']['message'];
	            _this3.initMessage = _this3.message;
	            _this3.displayYear = (0, _moment2.default)(message['createdAt']).format('YYYY');
	            _this3.displayMonth = (0, _moment2.default)(message['createdAt']).format('MM');
	            _this3.displayDate = (0, _moment2.default)(message['createdAt']).format('DD');
	          }
	        }
	        _this3.$scope.$apply();
	      }).catch(function (error) {
	        // エラー発生時、テーマを非表示に
	        _this3.showTheme = false;
	        _this3.$scope.$apply();
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'getMeMessages',
	    value: function getMeMessages() {
	      var _this4 = this;
	
	      var getMembersMeMessagesParams = {
	        type: 1
	      };
	      this.commonApiFactory.getMembersMeMessages(getMembersMeMessagesParams).then(function (result) {
	        _this4.hasMessage = false;
	        if (result.length > 0) {
	          _this4.showTheme = true;
	          result.reverse();
	          var message = result.shift();
	          _this4.hasMessage = true;
	          _this4.messageId = message['id'];
	          _this4.message = message['data']['message'];
	          _this4.initMessage = _this4.message;
	          _this4.displayYear = (0, _moment2.default)(message['createdAt']).format('YYYY');
	          _this4.displayMonth = (0, _moment2.default)(message['createdAt']).format('MM');
	          _this4.displayDate = (0, _moment2.default)(message['createdAt']).format('DD');
	        }
	        // メッセージが取得できなかった場合、メッセージ表示領域自体を非表示にする
	        if (!_this4.hasMessage) {
	          _this4.showTheme = false;
	        }
	        _this4.$scope.$apply();
	      }).catch(function (error) {
	        // エラー発生時、テーマを非表示に
	        _this4.showTheme = false;
	        _this4.$scope.$apply();
	        console.log('error : ', error);
	      });
	    }
	  }, {
	    key: 'create',
	    value: function create() {
	      var _this5 = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	
	      if (this.validatePersonalCard()) {
	        this.commonFactory.overlayHidden();
	        return;
	      }
	
	      var params = { memberId: this.targetId };
	      var bodies = { type: 1, data: { message: $('#txtMessage').val(), isUnpublished: true } };
	      this.commonApiFactory.postMembersMemberIdMessages(params, bodies).then(function (message) {
	        _this5.commonFactory.overlayHidden();
	        _this5.$scope.$apply();
	        _this5.openDialog('公開予定の個人テーマを新規設定しました。');
	      }).catch(function (error) {
	        console.log('error : ', error);
	        _this5.commonFactory.flashErrorMessageFlag(_this5.Const.SSAPP_HAS_UNEXPECTED_ERROR, 5000, false);
	        _this5.commonFactory.overlayHidden();
	        _this5.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this6 = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	
	      if (this.validatePersonalCard()) {
	        this.commonFactory.overlayHidden();
	        return;
	      }
	
	      this.draftMessage = $('#txtMessage').val();
	      var params = { memberId: this.targetId };
	      var bodies = { id: this.draftMessageId, data: { message: this.draftMessage } };
	      this.commonApiFactory.putMembersMemberIdMessages(params, bodies).then(function (message) {
	        _this6.commonFactory.overlayHidden();
	        _this6.$scope.$apply();
	        _this6.openDialog('公開予定の個人テーマの編集が完了しました。');
	      }).catch(function (error) {
	        console.log('error : ', error);
	        _this6.commonFactory.flashErrorMessageFlag(_this6.Const.SSAPP_HAS_UNEXPECTED_ERROR, 5000, false);
	        _this6.commonFactory.overlayHidden();
	        _this6.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'publish',
	    value: function publish() {
	      var _this7 = this;
	
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      } else {
	        this.commonFactory.overlayShow();
	      }
	
	      var params = { memberId: this.targetId };
	      var bodies = { id: this.draftMessageId, data: { isUnpublished: false } };
	      this.commonApiFactory.putMembersMemberIdMessages(params, bodies).then(function (message) {
	        _this7.commonFactory.overlayHidden();
	        _this7.$scope.$apply();
	        _this7.openDialog('個人テーマが公開されました。');
	      }).catch(function (error) {
	        console.log('error : ', error);
	        _this7.commonFactory.flashErrorMessageFlag(_this7.Const.SSAPP_HAS_UNEXPECTED_ERROR, 5000, false);
	        _this7.commonFactory.overlayHidden();
	        _this7.$scope.$apply();
	      });
	    }
	  }, {
	    key: 'validatePersonalCard',
	    value: function validatePersonalCard() {
	      var str = $('#txtMessage').val();
	      if (!str) {
	        this.changeErrorMessage(true, false, false);
	      } else if (str.length > 1000) {
	        // this.changeErrorMessage(false, true, false)
	        this.changeErrorMessage(false, false, false);
	        return false;
	      } else if (this.commonFactory.isProhibitionChars(str)) {
	        // this.changeErrorMessage(false, false, true);
	        this.changeErrorMessage(false, false, false);
	        return false;
	      } else {
	        this.changeErrorMessage(false, false, false);
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'changeErrorMessage',
	    value: function changeErrorMessage(empty, overLength, prohibitionChars) {
	      this.validationForPersonalCard.isEmpty = empty;
	      this.validationForPersonalCard.isOverLength = overLength;
	      this.validationForPersonalCard.isProhibitionChars = prohibitionChars;
	    }
	  }, {
	    key: 'enterCreateMode',
	    value: function enterCreateMode() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.message = '';
	      this.editMode = true;
	      this.isCreateMode = true;
	    }
	  }, {
	    key: 'enterUpdateMode',
	    value: function enterUpdateMode() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      this.editMode = true;
	      this.isUpdateMode = true;
	    }
	  }, {
	    key: 'cancelMode',
	    value: function cancelMode() {
	      if (!navigator.onLine) {
	        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	        return;
	      }
	      location.reload();
	    }
	  }, {
	    key: 'openDialog',
	    value: function openDialog(message) {
	      this.isDialogOpened = true;
	      this.dialogMessage = message;
	    }
	  }, {
	    key: 'closeDialog',
	    value: function closeDialog() {
	      this.isDialogOpened = false;
	      location.reload();
	    }
	  }]);
	  return PersonalCardController;
	}();
	
	_angular2.default.module('myApp').component(COMPONENT_NAME, {
	  bindings: {
	    name: '@' + COMPONENT_NAME,
	    showTheme: '=showtheme',
	    themeViewAll: '=themeviewall',
	    coachView: '=coachview',
	    editMode: '=editmode'
	  },
	  controller: PersonalCardController,
	  templateUrl: 'app/components/personal-card/personal-card.html'
	});

/***/ },

/***/ 288:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(289);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(188);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('myApp').factory('commonAuthFactory', ['$routeParams', '$sessionStorage', 'commonFactory', 'Const', function ($routeParams, $sessionStorage, commonFactory, Const) {
	  var _this = this;
	
	  this.$sessionStorage = $sessionStorage;
	  this.commonFactory = commonFactory;
	  /**
	   * switch dev, prod cognito setting for user(staff)
	   */
	  this.configureUserCognito = function () {
	    // host名取得
	    var hostname = window.location.hostname;
	    if (hostname === Const.PROD_HOST_NAME) {
	      _this.userPoolIdUser = Const.PROD_USER_COGNITO_USER_POOL_ID;
	      _this.clientIdUser = Const.PROD_USER_CLIENT_ID;
	      _this.identityPoolIdUser = Const.PROD_USER_COGNITO_ID_POOL_ID;
	    } else {
	      _this.userPoolIdUser = Const.DEV_USER_COGNITO_USER_POOL_ID;
	      _this.clientIdUser = Const.DEV_USER_CLIENT_ID;
	      _this.identityPoolIdUser = Const.DEV_USER_COGNITO_ID_POOL_ID;
	    }
	  };
	
	  this.configureStaffCognito = function () {
	    // host名取得
	    var hostname = window.location.hostname;
	    if (hostname === Const.PROD_HOST_NAME) {
	      _this.userPoolIdUser = Const.PROD_STAFF_COGNITO_USER_POOL_ID;
	      _this.clientIdUser = Const.PROD_STAFF_CLIENT_ID;
	      _this.identityPoolIdUser = Const.PROD_STAFF_COGNITO_ID_POOL_ID;
	    } else {
	      _this.userPoolIdUser = Const.DEV_STAFF_COGNITO_USER_POOL_ID;
	      _this.clientIdUser = Const.DEV_STAFF_CLIENT_ID;
	      _this.identityPoolIdUser = Const.DEV_STAFF_COGNITO_ID_POOL_ID;
	    }
	  };
	
	  /**
	   * UserIDとパスワードを使いユーザ認証を行い、CognitoからTemporary Credentialsを取得する
	   * 認証に成功した場合はPromiseでCredentialsを返す
	   */
	  this.userLogin = function (userId, userPassword, newPassword) {
	    return new _promise2.default(function (resolve, reject) {
	      _this.configureUserCognito();
	      var authenticationData = {
	        Username: userId,
	        Password: userPassword
	      };
	      var authenticationDetails = new AWSCognito.CognitoIdentityServiceProvider.AuthenticationDetails(authenticationData);
	      var poolData = {
	        UserPoolId: _this.userPoolIdUser,
	        ClientId: _this.clientIdUser,
	        Paranoia: 7
	      };
	      var userPool = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(poolData);
	      var userData = {
	        Username: userId,
	        Pool: userPool
	      };
	      var cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);
	
	      // ユーザ認証を行う
	      cognitoUser.authenticateUser(authenticationDetails, {
	        onSuccess: function onSuccess(authresult) {
	          var jwtToken = authresult.getIdToken().getJwtToken();
	          var refreshToken = authresult.getRefreshToken().getToken();
	          var accessToken = authresult.getAccessToken().getJwtToken();
	          // ユーザ認証で得たIDTokenを元にTemporary Credentialsを取得する
	          getCredentials(jwtToken, function (error, value) {
	            if (error) {
	              return reject(error);
	            }
	            localStorage.setItem(Const.LSKEY_USER_ID, userId);
	            localStorage.setItem(Const.LSKEY_USER_ID_TOKEN, jwtToken);
	            localStorage.setItem(Const.LSKEY_USER_REFRESH_TOKEN, refreshToken);
	            localStorage.setItem(Const.LSKEY_USER_ACCESS_TOKEN, accessToken);
	            return resolve(value);
	          });
	        },
	        onFailure: function onFailure(err) {
	          return reject(err);
	        },
	
	        // 仮パスワードの場合
	        newPasswordRequired: function newPasswordRequired(userAttributes, requiredAttributes) {
	          localStorage.setItem(Const.LSKEY_USER_ID, userId);
	          // 新しいパスワードがあれば、パスワードを変更
	          if (newPassword != null) {
	            var attributeData = null;
	            cognitoUser.completeNewPasswordChallenge(newPassword, attributeData, {
	              onSuccess: function onSuccess(authresult) {
	                var jwtToken = authresult.getIdToken().getJwtToken();
	                var accessToken = authresult.getAccessToken().getJwtToken();
	                var refreshToken = authresult.getRefreshToken().getToken();
	                // ユーザ認証で得たIDTokenを元にTemporary Credentialsを取得する
	                getCredentials(jwtToken, function (error, value) {
	                  if (error) {
	                    return reject(error);
	                  }
	                  localStorage.setItem(Const.LSKEY_USER_ID_TOKEN, jwtToken);
	                  localStorage.setItem(Const.LSKEY_USER_REFRESH_TOKEN, refreshToken);
	                  localStorage.setItem(Const.LSKEY_USER_ACCESS_TOKEN, accessToken);
	                  return resolve(value);
	                });
	              },
	              onFailure: function onFailure(err) {
	                return reject(err);
	              }
	            });
	          } else {
	            // 新しいパスワードが未入力の場合、パスワード変更画面に遷移
	            _this.$sessionStorage[Const.SSAPP_IS_TMP_PASSWORD] = true;
	            _this.$sessionStorage[Const.SSAPP_IS_LOADING] = false;
	            location.href = '#/password_change';
	          }
	        }
	      });
	    });
	  };
	
	  /*
	   * パスワードを変更する
	   */
	  this.changePassword = function (oldPassword, newPassword) {
	    return new _promise2.default(function (resolve, reject) {
	      if (localStorage.getItem(Const.LSAPP_ROLE) === Const.LSAPP_ROLE_MEMBER) {
	        _this.configureUserCognito();
	      } else {
	        _this.configureStaffCognito();
	      }
	      var userId = localStorage.getItem(Const.LSKEY_USER_ID);
	      var poolData = {
	        UserPoolId: _this.userPoolIdUser,
	        ClientId: _this.clientIdUser,
	        Paranoia: 7
	      };
	      var userPool = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(poolData);
	      var userData = {
	        Username: userId,
	        Pool: userPool
	      };
	      var cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);
	      cognitoUser.signInUserSession = cognitoUser.getCognitoUserSession({
	        IdToken: localStorage.getItem(Const.LSKEY_USER_ID_TOKEN),
	        AccessToken: localStorage.getItem(Const.LSKEY_USER_ACCESS_TOKEN),
	        RefreshToken: localStorage.getItem(Const.LSKEY_USER_REFRESH_TOKEN)
	      });
	
	      cognitoUser.changePassword(oldPassword, newPassword, function (err, result) {
	        if (err) {
	          return reject(err);
	        }
	        return resolve();
	      });
	    });
	  };
	
	  /**
	   * IDTokenを元にCognitoからTemporary Credentialsを取得する
	   */
	  this.staffLogin = function (userId, userPassword, newPassword) {
	    return new _promise2.default(function (resolve, reject) {
	      _this.configureStaffCognito();
	      var authenticationData = {
	        Username: userId,
	        Password: userPassword
	      };
	      var authenticationDetails = new AWSCognito.CognitoIdentityServiceProvider.AuthenticationDetails(authenticationData);
	      var poolData = {
	        UserPoolId: _this.userPoolIdUser,
	        ClientId: _this.clientIdUser,
	        Paranoia: 7
	      };
	      var userPool = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(poolData);
	      var userData = {
	        Username: userId,
	        Pool: userPool
	      };
	      var cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);
	
	      // ユーザ認証を行う
	      cognitoUser.authenticateUser(authenticationDetails, {
	        onSuccess: function onSuccess(authresult) {
	          var jwtToken = authresult.getIdToken().getJwtToken();
	          var refreshToken = authresult.getRefreshToken().getToken();
	          var accessToken = authresult.getAccessToken().getJwtToken();
	          // ユーザ認証で得たIDTokenを元にTemporary Credentialsを取得する
	          getCredentials(jwtToken, function (error, value) {
	            if (error) {
	              return reject(error);
	            }
	            localStorage.setItem(Const.LSKEY_USER_ID, userId);
	            localStorage.setItem(Const.LSKEY_USER_ID_TOKEN, jwtToken);
	            localStorage.setItem(Const.LSKEY_USER_REFRESH_TOKEN, refreshToken);
	            localStorage.setItem(Const.LSKEY_USER_ACCESS_TOKEN, accessToken);
	            return resolve(value);
	          });
	        },
	        onFailure: function onFailure(err) {
	          return reject(err);
	        },
	
	        // 仮パスワードの場合
	        newPasswordRequired: function newPasswordRequired(userAttributes, requiredAttributes) {
	          localStorage.setItem(Const.LSKEY_USER_ID, userId);
	          // 新しいパスワードがあれば、パスワードを変更
	          if (newPassword != null) {
	            var attributeData = null;
	            cognitoUser.completeNewPasswordChallenge(newPassword, attributeData, {
	              onSuccess: function onSuccess(authresult) {
	                var jwtToken = authresult.getIdToken().getJwtToken();
	                var accessToken = authresult.getAccessToken().getJwtToken();
	                var refreshToken = authresult.getRefreshToken().getToken();
	                // ユーザ認証で得たIDTokenを元にTemporary Credentialsを取得する
	                getCredentials(jwtToken, function (error, value) {
	                  if (error) {
	                    return reject(error);
	                  }
	                  localStorage.setItem(Const.LSKEY_USER_ID_TOKEN, jwtToken);
	                  localStorage.setItem(Const.LSKEY_USER_REFRESH_TOKEN, refreshToken);
	                  localStorage.setItem(Const.LSKEY_USER_ACCESS_TOKEN, accessToken);
	                  return resolve(value);
	                });
	              },
	              onFailure: function onFailure(err) {
	                return reject(err);
	              }
	            });
	          } else {
	            // 新しいパスワードが未入力の場合、パスワード変更画面に遷移
	            _this.$sessionStorage[Const.SSAPP_IS_TMP_PASSWORD] = true;
	            _this.$sessionStorage[Const.SSAPP_IS_LOADING] = false;
	            location.href = '#/password_change';
	          }
	        }
	      });
	    });
	  };
	
	  /**
	   * IDTokenを元にCognitoからTemporary Credentialsを取得する
	   */
	  var getCredentials = function getCredentials(jwtToken, callback) {
	    var loginStr = 'cognito-idp.' + Const.REGION + '.amazonaws.com/' + _this.userPoolIdUser;
	    var identityObj = {};
	    identityObj = {
	      IdentityPoolId: _this.identityPoolIdUser,
	      Logins: {}
	    };
	    identityObj.Logins[loginStr] = jwtToken;
	    AWS.config.region = Const.REGION;
	    AWS.config.credentials = new AWS.CognitoIdentityCredentials(identityObj);
	    AWS.config.credentials.clearCachedId();
	    AWS.config.credentials.get(function (err) {
	      if (err) {
	        callback(err, null);
	        return;
	      }
	      var accessKeyId = AWS.config.credentials.accessKeyId;
	      var secretAccessKey = AWS.config.credentials.secretAccessKey;
	      var sessionToken = AWS.config.credentials.sessionToken;
	      callback(null, {
	        accessKeyId: accessKeyId,
	        secretAccessKey: secretAccessKey,
	        sessionToken: sessionToken
	      });
	    });
	  };
	
	  /**
	   * ユーザ認証で得たTemporary Credentialsにより、
	   * FunctionAPIの実行権限が付与されたCredentialsを取得する
	   * PromiseでCredentialsが返る
	   */
	  this.getCredentialsForAPI = function (credentials, role) {
	    return new _promise2.default(function (resolve, reject) {
	      if (!credentials) {
	        return reject('Please authenticate.');
	      }
	      var accessKeyId = credentials.accessKeyId;
	      var secretAccessKey = credentials.secretAccessKey;
	      var sessionToken = credentials.sessionToken;
	      var apigClient = apigClientFactory.newClient({
	        'accessKey': accessKeyId,
	        'secretKey': secretAccessKey,
	        'sessionToken': sessionToken,
	        'region': Const.REGION
	      });
	      var body = void 0;
	      var params = void 0;
	      if (role === Const.LSAPP_ROLE_MEMBER) {
	        params = { role: Const.LSAPP_ROLE_MEMBER };
	      } else {
	        params = { role: Const.LSAPP_ROLE_STAFF };
	      }
	      apigClient.roleAuthorizationPost(params, body, {}).then(function (result) {
	        var credentials = result.data;
	        localStorage.setItem(Const.LSKEY_USER_ACCESS_KEY_ID, credentials.AccessKeyId);
	        localStorage.setItem(Const.LSKEY_USER_SECRET_ACCESS_KEY, credentials.SecretAccessKey);
	        localStorage.setItem(Const.LSKEY_USER_SESSION_TOKEN, credentials.SessionToken);
	        return resolve();
	      }).catch(function (result) {
	        if (result.response) {
	          if (result.response.status === 503) {
	            _this.commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          }
	        }
	        var errorRes = (0, _stringify2.default)(result);
	        return reject(errorRes);
	      });
	    });
	  };
	
	  /**
	   * RefreshTokenを使いIDTokenを取得し、CognitoからTemporary Credentialsを取得する
	   * PromiseでCredentialsを返す
	   */
	  this.refreshCredentials = function () {
	    return new _promise2.default(function (resolve, reject) {
	      var userRefreshToken = localStorage.getItem(Const.LSKEY_USER_REFRESH_TOKEN);
	      var userId = localStorage.getItem(Const.LSKEY_USER_ID);
	      var refreshToken = new AWSCognito.CognitoIdentityServiceProvider.CognitoRefreshToken({
	        RefreshToken: userRefreshToken
	      });
	      if (localStorage.getItem(Const.LSAPP_ROLE) === Const.LSAPP_ROLE_MEMBER) {
	        _this.configureUserCognito();
	      } else {
	        _this.configureStaffCognito();
	      }
	      var poolData = {
	        UserPoolId: _this.userPoolIdUser,
	        ClientId: _this.clientIdUser,
	        Paranoia: 7
	      };
	      var userPool = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(poolData);
	      var userData = {
	        Username: userId,
	        Pool: userPool
	      };
	      var cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);
	      cognitoUser.refreshSession(refreshToken, function (err, authresult) {
	        if (err) {
	          console.log(err);
	          return reject(err);
	        }
	        var jwtToken = authresult.getIdToken().getJwtToken();
	        var refreshToken = authresult.getRefreshToken().getToken();
	
	        // refreshで得たIDTokenを元にTemporary Credentialsを取得する
	        getCredentials(jwtToken, function (error, value) {
	          if (error) {
	            console.log(error);
	            return reject(error);
	          }
	          localStorage.setItem(Const.LSKEY_USER_REFRESH_TOKEN, refreshToken);
	          return resolve(value);
	        });
	      });
	    });
	  };
	
	  return this;
	}]);

/***/ },

/***/ 291:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(289);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(188);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('myApp').factory('commonApiFactory', ['$routeParams', '$timeout', 'commonAuthFactory', 'commonFactory', 'Const', function ($routeParams, $timeout, commonAuthFactory, commonFactory, Const) {
	  var checkKeyToken = function checkKeyToken() {
	    if (!localStorage.getItem(Const.LSKEY_USER_ACCESS_KEY_ID) || !localStorage.getItem(Const.LSKEY_USER_SECRET_ACCESS_KEY) || !localStorage.getItem(Const.LSKEY_USER_SESSION_TOKEN)) {
	      return false;
	    }
	    return true;
	  };
	
	  var createApigClient = function createApigClient() {
	    return apigClientFactory.newClient({
	      'accessKey': localStorage.getItem(Const.LSKEY_USER_ACCESS_KEY_ID),
	      'secretKey': localStorage.getItem(Const.LSKEY_USER_SECRET_ACCESS_KEY),
	      'sessionToken': localStorage.getItem(Const.LSKEY_USER_SESSION_TOKEN),
	      'region': Const.REGION
	    });
	  };
	
	  // Credentialをリフレッシュする
	  var refreshOnCredentials = function refreshOnCredentials() {
	    return new _promise2.default(function (resolve, reject) {
	      return commonAuthFactory.refreshCredentials().then(function (loginResult) {
	        return resolve(commonAuthFactory.getCredentialsForAPI(loginResult, localStorage.getItem(Const.LSAPP_ROLE)));
	      }).catch(function (error) {
	        commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_REFRESH_ERROR, 5000, true);
	        return reject(error);
	      });
	    });
	  };
	
	  // Credentialをリフレッシュ後、対象のコールバックを実行する
	  var callTargetApiAgain = function callTargetApiAgain(callBack, params, bodies, additionalParams) {
	    return new _promise2.default(function (resolve, reject) {
	      console.log('Retry...');
	      callBack(params, bodies, additionalParams).then(function (result) {
	        return resolve(result);
	      }).catch(function (error) {
	        return reject(error);
	      });
	    });
	  };
	
	  /*
	    ADMIN COMPANIES ME / GET
	  */
	  this.getAdminCompaniesMeSchools = function () {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = {};
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.adminCompaniesMeSchoolsGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            location.reload();
	            return reject(Const.SSAPP_HAS_REFRESH_OK);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    ADMIN SCHOOL COURSES  / GET
	  */
	  this.getAdminSchoolsSchoolIdCourses = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.adminSchoolsSchoolIdCoursesGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            location.reload();
	            return reject(Const.SSAPP_HAS_REFRESH_OK);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    ADMIN SCHOOL MEMBERS  / GET
	  */
	  this.getAdminSchoolsSchoolIdMembers = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.adminSchoolsSchoolIdMembersGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            location.reload();
	            return reject(Const.SSAPP_HAS_REFRESH_OK);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    ADMIN SCHOOL STAFFS  / GET
	  */
	  this.getAdminSchoolsSchoolIdStaffs = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.adminSchoolsSchoolIdStaffsGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            location.reload();
	            return reject(Const.SSAPP_HAS_REFRESH_OK);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBERS ME / GET
	  */
	  this.getMembersMe = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.membersMeGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            location.reload();
	            return reject(Const.SSAPP_HAS_REFRESH_OK);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBERS ME / PUT
	  */
	  this.putMembersMe = function (bodies) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = {};
	      var body = bodies;
	      var additionalParams = {};
	
	      apigClient.membersMePut(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.membersMePut, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBERS ME MESSAGES
	  */
	  this.getMembersMeMessages = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.membersMeMessagesGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            location.reload();
	            return reject(Const.SSAPP_HAS_REFRESH_OK);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBERS ME LESSONS
	  */
	  this.getMembersMeLessons = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.membersMeLessonsGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            location.reload();
	            return reject(Const.SSAPP_HAS_REFRESH_OK);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBERS ME SHOTS
	  */
	  this.getMembersMeShots = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.membersMeShotsGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.membersMeShotsGet, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBERS ME COURSE LESSONS
	  */
	  this.getMembersMeCoursesCourseIdLessons = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.membersMeCoursesCourseIdLessonsGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            location.reload();
	            return reject(Const.SSAPP_HAS_REFRESH_OK);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    STAFFS ME
	  */
	  this.getStaffsMe = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.staffsMeGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            location.reload();
	            return reject(Const.SSAPP_HAS_REFRESH_OK);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBER
	  */
	  this.getMembersMemberId = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.membersMemberIdGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            location.reload();
	            return reject(Const.SSAPP_HAS_REFRESH_OK);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBER MESSAGES / GET
	  */
	  this.getMembersMemberIdMessages = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.membersMemberIdMessagesGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            location.reload();
	            return reject(Const.SSAPP_HAS_REFRESH_OK);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBER MESSAGES / POST
	  */
	  this.postMembersMemberIdMessages = function (params, bodies) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = bodies;
	      var additionalParams = {};
	
	      apigClient.membersMemberIdMessagesPost(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.membersMemberIdMessagesPost, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBER MESSAGES / PUT
	  */
	  this.putMembersMemberIdMessages = function (params, bodies) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = bodies;
	      var additionalParams = {};
	
	      apigClient.membersMemberIdMessagesPut(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.membersMemberIdMessagesPut, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBER LESSONS
	  */
	  this.getMembersMemberIdLessons = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.membersMemberIdLessonsGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            location.reload();
	            return reject(Const.SSAPP_HAS_REFRESH_OK);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBER SHOTS
	  */
	  this.getMembersMemberIdShots = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.membersMemberIdShotsGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.membersMemberIdShotsGet, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    STAFF ME COURSES
	  */
	  this.getStaffsMeCourses = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.staffsMeCoursesGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            location.reload();
	            return reject(Const.SSAPP_HAS_REFRESH_OK);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    COURSE MEMBERS
	  */
	  this.getCoursesCourseIdMembers = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.coursesCourseIdMembersGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            location.reload();
	            return reject(Const.SSAPP_HAS_REFRESH_OK);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBER COURSE LESSONS
	  */
	  this.getMembersMemberIdCoursesCourseIdLessons = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.membersMemberIdCoursesCourseIdLessonsGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            location.reload();
	            return reject(Const.SSAPP_HAS_REFRESH_OK);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBER FEEDBACKSHEET / GET
	  */
	  this.getMembersMemberIdFeedbackSheet = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.membersMemberIdFeedbackSheetGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            location.reload();
	            return reject(Const.SSAPP_HAS_REFRESH_OK);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    COMPANY ADMIN SCHOOL ADMIN PASSWORD RESET / POST
	  */
	  this.postAdminCompaniesMeSchoolsSchoolIdAdminPasswordReset = function (params, bodies) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = bodies;
	      var additionalParams = {};
	
	      apigClient.adminCompaniesMeSchoolsSchoolIdAdminPasswordResetPost(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.adminCompaniesMeSchoolsSchoolIdAdminPasswordResetPost, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    SCHOOL ADMIN STAFF PASSWORD RESET / POST
	  */
	  this.postAdminSchoolsSchoolIdStaffsStaffIdPasswordReset = function (params, bodies) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = bodies;
	      var additionalParams = {};
	
	      apigClient.adminSchoolsSchoolIdStaffsStaffIdPasswordResetPost(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.adminSchoolsSchoolIdStaffsStaffIdPasswordResetPost, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    SCHOOL ADMIN MEMBER PASSWORD RESET / POST
	  */
	  this.postAdminSchoolsSchoolIdMembersMemberIdPasswordReset = function (params, bodies) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = bodies;
	      var additionalParams = {};
	
	      apigClient.adminSchoolsSchoolIdMembersMemberIdPasswordResetPost(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.adminSchoolsSchoolIdMembersMemberIdPasswordResetPost, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBER PASSWORD RESET / POST
	  */
	  this.postMembersPasswordReset = function (bodies) {
	    return new _promise2.default(function (resolve, reject) {
	      // 認証情報無しで呼び出し
	      var apigClient = apigClientFactory.newClient();
	
	      var param = {};
	      var body = bodies;
	      var additionalParams = {};
	
	      apigClient.membersPasswordResetPost(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          return reject('API call failed.');
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBER VIDEO / POST
	  */
	  this.postMembersVideos = function (params, bodies) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = bodies;
	      var additionalParams = {};
	
	      apigClient.membersMemberIdVideosPost(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.membersMemberIdVideosPost, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  this.postMembersVideosByVideoId = function (params, bodies) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = bodies;
	      var additionalParams = {};
	
	      apigClient.membersMemberIdVideosPostByVideoId(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.membersMemberIdVideosPost, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBER VIDEOS / GET
	  */
	  this.getMembersMemberIdVideos = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.membersMemberIdVideosGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            location.reload();
	            return reject(Const.SSAPP_HAS_REFRESH_OK);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    ME VIDEO / GET
	  */
	  this.getMembersMeVideos = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.membersMeVideosGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            location.reload();
	            return reject(Const.SSAPP_HAS_REFRESH_OK);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBER VIDEO / PUT
	  */
	  this.putVideosVideoId = function (params, bodies) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = bodies;
	      var additionalParams = {};
	
	      apigClient.videosVideoIdPut(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.videosVideoIdPut, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBER VIDEO / DELETE
	  */
	  this.deleteVideosVideoId = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.videosVideoIdDelete(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.videosVideoIdDelete, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    MEMBER VIDEO / GET
	  */
	  this.getVideosVideoId = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.videosVideoIdGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.videosVideoIdGet, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    SCHOOL VIDEOS / POST
	  */
	  this.postSchoolsSchoolIdVideos = function (params, bodies) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = bodies;
	      var additionalParams = {};
	
	      apigClient.schoolsSchoolIdVideosPost(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.schoolsSchoolIdVideosPostRequest, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    SCHOOL VIDEOS / GET
	  */
	  this.getSchoolsSchoolIdVideos = function (params, bodies) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = bodies;
	      var additionalParams = {};
	
	      apigClient.schoolsSchoolIdVideosGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.schoolsSchoolIdVideosGetRequest, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	  /*
	    SCHOOL VIDEOS SUMMARY
	  */
	  this.getSchoolsSchoolIdVideosSummary = function (params, bodies) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = bodies;
	      var additionalParams = {};
	
	      apigClient.schoolsSchoolIdVideosSummaryGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.schoolsSchoolIdVideosSummaryGetRequest, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    SCHOOL VIDEOS BACKLOG
	  */
	  this.getSchoolsSchoolIdMembersVideosBacklogsMembers = function (params, bodies) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = bodies;
	      var additionalParams = {};
	
	      apigClient.schoolsSchoolIdMembersVideosBacklogsMembersGet(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.schoolsSchoolIdMembersVideosBacklogsMembersGetRequest, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	
	  /*
	    NOTIFICATIONS VIDEOS / DELETE
	  */
	  this.deleteNotificationsVideosVideoId = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.notificationsVideosVideoIdDelete(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.videosVideoIdDelete, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	  /*
	    NOTIFICATIONS VIDEOS / POST
	  */
	  this.postNotificationsVideosVideoId = function (params) {
	    return new _promise2.default(function (resolve, reject) {
	      // AccessKey and Token Check!
	      if (!checkKeyToken()) {
	        return reject('Please authenticate.');
	      }
	      // apiGatewayから取得したSDKを生成
	      var apigClient = createApigClient();
	
	      var param = params;
	      var body = {};
	      var additionalParams = {};
	
	      apigClient.notificationsVideosVideoIdPost(param, body, additionalParams).then(function (result) {
	        return resolve(result.data);
	      }).catch(function (result) {
	        if (!navigator.onLine) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
	          return reject((0, _stringify2.default)(result));
	        } else if (result.response && result.response.status === 503) {
	          commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
	          return reject(result.response);
	        } else if (result.response && result.response.status >= 400) {
	          return reject(result.response);
	        } else {
	          refreshOnCredentials().then(function () {
	            apigClient = createApigClient();
	            return callTargetApiAgain(apigClient.notificationsVideosVideoIdPostRequest, param, body, additionalParams);
	          }).then(function (result) {
	            return resolve(result.data);
	          }).catch(function (error) {
	            // Cognitoのrefreshエラーの場合、undefined
	            if (!error) {
	              console.error('Credentials refresh failed:', error);
	              return reject(error);
	            }
	            return reject(error.response);
	          });
	        }
	      });
	    });
	  };
	  return this;
	}]);

/***/ },

/***/ 292:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _isFinite = __webpack_require__(293);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('myApp').factory('commonFactory', ['$routeParams', '$sessionStorage', '$timeout', 'Const', function ($routeParams, $sessionStorage, $timeout, Const) {
	  var _this = this;
	
	  this.fullSetList = ['abcdefghijklmnopqrstuvwxyz', 'ABCDEFGHIJKLMNOPQRSTUVWXYZ', '0123456789', '^$*.[]{}()?-“!@#%&/,><‘:;|_~`'];
	  this.lowercaseAlphabetList = ['abcdefghijklmnopqrstuvwxyz'];
	  this.numberList = ['0123456789'];
	  /**
	   * 指定されたフラッシュメッセージ用のフラグを指定ミリ秒の間だけtrueにする。
	   */
	  this.flashErrorMessageFlag = function (flagName, msec, transitToLoginBool) {
	    $sessionStorage[flagName] = true;
	    $timeout(function () {
	      $sessionStorage[flagName] = false;
	      if (transitToLoginBool) {
	        if (localStorage.getItem(Const.LSAPP_ROLE) === Const.LSAPP_ROLE_MEMBER) {
	          location.href = '#/member/login';
	        } else {
	          location.href = '#/staff/login';
	        }
	      }
	    }, msec);
	  };
	
	  /*
	     渡された Date の月初日と月末日を返します。
	     ex)
	     beginDateParam : Thu Jan 01 2016 00:00:00 GMT+0900 (JST)
	     endDateParam   : Fri Feb 01 2016 00:00:00 GMT+0900 (JST)
	   */
	  this.getMonthRange = function (date) {
	    var beginDateParam = new Date(date.getFullYear(), date.getMonth());
	    var endDateParam = new Date(date.getFullYear(), date.getMonth() + 1);
	    return {
	      endDateParam: endDateParam.toISOString(),
	      beginDateParam: beginDateParam.toISOString()
	    };
	  };
	
	  this.getThreeMonthsBeforeAndAfter = function (date) {
	    var beginDateParam = new Date(date.getFullYear(), date.getMonth() - 3);
	    var endDateParam = new Date(date.getFullYear(), date.getMonth() + 3);
	    return {
	      endDateParam: endDateParam.toISOString(),
	      beginDateParam: beginDateParam.toISOString()
	    };
	  };
	
	  /*
	     渡された Date からひと月先を返す
	  */
	  this.getMonthLater = function (date) {
	    var beginDateParam = new Date(date.getFullYear(), date.getMonth() + 1);
	    var endDateParam = new Date(date.getFullYear(), date.getMonth() + 2);
	    return {
	      endDateParam: endDateParam.toISOString(),
	      beginDateParam: beginDateParam.toISOString()
	    };
	  };
	
	  /*
	     渡された Date からひと月前に戻す
	  */
	  this.getMonthAgo = function (date) {
	    var beginDateParam = new Date(date.getFullYear(), date.getMonth() - 1);
	    var endDateParam = new Date(date.getFullYear(), date.getMonth());
	    return {
	      endDateParam: endDateParam.toISOString(),
	      beginDateParam: beginDateParam.toISOString()
	    };
	  };
	
	  /*
	     アルファベット小文字4文字、数字4桁のパスワードを生成
	  */
	  this.createImterimPassword = function () {
	    var lowercase = _this.generatePassword(4, _this.lowercaseAlphabetList);
	    var number = _this.generatePassword(4, _this.numberList);
	    return lowercase + number;
	  };
	
	  /*
	     ポリシーに準拠したパスワードを自動生成
	     第一引数が数値ではない、または4より小さいの場合は、4文字のパスワードが返却される
	     第二引数であるリスト内から最低一文字以上採用して、ポリシーに準拠させる
	      [
	      "abcdefghijklmnopqrstuvwxyz",
	      "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
	      "0123456789"
	     ]
	      上記の場合、半角英字(大文字/小文字)、半角数字の中から一文字以上採用して、
	     パスワードを作成する
	     記号をポリシーに含めたい場合、"=~|{}_?+*`@`"などを配列に含めれば良い
	      返却値の例:
	       commonFactory.generatePassword(3) => hI94hDQG
	       commonFactory.generatePassword(4) => n4vZQbfn
	       commonFactory.generatePassword(5) => Vaq7M
	       commonFactory.generatePassword('5') => z70y69Fl
	       commonFactory.generatePassword(8) => GN47RQat
	       commonFactory.generatePassword('w') => 3qYmC9SC
	       commonFactory.generatePassword('0012') => vQ0k0ZVy
	   */
	  this.generatePassword = function (count, list) {
	    if (!(0, _isFinite2.default)(count) || count < 4) {
	      count = 4;
	    }
	    var c = function c(xs) {
	      return xs[Math.floor(Math.random() * xs.length)];
	    };
	    var f = function f(n, ws) {
	      var i = ws.length;
	      var l = ws.length;
	      var w = [];
	      var r = [];
	
	      for (i = 0; i < l; i++) {
	        r.push(c(ws[i]));
	      }
	      w = String.prototype.concat.apply('', ws);
	      for (; i < n; i++) {
	        r.push(c(w));
	      }
	      for (; i >= 0; i--) {
	        var j = Math.floor(Math.random() * n);
	        var t = r[i];
	        r[i] = r[j];
	        r[j] = t;
	      }
	      return r.join('');
	    };
	    return f(count, list);
	  };
	
	  /*
	     渡された数値を、渡された桁数になるまで0埋め(左埋め)した値を返却する。
	     第一引数、第二引数ともが数値ではない場合、第一引数をそのまま返却する。
	     第二引数が21桁以上の場合も、第一引数をそのまま返却する。
	   */
	  this.getPaddingZero = function (num, count) {
	    var maxLength = 21;
	    if (!num) {
	      num = 0;
	    }
	    if (!(0, _isFinite2.default)(parseInt(num)) || !(0, _isFinite2.default)(count)) {
	      return num;
	    }
	    if (count >= maxLength) {
	      return num;
	    }
	    return ('00000000000000000000' + num).slice(count * -1);
	  };
	
	  /*
	     渡された数値を、渡された桁数になるまで0埋め(左埋め)した値を返却する。
	     第一引数、第二引数ともが数値ではない場合、第一引数をそのまま返却する。
	     第二引数が21桁以上の場合も、第一引数をそのまま返却する。
	   */
	  this.getGenderName = function (genderNum) {
	    if (!(0, _isFinite2.default)(genderNum)) {
	      return genderNum;
	    }
	    var genderName = void 0;
	    switch (genderNum) {
	      case Const.GENDER_TYPE.male:
	        genderName = '男';
	        break;
	      case Const.GENDER_TYPE.female:
	        genderName = '女';
	        break;
	      default:
	        genderName = '-';
	    }
	    return genderName;
	  };
	
	  // Local Storageに保存したものを削除する
	  this.deleteLocalStorage = function () {
	    if (localStorage.getItem(Const.LSKEY_USER_ID)) {
	      localStorage.removeItem(Const.LSKEY_USER_ID);
	    }
	    if (localStorage.getItem(Const.LSKEY_USER_ID_TOKEN)) {
	      localStorage.removeItem(Const.LSKEY_USER_ID_TOKEN);
	    }
	    if (localStorage.getItem(Const.LSKEY_USER_ACCESS_KEY_ID)) {
	      localStorage.removeItem(Const.LSKEY_USER_ACCESS_KEY_ID);
	    }
	    if (localStorage.getItem(Const.LSKEY_USER_SECRET_ACCESS_KEY)) {
	      localStorage.removeItem(Const.LSKEY_USER_SECRET_ACCESS_KEY);
	    }
	    if (localStorage.getItem(Const.LSKEY_USER_SESSION_TOKEN)) {
	      localStorage.removeItem(Const.LSKEY_USER_SESSION_TOKEN);
	    }
	    if (localStorage.getItem(Const.LSKEY_USER_REFRESH_TOKEN)) {
	      localStorage.removeItem(Const.LSKEY_USER_REFRESH_TOKEN);
	    }
	    if (localStorage.getItem(Const.LSKEY_USER_ACCESS_TOKEN)) {
	      localStorage.removeItem(Const.LSKEY_USER_ACCESS_TOKEN);
	    }
	    if (localStorage.getItem(Const.LSAPP_SCHOOL_NAME)) {
	      localStorage.removeItem(Const.LSAPP_SCHOOL_NAME);
	    }
	    if (localStorage.getItem(Const.LSAPP_SCHOOL_ID)) {
	      localStorage.removeItem(Const.LSAPP_SCHOOL_ID);
	    }
	    if (localStorage.getItem(Const.LSAPP_MEMBER_NAME)) {
	      localStorage.removeItem(Const.LSAPP_MEMBER_NAME);
	    }
	    if (localStorage.getItem(Const.LSAPP_MEMBER_ID)) {
	      localStorage.removeItem(Const.LSAPP_MEMBER_ID);
	    }
	    if (localStorage.getItem(Const.LSAPP_DISP_MEMBER_ID)) {
	      localStorage.removeItem(Const.LSAPP_DISP_MEMBER_ID);
	    }
	    if (localStorage.getItem(Const.LSAPP_ROLE)) {
	      localStorage.removeItem(Const.LSAPP_ROLE);
	    }
	
	    // Cognitoに関するlocalStorageを削除
	    for (var key in localStorage) {
	      if (/CognitoIdentityServiceProvider/.test(key) || /aws.cognito/.test(key)) {
	        localStorage.removeItem(key);
	      }
	    }
	  };
	
	  // Session Storageに保存したものを削除する
	  this.deleteSessionStorage = function () {
	    if ($sessionStorage[Const.LSAPP_ROLE]) {
	      delete $sessionStorage[Const.LSAPP_ROLE];
	    }
	    if ($sessionStorage[Const.SSAPP_SCHOOL_NAME]) {
	      delete $sessionStorage[Const.SSAPP_SCHOOL_NAME];
	    }
	    if ($sessionStorage[Const.SSAPP_COACH_NAME]) {
	      delete $sessionStorage[Const.SSAPP_COACH_NAME];
	    }
	    if ($sessionStorage[Const.SSAPP_COACH_GENDER] !== null) {
	      delete $sessionStorage[Const.SSAPP_COACH_GENDER];
	    }
	    if ($sessionStorage[Const.SSAPP_USER_NAME]) {
	      delete $sessionStorage[Const.SSAPP_USER_NAME];
	    }
	    if ($sessionStorage[Const.SSAPP_GENDER] !== null) {
	      delete $sessionStorage[Const.SSAPP_GENDER];
	    }
	    if ($sessionStorage[Const.SSAPP_COMPANY_ID]) {
	      delete $sessionStorage[Const.SSAPP_COMPANY_ID];
	    }
	    if ($sessionStorage[Const.SSAPP_SCHOOL_ID]) {
	      delete $sessionStorage[Const.SSAPP_SCHOOL_ID];
	    }
	    if ($sessionStorage[Const.SSAPP_COURSE_ID]) {
	      delete $sessionStorage[Const.SSAPP_COURSE_ID];
	    }
	    if ($sessionStorage[Const.SSAPP_MEMBER_ID]) {
	      delete $sessionStorage[Const.SSAPP_MEMBER_ID];
	    }
	    if ($sessionStorage[Const.SSAPP_SELECTED_YEAR_MONTH]) {
	      delete $sessionStorage[Const.SSAPP_SELECTED_YEAR_MONTH];
	    }
	    if ($sessionStorage[Const.SSAPP_LESSON_BEGIN_DATE]) {
	      delete $sessionStorage[Const.SSAPP_LESSON_BEGIN_DATE];
	    }
	    if ($sessionStorage[Const.SSAPP_LESSON_END_DATE]) {
	      delete $sessionStorage[Const.SSAPP_LESSON_END_DATE];
	    }
	    if ($sessionStorage[Const.SSAPP_LESSON_NAME]) {
	      delete $sessionStorage[Const.SSAPP_LESSON_NAME];
	    }
	    if ($sessionStorage[Const.SSAPP_LESSON_DATE]) {
	      delete $sessionStorage[Const.SSAPP_LESSON_DATE];
	    }
	    if ($sessionStorage[Const.SSAPP_LESSON_DAY]) {
	      delete $sessionStorage[Const.SSAPP_LESSON_DAY];
	    }
	    if ($sessionStorage[Const.SSAPP_LESSON_BEGIN_TIME]) {
	      delete $sessionStorage[Const.SSAPP_LESSON_BEGIN_TIME];
	    }
	    if ($sessionStorage[Const.SSAPP_LESSON_END_TIME]) {
	      delete $sessionStorage[Const.SSAPP_LESSON_END_TIME];
	    }
	    if ($sessionStorage[Const.SSAPP_DISP_LESSON_INDEX] !== null) {
	      delete $sessionStorage[Const.SSAPP_DISP_LESSON_INDEX];
	    }
	    if ($sessionStorage[Const.SSAPP_DISP_LESSON_LIST]) {
	      delete $sessionStorage[Const.SSAPP_DISP_LESSON_LIST];
	    }
	    if ($sessionStorage[Const.SSAPP_TARGET_LESSON_INDEX] !== null) {
	      delete $sessionStorage[Const.SSAPP_TARGET_LESSON_INDEX];
	    }
	    if ($sessionStorage[Const.SSAPP_TARGET_LESSON_LIST]) {
	      delete $sessionStorage[Const.SSAPP_TARGET_LESSON_LIST];
	    }
	    if ($sessionStorage[Const.SSAPP_COURSE_INDEX] !== null) {
	      delete $sessionStorage[Const.SSAPP_COURSE_INDEX];
	    }
	    if ($sessionStorage[Const.SSAPP_COURSE_LIST]) {
	      delete $sessionStorage[Const.SSAPP_COURSE_LIST];
	    }
	    if ($sessionStorage[Const.SSAPP_SENSOR_RENTAL] !== null) {
	      delete $sessionStorage[Const.SSAPP_SENSOR_RENTAL];
	    }
	    if ($sessionStorage[Const.SSAPP_EULA_AGREE] !== null) {
	      delete $sessionStorage[Const.SSAPP_EULA_AGREE];
	    }
	    if ($sessionStorage[Const.SSAPP_SMALL_HEIGHT]) {
	      delete $sessionStorage[Const.SSAPP_SMALL_HEIGHT];
	    }
	    if ($sessionStorage[Const.SSAPP_IS_LOADING] !== null) {
	      delete $sessionStorage[Const.SSAPP_IS_LOADING];
	    }
	    if ($sessionStorage[Const.SSAPP_LESSON_COACH_NAME] !== null) {
	      delete $sessionStorage[Const.SSAPP_LESSON_COACH_NAME];
	    }
	    if ($sessionStorage[Const.SSAPP_LESSON_SUB_COACH_NAME] !== null) {
	      delete $sessionStorage[Const.SSAPP_LESSON_SUB_COACH_NAME];
	    }
	    if ($sessionStorage[Const.SSAPP_HEATMAP_FLG] !== null) {
	      delete $sessionStorage[Const.SSAPP_HEATMAP_FLG];
	    }
	    if ($sessionStorage[Const.SSAPP_SHOT_KIND] !== null) {
	      delete $sessionStorage[Const.SSAPP_SHOT_KIND];
	    }
	    if ($sessionStorage[Const.SSAPP_RENDER_FIN] !== null) {
	      delete $sessionStorage[Const.SSAPP_RENDER_FIN];
	    }
	    if ($sessionStorage[Const.SSAPP_SELECTED_DATE] !== null) {
	      delete $sessionStorage[Const.SSAPP_SELECTED_DATE];
	    }
	    if ($sessionStorage[Const.SSAPP_MOVE_VIDEO_TO_MEMBER_COMPLETE] !== null) {
	      delete $sessionStorage[Const.SSAPP_MOVE_VIDEO_TO_MEMBER_COMPLETE];
	    }
	    if ($sessionStorage[Const.SSAPP_MOVE_VIDEO_TO_GUEST_COMPLETE] !== null) {
	      delete $sessionStorage[Const.SSAPP_MOVE_VIDEO_TO_GUEST_COMPLETE];
	    }
	    if ($sessionStorage[Const.SSAPP_ADMIN_COURSE_LIST_LOCATION] !== null) {
	      delete $sessionStorage[Const.SSAPP_ADMIN_COURSE_LIST_LOCATION];
	    }
	    if ($sessionStorage[Const.SSAPP_VIDEO_ID_MOVE_TO_MEMBER] !== null) {
	      delete $sessionStorage[Const.SSAPP_VIDEO_ID_MOVE_TO_MEMBER];
	    }
	    if ($sessionStorage[Const.SSAPP_MEMBER_ID_MOVE_TO_MEMBER] !== null) {
	      delete $sessionStorage[Const.SSAPP_MEMBER_ID_MOVE_TO_MEMBER];
	    }
	    if ($sessionStorage[Const.SSAPP_PUBLIC_VIDEO_COMPLETE] !== null) {
	      delete $sessionStorage[Const.SSAPP_PUBLIC_VIDEO_COMPLETE];
	    }
	    if ($sessionStorage[Const.SSAPP_PRIVATE_VIDEO_COMPLETE] !== null) {
	      delete $sessionStorage[Const.SSAPP_PRIVATE_VIDEO_COMPLETE];
	    }
	    if ($sessionStorage[Const.SSAPP_PREVIEW_VIDEO_ON_COMPLETE] !== null) {
	      delete $sessionStorage[Const.SSAPP_PREVIEW_VIDEO_ON_COMPLETE];
	    }
	    if ($sessionStorage[Const.SSAPP_PREVIEW_VIDEO_OFF_COMPLETE] !== null) {
	      delete $sessionStorage[Const.SSAPP_PREVIEW_VIDEO_OFF_COMPLETE];
	    }
	  };
	
	  // 画面遷移時にエラーフラグが立っていた場合は落とす
	  this.deleteErrorFlg = function () {
	    if ($sessionStorage[Const.SSAPP_HAS_NETWORK_ERROR] !== null) {
	      delete $sessionStorage[Const.SSAPP_HAS_NETWORK_ERROR];
	    }
	    if ($sessionStorage[Const.SSAPP_HAS_REFRESH_OK] !== null) {
	      delete $sessionStorage[Const.SSAPP_HAS_REFRESH_OK];
	    }
	    if ($sessionStorage[Const.SSAPP_HAS_REFRESH_ERROR] !== null) {
	      delete $sessionStorage[Const.SSAPP_HAS_REFRESH_ERROR];
	    }
	    if ($sessionStorage[Const.SSAPP_HAS_UNEXPECTED_ERROR] !== null) {
	      delete $sessionStorage[Const.SSAPP_HAS_UNEXPECTED_ERROR];
	    }
	    if ($sessionStorage[Const.SSAPP_HAS_MAINTENANCE_ERROR] !== null) {
	      delete $sessionStorage[Const.SSAPP_HAS_MAINTENANCE_ERROR];
	    }
	    if ($sessionStorage[Const.SSAPP_IS_LOADING] !== null) {
	      delete $sessionStorage[Const.SSAPP_IS_LOADING];
	    }
	  };
	
	  /*
	     禁則文字チェックを行う
	     true  : 禁則文字を含む
	     false : 禁則文字を含まない
	   */
	  this.isProhibitionChars = function (chars) {
	    var f = function f(char) {
	      var notProhibitionChars = ['abcdefghijklmnopqrstuvwxyz', 'ABCDEFGHIJKLMNOPQRSTUVWXYZ', '0123456789', '^$*.[]{}()?-“!@#%&/,><‘:;|_~`'];
	      var chars = notProhibitionChars.join('');
	      if (~chars.indexOf(char)) {
	        return false;
	      }
	      return true;
	    };
	    for (var i = 0; i < chars.length; i += 1) {
	      if (f(chars.charAt(i))) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  /*
	     パスワードポリシーチェックを行う
	     true  : ポリシーに従っている
	     false : ポリシーに従っていない
	   */
	  this.isPasswordPolicy = function (chars) {
	    var chk = { lower: false, upper: false, num: false, symbol: false };
	    var notProhibitionChars = _this.fullSetList;
	    for (var i = 0; i < chars.length; i += 1) {
	      for (var v in notProhibitionChars) {
	        if (notProhibitionChars[v].indexOf(chars.charAt(i)) < 0) {
	          continue;
	        }
	        switch (v) {
	          case '0':
	            chk['lower'] = true;
	            break;
	          case '1':
	            chk['upper'] = true;
	            break;
	          case '2':
	            chk['num'] = true;
	            break;
	          case '3':
	            chk['symbol'] = true;
	            break;
	          default:
	          // 処理なし
	        }
	        // パスワードポリシーの強弱を変えたい場合は、以下の分岐部分で強弱をつける
	        // ex): chk['lower'] && chk['upper'] && chk['num'] && chk['symbol']
	        //      => アルファベット大文字小文字、数値、記号を含む
	        // ex): chk['lower'] && chk['num']
	        //      => アルファベット小文字、数値を含む(アルファベット大文字、記号は任意)
	        if (chk['lower'] && chk['num']) {
	          return true;
	        }
	      }
	    }
	    return false;
	  };
	
	  this.setStorage = function (key, value) {
	    localStorage.setItem(key, value);
	    $sessionStorage[key] = value;
	  };
	
	  // プログレスバー 表示
	  this.overlayShow = function () {
	    $sessionStorage[Const.SSAPP_IS_LOADING] = true;
	  };
	
	  // プログレスバー 非表示
	  this.overlayHidden = function () {
	    $sessionStorage[Const.SSAPP_IS_LOADING] = false;
	  };
	
	  return this;
	}]);

/***/ },

/***/ 296:
/***/ function(module, exports, __webpack_require__) {

	/*global d3 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SVG_HEIGHT = 50;
	var SVG_WIDTH = 640;
	var SVG_LEFT_PAD = 80;
	var SVG_RIGHT_PAD = 80;
	var SVG_PROGRESS_WIDTH = SVG_WIDTH - SVG_LEFT_PAD - SVG_RIGHT_PAD;
	
	var TennisShotDataView = function () {
	  function TennisShotDataView(videoid, impactPoints, swingTypes) {
	    (0, _classCallCheck3.default)(this, TennisShotDataView);
	
	    this.shots = [];
	    this.creationTime = '';
	    this.videoDuration = 0;
	    this.videoStartTime = '';
	    this.drawingShotIndex = -1;
	    this.drawingShotTime = 0;
	    this.videoid = videoid;
	    this.impactPoints = impactPoints;
	    this.swingTypes = swingTypes;
	
	    this.videoImpactPointMapper = this.createVideoMap();
	
	    var svg = d3.select(videoid).select('#shotracket').append('svg').attr('preserveAspectRatio', 'xMinYMin meet')
	    // このSVG要素全体の枠、のサイズこれに対する比率で描画すればScaleしても追従する
	    // TBD: ラケット画像の値にしているがあとで玉の当たる位置合わせで微調整必要
	    .attr('viewBox', '0 0 128 114').classed('svg-content', true);
	
	    svg.append('image', 'g').attr('xlink:href', './res/racket.png').attr('width', '100%').attr('height', '100%');
	
	    this.shotsvg = svg.append('g').attr({
	      transform: function transform(d) {
	        return 'translate(' + -10.0 + ',' + -10.0 + ')';
	      }
	    });
	    this.shotsvg.append('circle').attr({
	      'r': function r(d) {
	        return 10;
	      },
	      'fill': function fill(d, i) {
	        return '#eeee00';
	      }
	    });
	
	    svg = d3.select(videoid).select('#shotinfo').append('svg').attr('preserveAspectRatio', 'xMinYMin meet')
	    // このSVG要素全体の枠（元のVideoのサイズで調整したので640=100%にしている）
	    // これに対する比率で描画すればScaleしても追従する
	    .attr('viewBox', '0 0 640 75').classed('svg-content', true);
	    svg.append('rect').attr({
	      'x': 0,
	      'y': 0,
	      'width': '100%',
	      'height': '100%',
	      'fill': 'black',
	      'opacity': 0.5
	    });
	
	    this.swingType = svg.append('text').attr({
	      'x': '120',
	      'y': '12',
	      'font-size': '12',
	      'fill': '#ffffff',
	      'stroke-width': '1'
	    });
	    svg.append('text').attr({
	      'x': '300',
	      'y': '12',
	      'font-size': '12',
	      'fill': '#ffffff',
	      'stroke-width': '1'
	    }).text('ボール回転');
	    this.ballSpin = svg.append('text').attr({
	      'x': '300',
	      'y': '38',
	      'font-size': '24',
	      'fill': '#ffffff',
	      'stroke-width': '1'
	    });
	    svg.append('text').attr({
	      'x': '400',
	      'y': '12',
	      'font-size': '12',
	      'fill': '#ffffff',
	      'stroke-width': '1'
	    }).text('スイング速度');
	    this.swingSpeed = svg.append('text').attr({
	      'x': '410',
	      'y': '38',
	      'font-size': '24',
	      'fill': '#ffffff',
	      'stroke-width': '1'
	    });
	    svg.append('text').attr({
	      'x': '460',
	      'y': '38',
	      'font-size': '12',
	      'fill': '#ffffff',
	      'stroke-width': '1'
	    }).text('km/h');
	    svg.append('text').attr({
	      'x': '500',
	      'y': '12',
	      'font-size': '12',
	      'fill': '#ffffff',
	      'stroke-width': '1'
	    }).text('ボール速度');
	    this.ballSpeed = svg.append('text').attr({
	      'x': '510',
	      'y': '38',
	      'font-size': '24',
	      'fill': '#ffffff',
	      'stroke-width': '1'
	    });
	    svg.append('text').attr({
	      'x': '560',
	      'y': '38',
	      'font-size': '12',
	      'fill': '#ffffff',
	      'stroke-width': '1'
	    }).text('km/h');
	
	    TennisShotDataView.$inject = ['videoid', 'impactPoints', 'swingTypes'];
	  }
	
	  // Implementation ---------------------------------------
	
	
	  (0, _createClass3.default)(TennisShotDataView, [{
	    key: 'appendShots',
	    value: function appendShots(shots, start, end) {
	      if (!shots) {
	        console.error('shot response timing issue');
	      }
	      if (end < shots[0].date || shots[shots.length - 1].date < start) {
	        console.error('video range mismatched');
	        return;
	      }
	
	      var startIndex = -1;
	      var endIndex = -1;
	      for (var i = 0; i < shots.length; i++) {
	        if (start < shots[i].date) {
	          startIndex = i;
	          break;
	        }
	      }
	      for (var j = startIndex; j < shots.length; j++) {
	        if (end < shots[j].date) {
	          endIndex = j;
	          break;
	        }
	        if (j === shots.length - 1) {
	          endIndex = shots.length;
	          break;
	        }
	      }
	      if (startIndex === -1 || endIndex === -1 || endIndex < startIndex) {
	        console.error('video and shot data mismatched');
	        return;
	      }
	      this.videoStartTime = start;
	      this.videoDuration = end - start;
	      this.shots = shots.slice(startIndex, endIndex);
	    }
	  }, {
	    key: 'updateShots',
	    value: function updateShots(time, videoHeight, videoWidth) {
	      if (!this.shots) return;
	      this.updateTimeline(time);
	
	      // 若干描画を速めたいので0.7秒描画判定時刻は先送り
	      time = 0.7 + time;
	
	      // 再生が戻った時は最初のshotから検索
	      if (time * 1000 < this.drawingShotTime) {
	        this.clearShot();
	        this.drawingShotIndex = -1;
	      }
	
	      var end = this.shots.length - 1;
	
	      // Shotのupdateが必要なければ終了
	      if (this.drawingShotIndex === end || time * 1000 < this.shots[this.drawingShotIndex + 1].date - this.videoStartTime) {
	        return;
	      }
	
	      // 該当ショットを検索
	      for (var i = this.drawingShotIndex + 1; i <= end; i++) {
	        if (i === end || time * 1000 < this.shots[i + 1].date - this.videoStartTime) {
	          this.drawingShotIndex = i;
	          this.drawingShotTime = this.shots[i].date - this.videoStartTime;
	          break;
	        }
	      }
	
	      var point = this.shots[this.drawingShotIndex].impact_point;
	      this.updateShot(point);
	    }
	  }, {
	    key: 'updateShot',
	    value: function updateShot(point) {
	      var _this = this;
	
	      this.shotsvg.attr({
	        transform: function transform(d) {
	          return 'translate(' + _this.videoImpactPointMapper[point].x + ',' + _this.videoImpactPointMapper[point].y + ')';
	        }
	      });
	      var spinsigned = this.shots[this.drawingShotIndex].spin > 0 ? '+' : '';
	      this.swingType.text(this.shots[this.drawingShotIndex].swing_type);
	      this.ballSpin.text(spinsigned + this.shots[this.drawingShotIndex].spin);
	      this.ballSpeed.text(this.shots[this.drawingShotIndex].hitball_speed);
	      this.swingSpeed.text(this.shots[this.drawingShotIndex].swing_speed.toFixed(0));
	    }
	  }, {
	    key: 'clearShot',
	    value: function clearShot() {
	      // impact pointの位置を再生前に戻す
	      this.shotsvg.attr({
	        transform: function transform(d) {
	          return 'translate(' + -10 + ',' + -10 + ')';
	        }
	      });
	      // 描画されたショット情報を空文字で更新
	      this.swingType.text('');
	      this.ballSpin.text('');
	      this.ballSpeed.text('');
	      this.swingSpeed.text('');
	    }
	  }, {
	    key: 'createVideoMap',
	    value: function createVideoMap() {
	      var X_OFFSET = 31;
	      var X_SCALE = 11;
	      var Y_OFFSET = 8;
	      var Y_SCALE = 11;
	
	      var array = [];
	      for (var i = 0; i < this.impactPoints.length; i++) {
	        array.push({ x: X_OFFSET + X_SCALE * this.impactPoints[i][0],
	          y: Y_OFFSET + Y_SCALE * this.impactPoints[i][1] });
	      }
	      return array;
	    }
	
	    // shot のタイムラインは8月は表示しないので呼び出されないが、
	    // 実装を残しておく
	
	  }, {
	    key: 'addShotBar',
	    value: function addShotBar() {
	      var svg = d3.select(this.videoid).select('#shotbar').append('svg').attr({
	        width: SVG_WIDTH,
	        height: SVG_HEIGHT
	      });
	
	      svg.append('rect').attr({
	        'x': 0,
	        'y': 0,
	        'width': SVG_WIDTH,
	        'height': 50,
	        'fill': 'black',
	        'opacity': 0.5
	      });
	
	      var that = this;
	      var g = svg.selectAll('g').data(this.shots).enter().append('g').attr({
	        transform: function transform(d) {
	          var tp = 1.0 * (d.date - that.videoStartTime) / that.videoDuration;
	          return 'translate(' + (1.0 * SVG_LEFT_PAD + Math.floor(tp * SVG_PROGRESS_WIDTH)) + ',' + SVG_HEIGHT / 2 + ')';
	        }
	      });
	
	      g.append('circle').attr({
	        'r': function r(d) {
	          return 10;
	        },
	        'fill': function fill(d, i) {
	          var label = that.swingTypes.getLabel(d.swing_id);
	          return that.swingTypes.getColorByLabel(label);
	        }
	      });
	      g.append('text').attr({
	        'text-anchor': 'middle',
	        'dy': '.35em',
	        'fill': 'white'
	      }).text(function (d, i) {
	        return i + 1;
	      });
	
	      svg.append('g').attr({
	        transform: function transform(d) {
	          return 'translate(' + 0.0 + ',' + 0.0 + ')';
	        }
	      }).append('line').attr({
	        'x1': '0',
	        'y1': '0',
	        'x2': '0',
	        'y2': '0',
	        'stroke': '#ffffff'
	      });
	    }
	
	    // こちらも8月のテストマーケではタイムラインは表示しないことになったが
	    // 実装は残しておく
	
	  }, {
	    key: 'updateTimeline',
	    value: function updateTimeline(time) {
	      var line = d3.select(this.videoid).select('#shotbar').select('svg').selectAll('line');
	      if (!line) {
	        console.error('no line found!!');
	      }
	      var percent = 1000.0 * time / this.videoDuration;
	      line.attr({
	        'x1': '' + (1.0 * SVG_LEFT_PAD + Math.floor(percent * SVG_PROGRESS_WIDTH)) + '',
	        'y1': '0',
	        'x2': '' + (1.0 * SVG_LEFT_PAD + Math.floor(percent * SVG_PROGRESS_WIDTH)) + '',
	        'y2': '' + SVG_HEIGHT + '',
	        'stroke': '#ffffff'
	      });
	    }
	  }]);
	  return TennisShotDataView;
	}();
	
	exports.default = TennisShotDataView;

/***/ },

/***/ 297:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(45);
	
	var _angular = __webpack_require__(46);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('myApp').factory('Page', function () {
	  var _title = 'マイカルテ';
	  return {
	    title: function title() {
	      return _title;
	    },
	    setTitle: function setTitle(newTitle) {
	      _title = newTitle;
	    }
	  };
	});

/***/ }

});


// WEBPACK FOOTER //
// app.bundle.js